// Keyed by short, stable kebab-case keys (e.g. "forgot-password-title") rather
// than the literal English string — makes entries easy to find/grep later and
// keeps translations intact if the English copy is later reworded.
export default {
   "forgot-password-title": "هل نسيت كلمة المرور؟",
   "forgot-password-description":
      "أدخل بريدك الإلكتروني أدناه لتلقي رمز التحقق واستعادة كلمة المرور الخاصة بك",
   email: "البريد الإلكتروني",
   cancel: "إلغاء",
   submit: "إرسال",
   "menu-section-stakeholders": "أصحاب المصلحة",
   "menu-section-setup": "الإعداد",
   "menu-section-implementation": "التنفيذ",
   "menu-section-support": "الدعم",
   "menu-item-experts": "الخبراء",
   "menu-item-approvers": "المعتمدون",
   "menu-item-organizations": "المنظمات",
   "menu-item-requests": "الطلبات",
   "menu-item-assessments": "التقييمات",
   "menu-item-modules": "الوحدات",
   "menu-item-targets": "الأهداف",
   "menu-item-workspaces": "مساحات العمل",
   "menu-item-tickets": "التذاكر",
   "menu-section-organization-management": "إدارة المنظمة",
   "menu-section-my-account": "حسابي",
   "menu-item-profile": "الملف الشخصي",
   "menu-item-team": "الفريق",
   "menu-item-help-desk": "مكتب المساعدة",

   name: "الاسم",
   country: "الدولة",
   "phone-number": "رقم الهاتف",
   expertise: "الخبرة",
   "disabled-reason": "سبب التعطيل",
   "not-applicable": "غير متاح",
   export: "تصدير",
   "status-pending": "قيد الانتظار",
   "status-rejected": "مرفوض",
   "status-active": "نشط",
   "status-disabled": "معطل",

   "experts-management-title": "الخبراء",
   "experts-request-tab": "طلبات الخبراء",
   "experts-approved-tab": "الخبراء المعتمدون",
   "experts-deleted-button": "الخبراء المحذوفون",
   "experts-status-deactivated": "معطل",

   "filter-search-label": "عمَّ تبحث؟",
   "search-placeholder": "بحث",
   "search-by-name-placeholder": "البحث بالاسم",
   "search-task-by-name-placeholder": "البحث عن مهمة بالاسم",
   "search-module-by-name-placeholder": "البحث عن وحدة بالاسم",
   "search-workspace-by-name-placeholder": "البحث عن مساحة عمل بالاسم",
   "search-assessment-by-name-placeholder": "البحث عن تقييم بالاسم",
   "search-expert-by-name-placeholder": "البحث عن خبير بالاسم",
   "search-request-by-name-placeholder": "البحث عن طلب باسم المنظمة الطالبة",
   "search-request-by-email-placeholder": "البحث عن طلب ببريد المنظمة الطالبة الإلكتروني",
   "search-request-by-name-or-email-placeholder": "البحث بالاسم أو البريد الإلكتروني",
   "search-invoice-by-name-placeholder": "البحث عن فاتورة بالاسم",
   "search-organization-by-name-placeholder": "البحث عن منظمة بالاسم",
   "filter-by-type-placeholder": "التصفية حسب النوع",
   "filter-by-start-date-placeholder": "التصفية حسب تاريخ البدء",
   "filter-by-end-date-placeholder": "التصفية حسب تاريخ الانتهاء",
   "filter-by-year-placeholder": "التصفية حسب السنة",
   "filter-tasks-by-assigned-member-placeholder": "تصفية المهام حسب العضو المكلف",
   "filter-tasks-by-status-placeholder": "تصفية المهام حسب الحالة",
   "filter-workspace-request-by-status-placeholder": "تصفية طلب مساحة العمل حسب الحالة",
   "filter-workspace-by-country-placeholder": "تصفية مساحات العمل حسب الدولة",
   "filter-experts-by-country-placeholder": "تصفية الخبراء حسب الدولة",
   "filter-by-submission-date-placeholder": "التصفية حسب تاريخ التقديم",
   "filter-by-assessments-placeholder": "التصفية حسب التقييمات",
   "filter-by-assessment-placeholder": "التصفية حسب التقييم",
   "filter-by-workspace-placeholder": "التصفية حسب مساحة العمل",
   "filter-by-score-placeholder": "التصفية حسب النتيجة",
   "filter-by-country-placeholder": "التصفية حسب الدولة",
   "filter-by-operating-countries-placeholder": "التصفية حسب دول التشغيل",
   "filter-by-sectors-placeholder": "التصفية حسب القطاعات",
   "export-organizations-button": "تصدير المنظمات",
   "filter-by-module-placeholder": "التصفية حسب الوحدة",
   "filter-by-round-placeholder": "التصفية حسب الجولة",
   "filter-by-section-placeholder": "التصفية حسب القسم",
   "filter-by-owner-placeholder": "التصفية حسب المالك",
   "search-by-its-name-placeholder": "البحث بالاسم",
   "guided-assessment": "تقييم موجّه",
   "self-assessment": "تقييم ذاتي",
   "clear-all-button": "مسح الكل",
   "filters-button": "الفلاتر",
   workspace: "مساحة العمل",
   assessment: "التقييم",
   score: "النتيجة",
   city: "المدينة",
   "operating-countries": "دول التشغيل",
   sectors: "القطاعات",
   type: "النوع",
   organizations: "المنظمات",
   "select-workspace-placeholder": "اختر مساحة العمل",
   "select-assessment-placeholder": "اختر التقييم",
   "select-score-range-placeholder": "اختر نطاق النتيجة",
   "select-country-placeholder": "اختر الدولة",
   "select-base-city-placeholder": "اختر مدينتك الأساسية",
   "select-sectors-placeholder": "اختر القطاعات",
   "select-type-placeholder": "اختر النوع",

   "toast-oops-title": "عذرًا! حدثت مشكلة!",
   "toast-request-accepted-success-title": "تم قبول الطلب بنجاح!",
   "toast-request-accepted-success-description":
      "تم قبول هذا الطلب بنجاح، وسيتم إشعار المستخدم الطالب بالرد.",
   "toast-request-accept-error-description":
      "واجهنا مشكلة في قبول هذا الطلب، يرجى المحاولة مرة أخرى.",
   "toast-request-rejected-success-title": "تم رفض الطلب بنجاح!",
   "toast-request-rejected-success-description":
      "تم رفض هذا الطلب بنجاح، وسيتم إشعار المستخدم الطالب بالرد.",
   "toast-request-reject-error-description":
      "واجهنا مشكلة في رفض هذا الطلب، يرجى المحاولة مرة أخرى.",
   "toast-requests-accepted-success-title": "تم قبول الطلبات بنجاح!",
   "toast-requests-accepted-success-description":
      "تم قبول الطلبات بنجاح، وسيتم إشعار المستخدمين الطالبين بالرد.",
   "toast-requests-accept-error-description":
      "واجهنا مشكلة في قبول هذه الطلبات، يرجى المحاولة مرة أخرى.",
   "toast-requests-rejected-success-title": "تم رفض الطلبات بنجاح!",
   "toast-requests-rejected-success-description":
      "تم رفض الطلبات بنجاح، وسيتم إشعار المستخدمين الطالبين بالرد.",
   "toast-requests-reject-error-description":
      "واجهنا مشكلة في رفض هذه الطلبات، يرجى المحاولة مرة أخرى.",
   "approve-all-button": "قبول الكل",
   "reject-all-button": "رفض الكل",

   "search-target-placeholder": "البحث عن هدف حسب اسم التقييم أو الوحدة",
   "show-active-rounds-checkbox": "إظهار الجولات النشطة",

   "general-score-column": "النتيجة العامة",
   "submissions-column": "التقديمات",
   "tasks-column": "المهام",
   "areas-complete-text": "مجالات مكتملة",
   "organizations-progress-summary-title": "ملخص تقدم المنظمات",
   "export-progress-summary-button": "تصدير ملخص التقدم",
   "select-module-performance-label": "اختر الوحدة لرؤية أداء المنظمات",
   "all-modules-placeholder": "جميع الوحدات",

   "registration-request-tab": "طلب التسجيل",
   "workspace-request-tab": "طلب مساحة العمل",
   "assessment-request-tab": "طلب التقييم",
   "status-approved": "معتمد",
   "requesting-user-column": "المستخدم الطالب",
   "request-date-column": "تاريخ الطلب",
   "approval-date-column": "تاريخ الموافقة",
   "processed-by-column": "تمت المعالجة بواسطة",
   "workspace-name-column": "اسم مساحة العمل",
   "assessment-name-column": "اسم التقييم",
   "consultant-name-column": "اسم الاستشاري",
   "rejection-date-column": "تاريخ الرفض",
   "accept-request-title": "قبول الطلب",
   "accept-request-button": "قبول الطلب",
   "accept-request-description": "أنت على وشك قبول هذا الطلب. لا يمكن التراجع عن هذا الإجراء.",
   "reject-request": "رفض الطلب",
   "reject-request-description": "أنت على وشك رفض هذا الطلب. لا يمكن التراجع عن هذا الإجراء.",
   "confirm-continue-text": "هل أنت متأكد أنك تريد المتابعة؟",
   "reject-button": "رفض",
   "approve-button": "قبول",
   "organization-request-title": "طلب المنظمة",
   "foundation-label": "تاريخ التأسيس",
   "address-label": "العنوان",
   "organization-sectors-label": "قطاعات المنظمة",
   "organization-type-label": "نوع المنظمة",
   "organization-size-label": "حجم المنظمة",
   "organization-name-label": "اسم المنظمة",
   "organization-description-label": "وصف المنظمة",

   "organization-deleted-success-title": "تم حذف المنظمة بنجاح!",
   "organization-deleted-success-description": "تم حذف هذه المنظمة بنجاح.",
   "organization-delete-error-description": "واجهنا مشكلة في حذف هذه المنظمة، يرجى المحاولة مرة أخرى.",
   "organization-restored-success-title": "تمت استعادة المنظمة بنجاح!",
   "organization-restored-success-description": "تمت استعادة هذه المنظمة بنجاح.",
   "organization-restore-error-description":
      "واجهنا مشكلة في تعطيل هذه المنظمة، يرجى المحاولة مرة أخرى.",
   "organization-restore-failed-error-description":
      "واجهنا مشكلة في استعادة هذه المنظمة، يرجى المحاولة مرة أخرى.",
   "organization-disabled-success-title": "تم تعطيل المنظمة بنجاح!",
   "organization-disabled-success-description": "تم تعطيل هذه المنظمة بنجاح.",
   "disable-organization-title": "تعطيل المنظمة",
   "disable-organization-description-text":
      "أنت على وشك تعطيل هذه المنظمة. سيتم نقلها إلى قائمة المنظمات المعطلة حتى تتم استعادتها.",
   "reason-for-disabling-label": "سبب التعطيل",
   "disable-organization-reason-placeholder": "يرجى إدخال سبب تعطيل هذه المنظمة",
   "disable-button": "تعطيل",
   "restore-organization-title": "استعادة المنظمة",
   "registration-date-column": "تاريخ التسجيل",
   "organization-list-title": "قائمة المنظمات",
   "enroll-organizations-button": "تسجيل في مساحة عمل أخرى",
   "registered-organizations-label": "المنظمات المسجلة",
   "average-score-label": "متوسط النتيجة",
   "registered-as-of-text": "مسجلة منذ",
   "social-networks-title": "الشبكات الاجتماعية",
   "offices-title": "المكاتب",
   "ongoing-projects-label": "المشاريع الجارية",
   "members-label": "الأعضاء",
   "representative-label": "الممثل",
   "representative-name-label": "اسم الممثل",
   "representative-title-label": "منصب الممثل",
   "representative-location-label": "موقع الممثل",
   "representative-phone-label": "هاتف الممثل",
   "representative-skype-label": "سكايب الممثل",
   "representative-email-label": "بريد الممثل الإلكتروني",

   "workspace-required-validation": "مساحة العمل مطلوبة",
   "organizations-enrolled-success-title": "تم تسجيل المنظمات بنجاح!",
   "organizations-enrolled-success-description":
      "تم تسجيل هذه المنظمات بنجاح في مساحة العمل التي حددتها.",
   "organizations-enroll-error-description":
      "واجهنا مشكلة في تسجيل هذه المنظمات، يرجى المحاولة مرة أخرى.",
   "enroll-organization-modal-title": "تسجيل المنظمة في مساحة عمل أخرى",
   "select-workspace-to-enroll-label": "حدد مساحة العمل لتسجيل المنظمات",
   "confirm-button": "تأكيد",
   "delete-button": "حذف",
   "delete-organization-title": "حذف المنظمة",
   "delete-organization-description": "أنت على وشك حذف هذه المنظمة. لا يمكن التراجع عن هذا الإجراء.",

   "update-successful-message": "تم التحديث بنجاح",
   "max-50-symbols-validation": "الحد الأقصى 50 حرفًا",
   "min-3-symbols-validation": "الحد الأدنى 3 أحرف",
   "invalid-email-validation": "بريد إلكتروني غير صالح",
   "required-validation": "مطلوب",
   "edit-organization-details-title": "تعديل تفاصيل المنظمة",
   "project-number-title": "عدد المشاريع",
   "ongoing-project-number-label": "عدد المشاريع الجارية",
   "social-label": "الشبكات الاجتماعية",
   "website-label": "الموقع الإلكتروني",
   "facebook-label": "Facebook",
   "twitter-label": "Twitter",
   "linkedin-label": "Linkedin",
   "instagram-label": "Instagram",
   "back-button": "رجوع",
   "update-button": "تحديث",

   "representative-removed-success-title": "تمت إزالة تفاصيل الممثل بنجاح!",
   "representative-removed-success-description": "تمت إزالة معلومات تفاصيل ممثلكم.",
   "representative-remove-error-description":
      "واجهنا مشكلة في إزالة معلومات تفاصيل الممثل، يرجى المحاولة مرة أخرى.",
   "profile-status-changed-title": "تم تغيير حالة ملفك الشخصي!",
   "profile-status-changed-description": "تم تغيير حالة ملفك الشخصي بنجاح.",
   "profile-status-change-error-description":
      "واجهنا مشكلة في تغيير حالة الملف الشخصي، يرجى المحاولة مرة أخرى.",
   "go-back-to-organizations-link": "العودة إلى المنظمات",
   "print-profile-button": "طباعة الملف الشخصي",
   "make-profile-public-button": "اجعل الملف الشخصي عامًا",
   "make-profile-private-button": "اجعل الملف الشخصي خاصًا",
   "complete-profile-reminder-title": "لا تنسَ إكمال ملفك الشخصي!",
   "complete-profile-reminder-description": "عزز ظهورك داخل المجتمع من خلال إكمال ملفك الشخصي وجعله عامًا.",
   "complete-profile-now-button": "أكمل الملف الشخصي الآن",
   "profile-status-label": "حالة الملف الشخصي",
   "private-status": "خاص",
   "public-status": "عام",
   "organization-email-label": "البريد الإلكتروني للمنظمة",
   "base-country-label": "الدولة الأساسية",
   "zip-code-label": "الرمز البريدي",
   "about-label": "نبذة",
   "foundation-date-label": "تاريخ التأسيس",
   "organizations-size-label": "حجم المنظمات",
   "countries-where-operate-label": "الدول التي تعمل فيها المنظمة",
   "sector-that-works-label": "القطاع الذي تعمل فيه المنظمة",
   "representative-details-title": "تفاصيل الممثل",
   "delete-all-representative-info-button": "حذف كل معلومات الممثل",
   "add-representative-details-button": "إضافة تفاصيل الممثل",
   "no-information-available-text": "لا توجد معلومات متاحة",
   "location-label": "الموقع",
   "edit-representative-details-button": "تعديل تفاصيل الممثل",
   "assessments-scores-title": "نتائج التقييمات",
   "assessments-scores-description": "تحقق من نتائج هذه المنظمة في التقييمات المكتملة.",
   "select-self-assessment-placeholder": "حدد التقييم الذاتي",
   "no-self-assessment-yet-title": "لا يوجد تقييم ذاتي بعد",
   "no-self-assessment-yet-description": "لم تكمل هذه المنظمة تقييمًا ذاتيًا بعد",
   "select-guided-assessment-placeholder": "حدد التقييم الموجه",
   "no-guided-assessment-yet-title": "لا يوجد تقييم موجه بعد",
   "no-guided-assessment-yet-description": "لم تكمل هذه المنظمة تقييمًا موجهًا بعد",
   "team-member-list-title": "قائمة أعضاء الفريق",
   "team-member-list-description":
      "أضف أعضاء فريقك وتعاونوا لتعزيز منظمتكم. هذا القسم مرئي لك فقط. حتى لو كان ملفك الشخصي عامًا، لن يتمكن أي شخص آخر من رؤية الأعضاء الذين تضيفهم.",
   "latest-round-label": "الجولة الأخيرة",
   "size-label": "الحجم",
   "select-number-placeholder": "حدد الرقم",
   "select-date-placeholder": "حدد تاريخًا",

   "profile-updated-success-title": "تم تحديث الملف الشخصي بنجاح!",
   "profile-updated-success-description": "تم تحديث معلومات ملفك الشخصي بشكل صحيح.",
   "profile-update-error-description":
      "واجهنا مشكلة في تحديث معلومات ملفك الشخصي، يرجى المحاولة مرة أخرى.",
   "international-name-required-validation": "الاسم الدولي مطلوب",
   "date-of-establishment-required-validation": "تاريخ التأسيس مطلوب",
   "address-required-validation": "العنوان مطلوب",
   "zip-code-required-validation": "الرمز البريدي مطلوب",
   "email-required-validation": "البريد الإلكتروني مطلوب",
   "invalid-phone-number-validation": "رقم هاتف غير صالح",
   "phone-number-required-validation": "رقم الهاتف مطلوب",
   "at-least-one-sector-required-validation": "مطلوب قطاع واحد على الأقل",
   "organization-size-required-validation": "حجم المنظمة مطلوب",
   "at-least-one-country-required-validation": "مطلوبة دولة واحدة على الأقل",
   "base-country-required-validation": "الدولة الأساسية مطلوبة",
   "city-required-validation": "المدينة مطلوبة",
   "edit-profile-title": "تعديل الملف الشخصي",
   "organization-details-tab": "تفاصيل المنظمة",
   "international-name-placeholder": "الاسم الدولي",
   "description-placeholder": "الوصف",
   "foundation-year-label": "سنة التأسيس",
   "select-organization-size-placeholder": "حدد حجم المنظمة",
   "countries-where-operates-label": "الدول التي تعمل فيها المنظمة",
   "select-operating-countries-placeholder": "حدد الدول التي تعمل فيها",
   "working-sector-label": "قطاع العمل",
   "select-sectors-alt-placeholder": "حدد القطاعات",
   "contact-information-tab": "معلومات الاتصال",
   "organizations-email-label": "البريد الإلكتروني للمنظمة",
   "select-base-country-placeholder": "حدد الدولة الأساسية",
   "select-a-city-placeholder": "حدد مدينة",
   "save-changes-button": "حفظ التغييرات",

   // Profile information page (account profile edit forms)
   "name-label": "الاسم",
   "city-label": "المدينة",
   "birthdate-label": "تاريخ الميلاد",
   "select-your-prefix": "اختر",
   "area-of-expertise-colon-label": "مجال الخبرة:",
   "years-suffix-label": "سنوات",
   "professional-details-title": "التفاصيل المهنية",
   "enter-current-password-placeholder": "أدخل كلمة المرور الحالية",
   "enter-new-password-placeholder": "أدخل كلمة المرور الجديدة",
   "enter-new-password-again-placeholder": "أدخل كلمة المرور الجديدة مرة أخرى",
   "enter-your-email-placeholder": "أدخل بريدك الإلكتروني",

   // Login information page (LoginInfo.js)
   "account-information-label": "معلومات الحساب",
   "email-label": "البريد الإلكتروني",
   "current-password-label": "كلمة المرور الحالية",
   "new-password-label": "كلمة المرور الجديدة",
   "password-hint-intro-text": "لحماية حسابك، يجب أن تحتوي كلمة المرور على الأقل على:",
   "password-hint-length": "8 أحرف على الأقل",
   "password-hint-uppercase": "حرف كبير واحد",
   "password-hint-lowercase": "حرف صغير واحد",
   "password-hint-number": "رقم واحد",
   "password-hint-special": "رمز خاص واحد",
   "change-password-here-text": "يمكنك تغيير كلمة المرور هنا",
   "email-changed-success-title": "تم تغيير البريد الإلكتروني بنجاح!",
   "email-changed-success-description": "تم تحديث بريدك الإلكتروني بشكل صحيح.",
   "email-update-error-description": "حدثت مشكلة أثناء تغيير بريدك الإلكتروني، يرجى المحاولة مرة أخرى.",
   "password-changed-success-title": "تم تغيير كلمة المرور بنجاح!",
   "password-changed-success-description": "تم تحديث كلمة المرور بشكل صحيح.",
   "password-update-error-description": "حدثت مشكلة أثناء تغيير كلمة المرور، يرجى المحاولة مرة أخرى.",
   "current-password-required-validation": "كلمة المرور الحالية مطلوبة",
   "new-password-required-validation": "كلمة المرور الجديدة مطلوبة",
   "confirm-new-password-required-validation": "تأكيد كلمة المرور الجديدة مطلوب",

   // Account management: deactivate/delete account (LoginInfo.js)
   "account-management-title": "إدارة الحساب",
   "deactivate-account-title": "تعطيل الحساب",
   "deactivate-account-description":
      "يمكنك تعطيل حسابك هنا. سيؤدي هذا إلى جعل حسابك غير قابل للاستخدام مؤقتًا. ومع ذلك، فإن هذا الإجراء قابل للعكس بالكامل، و",
   "deactivate-account-explanation": "يمكنك إعادة تفعيل حسابك في أي وقت بمجرد تسجيل الدخول مرة أخرى.",
   "delete-account-title": "حذف الحساب",
   "delete-account-description": "سيؤدي حذف حسابك إلى إزالة جميع بياناتك نهائيًا من نظامنا.",
   "delete-account-explanation":
      "هذا الإجراء لا يمكن التراجع عنه، بمعنى أنه بمجرد حذف حسابك، لن تتمكن من استعادة أي من معلوماتك أو محتواك.",
   "delete-account-explanation-2": "إذا كنت متأكدًا من رغبتك في المتابعة،",
   "delete-account-explanation-3":
      "يرجى العلم أنك ستفقد الوصول إلى جميع الخدمات والبيانات المرتبطة بحسابك.",
   "delete-account-modal-title": "احذف حسابك",
   "deactivate-account-modal-title": "عطّل حسابك",
   "delete-account-modal-description": "يؤسفنا رؤيتك تغادر، لكننا نحترم قرارك!",
   "deactivate-account-modal-description": "تفكر في أخذ استراحة؟ تعطيل حسابك خيار متاح دائمًا.",
   "confirm-account-deletion-title": "تأكيد حذف الحساب",
   "confirm-account-deactivation-title": "تأكيد تعطيل الحساب",
   "confirm-delete-account-description": "أنت على وشك حذف حسابك وبياناتك نهائيًا.",
   "confirm-deactivate-account-description": "أنت على وشك تعطيل حسابك.",
   "confirm-action-other-desc": "هل أنت متأكد أنك تريد المتابعة؟",
   "delete-reason-1": "لم أعد بحاجة إلى الخدمة.",
   "delete-reason-2": "وجدت خدمة أخرى تناسب احتياجاتي بشكل أفضل.",
   "delete-reason-3": "كانت لدي تجربة سيئة.",
   "delete-reason-4": "أشعر بالقلق بشأن خصوصية بياناتي.",
   "deactivate-reason-1": "أحتاج إلى استراحة قصيرة.",
   "deactivate-reason-2": "أنا مشغول جدًا حاليًا لاستخدام المنصة.",
   "deactivate-reason-3": "أتعامل مع أمور شخصية.",
   "deactivate-reason-4": "أريد التركيز على أولويات أخرى في الوقت الحالي.",
   "other-please-specify-label": "أخرى (يرجى التحديد)",
   "enter-your-answer-placeholder": "أدخل إجابتك هنا",
   "delete-account-feedback-prompt": "نود سماع رأيك. هل يمكنك مشاركة سبب تفكيرك في حذف حسابك؟",
   "deactivate-account-feedback-prompt": "نود سماع رأيك. هل يمكنك مشاركة سبب تفكيرك في تعطيل حسابك؟",
   "delete-account-followup-question":
      "شكرًا لك على البقاء معنا. هل هناك أي شيء كان بإمكاننا فعله لتحسين تجربتك؟",
   "deactivate-account-followup-question":
      "نسعى دائمًا للتحسين. إذا كانت لديك أي اقتراحات أو تعليقات، فسنكون سعداء بسماعها",
   "delete-account-error-description": "واجهنا مشكلة في حذف حسابك، يرجى المحاولة مرة أخرى.",
   "deactivate-account-error-description": "واجهنا مشكلة في تعطيل حسابك، يرجى المحاولة مرة أخرى.",

   // Payment information page (PaymentInfo.js, SuccessPaymentInfo.js, FailedPaymentInfo.js)
   "choose-perfect-plan-title": "اختر الخطة المثالية لك",
   "billed-annually-text": "تُفوتر سنويًا",
   "workspaces-suffix-label": "مساحات عمل",
   "members-suffix-label": "أعضاء",
   "data-storage-limit-suffix-label": "حد تخزين البيانات",
   "see-all-plan-details-link": "عرض جميع تفاصيل الخطة",
   "plan-selected-label": "تم اختيار الخطة",
   "select-this-plan-button": "اختر هذه الخطة",
   "view-billing-portal-button": "عرض بوابة الفوترة",
   "checkout-button": "الدفع",
   "active-subscription-error-description": "المستخدم لديه بالفعل اشتراك نشط. يرجى اختيار خطة مختلفة.",
   "payment-billing-error-description": "واجهنا مشكلة في إتمام عملية الدفع، يرجى المحاولة مرة أخرى.",
   "purchase-successful-title": "تمت عملية الشراء بنجاح!",
   "payment-processed-success-text": "تمت معالجة دفعتك بنجاح.",
   "thank-you-for-purchase-text": "شكرًا لك على شرائك!",
   "go-back-to-payment-info-text": "العودة إلى معلومات الدفع",
   "purchase-failed-title": "فشلت عملية الشراء",
   "purchase-failed-description":
      "للأسف، لم تنجح محاولة الشراء الأخيرة. قد تكون هناك مشكلة في معالجة الدفع أو مشكلة في المعلومات المقدمة. يرجى التحقق من تفاصيل الدفع والمحاولة مرة أخرى.",
   "apologize-inconvenience-text": "نعتذر عن الإزعاج ونقدر صبرك.",

   // Profile edit form validation messages (validationSchema.js)
   "min-3-symbols-validation": "الحد الأدنى 3 أحرف",
   "max-50-symbols-validation": "الحد الأقصى 50 حرفًا",
   "invalid-organization-email-validation": "بريد إلكتروني للمنظمة غير صالح",
   "organization-address-required-validation": "عنوان المنظمة مطلوب",
   "operating-countries-required-validation": "الدول التشغيلية مطلوبة",

   // Account deleted/deactivated confirmation page (AccountDeletedORDeactivated.js)
   "account-action-icon-alt": "إجراء الحساب",
   "account-deactivated-notice-text": "تم إلغاء تفعيل حسابك بنجاح بناءً على طلبك.",
   "account-deleted-notice-text": "تم حذف حسابك بنجاح بناءً على طلبك.",
   "positive-experience-farewell-text":
      "نثق بأنك حظيت بتجربة إيجابية معنا، ونود أن تعلم أنك ستكون دائمًا موضع ترحيب للعودة متى اخترت ذلك.",
   "kaporg-best-regards-text": "مع أطيب التحيات، فريق KAPorg.",

   // Edit profile picture modal (EditProfilePicture.js)
   "edit-profile-picture-title": "تعديل صورة الملف الشخصي",
   "change-profile-picture-button": "تغيير صورة الملف الشخصي",
   "delete-profile-picture-button": "حذف صورة الملف الشخصي",
   "profile-picture-updated-success-title": "تم تحديث صورة الملف الشخصي بنجاح!",
   "profile-picture-updated-success-description": "تم تحديث صورة ملفك الشخصي بشكل صحيح.",
   "profile-picture-update-error-description": "واجهنا مشكلة في تحديث صورة ملفك الشخصي، يرجى المحاولة مرة أخرى.",
   "profile-picture-deleted-success-title": "تم حذف صورة الملف الشخصي بنجاح!",
   "profile-picture-deleted-success-description": "تم حذف صورة ملفك الشخصي.",
   "profile-picture-delete-error-description": "واجهنا مشكلة في حذف صورة ملفك الشخصي، يرجى المحاولة مرة أخرى.",

   "name-required-validation": "الاسم مطلوب",
   "gender-required-validation": "الجنس مطلوب",
   "role-required-validation": "الدور مطلوب",
   "team-member-added-success-title": "تمت إضافة عضو الفريق بنجاح!",
   "team-member-added-success-description": "تمت إضافة هذا العضو بنجاح إلى قاعدة بيانات فريقك.",
   "team-member-add-error-description":
      "واجهنا مشكلة في إضافة هذا العضو إلى قاعدة بيانات فريقك، يرجى المحاولة مرة أخرى.",
   "add-new-member-title": "إضافة عضو جديد",
   "gender-label": "الجنس",
   "select-gender-placeholder": "حدد الجنس",
   "role-label": "الدور",
   "select-role-placeholder": "حدد الدور",
   "make-my-profile-public-button": "اجعل ملفي الشخصي عامًا",
   "make-my-profile-private-button": "اجعل ملفي الشخصي خاصًا",
   "make-profile-public-title": "اجعل الملف الشخصي عامًا",
   "make-profile-private-title": "اجعل الملف الشخصي خاصًا",
   "profile-visibility-notice-public":
      "من خلال جعل منظماتك الوطنية عامة، سيتمكن المانحون والخبراء من رؤية معلوماتك ونتائجك. لذلك، نوصي بالتأكد من اكتمال جميع معلوماتك قبل جعلها عامة.",
   "profile-visibility-notice-private":
      "من خلال جعل منظماتك الوطنية خاصة، سيتمكن المانحون والخبراء من رؤية معلوماتك ونتائجك. لذلك، نوصي بالتأكد من اكتمال جميع معلوماتك قبل جعلها خاصة.",
   "delete-member-title": "حذف العضو",
   "delete-member-description": "أنت على وشك حذف هذا العضو. لا يمكن التراجع عن هذا الإجراء.",
   "delete-all-representative-details-title": "حذف جميع تفاصيل الممثل",
   "delete-representative-info-description-1": "أنت على وشك حذف جميع معلومات ممثلك.",
   "delete-representative-info-description-2": "يمكنك إضافتها مرة أخرى لاحقًا إذا رغبت.",
   "delete-representative-info-description-3":
      "تذكر أن اكتمال الملف الشخصي أمر بالغ الأهمية لتحسين الظهور وفرص التواصل داخل المجتمع.",
   "organizations-management-title": "إدارة المنظمات",

   "representative-updated-success-title": "تم تحديث تفاصيل الممثل بنجاح!",
   "representative-updated-success-description": "تم تحديث معلومات تفاصيل ممثلك بشكل صحيح.",
   "representative-update-error-description":
      "واجهنا مشكلة في تحديث معلومات تفاصيل الممثل، يرجى المحاولة مرة أخرى.",
   "edit-representative-detail-title": "تعديل تفاصيل الممثل",
   "full-name-label": "الاسم الكامل",
   "phone-label": "الهاتف",
   "edit-representative-button": "تعديل الممثل",
   "representative-added-success-title": "تمت إضافة تفاصيل الممثل بنجاح!",
   "representative-added-success-description": "تمت إضافة معلومات تفاصيل ممثلك بشكل صحيح.",
   "representative-add-error-description":
      "واجهنا مشكلة في إضافة معلومات تفاصيل الممثل، يرجى المحاولة مرة أخرى.",
   "create-representative-detail-title": "إنشاء تفاصيل ممثل جديد",

   "team-member-removed-success-title": "تمت إزالة عضو الفريق بنجاح!",
   "team-member-removed-success-description": "تمت إزالة هذا العضو بنجاح من قاعدة بيانات فريقك.",
   "team-member-remove-error-description":
      "واجهنا مشكلة في إزالة هذا العضو من قاعدة بيانات فريقك، يرجى المحاولة مرة أخرى.",
   "fullname-column": "الاسم الكامل",
   "member-search-label": "عن أي عضو تبحث؟",
   "search-member-by-name-placeholder": "ابحث عن عضو باسمه",
   "add-member-button": "إضافة عضو",
   "new-member-button": "عضو جديد",
   "birthdate-label": "تاريخ الميلاد",
   "email-field-label": "البريد الإلكتروني",
   "name": "الاسم",
   "email": "البريد الإلكتروني",
   "cancel": "إلغاء",
   "no-assessments-listed-text": "لا توجد تقييمات مدرجة",
   "remaining-months-days-text": "{months} أشهر، {days} أيام",
   "more-actions-label": "مزيد من الإجراءات",
   "sort-ascending-alt": "ترتيب تصاعدي",
   "sort-descending-alt": "ترتيب تنازلي",
   "error-unauthorized-text": "عذرًا، غير مصرح لك بالوصول إلى هذه الصفحة.",
   "error-page-not-found-text": "عذرًا، الصفحة التي زرتها غير موجودة.",
   "error-oops-title": "عفوًا...",
   "back-home-button": "العودة إلى الرئيسية",
   "error-something-wrong-text": "يبدو أن هناك خطأ ما. نحن نعمل على حله",

   "requests-management-title": "إدارة الطلبات",
   "archived-assessments-link": "التقييمات المؤرشفة",
   "deleted-assessments-link": "التقييمات المحذوفة",
   "add-new-assessment-button": "تقييم جديد",
   "assessment-list-title": "التقييمات",
   "archive-button": "أرشفة",
   "archive-assessment-title": "أرشفة التقييم",
   "delete-assessment-title": "حذف التقييم",
   "archive-assessment-description": "أنت على وشك أرشفة هذا التقييم.",
   "delete-assessment-description": "أنت على وشك حذف هذا التقييم.",

   "start-date-after-previous-end-validation": "يجب أن يكون تاريخ البدء أكبر من تاريخ الانتهاء السابق",
   "end-date-after-start-validation": "يجب أن يكون تاريخ الانتهاء أكبر من تاريخ البدء",
   "assessment-name-empty-validation": "لا يمكن أن يكون اسم التقييم فارغًا",
   "submission-round-label-empty-validation": "لا يمكن أن تكون تسمية جولة التقديم فارغة",
   "date-fields-required-validation": "حقول التاريخ مطلوبة",
   "start-date-required-validation": "تاريخ البدء مطلوب",
   "end-date-required-validation": "تاريخ الانتهاء مطلوب",
   "assessment-created-success-title": "تم إنشاء التقييم بنجاح!",
   "assessment-created-success-description": "تم إنشاء تقييم جديد وإضافته إلى قاعدة بياناتك.",
   "assessment-create-error-description": "واجهنا مشكلة في إنشاء هذا التقييم، يرجى المحاولة مرة أخرى.",
   "assessment-details-title": "تفاصيل التقييم",
   "assessment-name-label": "اسم التقييم",
   "enter-assessment-name-placeholder": "أدخل اسم التقييم",
   "assessment-type-label": "نوع التقييم",
   "submission-round-label-field": "تسمية جولة التقديم",
   "enter-submission-round-placeholder": "أدخل جولة التقديم",
   "start-date-label": "تاريخ البدء",
   "end-date-label": "تاريخ الانتهاء",
   "add-new-submission-round-button": "إضافة جولة تقديم جديدة",
   "dynamic-range-label": "النطاق الديناميكي",
   "select-score-range-description": "حدد نطاق متغيرات النتيجة لتقييمك (حتى 5)",
   "score-variables-label": "متغيرات النتيجة",
   "from-label": "من",
   "to-label": "إلى",
   "score-label-field": "تسمية النتيجة",
   "score-description-field": "وصف النتيجة",
   "enter-label-description-placeholder": "أدخل وصفًا للتسمية",
   "add-assessment-button": "إضافة تقييم",
   "assessment-assigned-success-title": "تم تعيين التقييم بنجاح!",
   "assessment-assigned-success-description":
      "تم تعيين هذا التقييم بنجاح لأعضاء فريقك. سيتم إخطارهم بهذا الإجراء.",
   "assessment-assign-error-description":
      "واجهنا مشكلة في تعيين هذا التقييم لأعضاء فريقك، يرجى المحاولة مرة أخرى.",
   "assign-assessment-to-team-title": "تعيين تقييم للفريق",
   "project-management-label": "إدارة المشروع",

   "assessment-updated-success-title": "تم تحديث التقييم بنجاح!",
   "assessment-updated-success-description": "تم تحديث هذا التقييم بشكل صحيح.",
   "assessment-update-error-description": "واجهنا مشكلة في تحديث هذا التقييم، يرجى المحاولة مرة أخرى.",
   "edit-assessment-title": "تعديل التقييم",
   "edit-assessment-of-team-title": "تعديل تقييم هذا الفريق",
   "select-project-management-placeholder": "حدد إدارة المشروع",
   "module-assigned-success-title": "تم تعيين الوحدة بنجاح!",
   "module-assigned-success-description":
      "تم تعيين هذه الوحدة بنجاح لأعضاء فريقك. سيتم إخطارهم بهذا الإجراء.",
   "module-unassigned-success-title": "تم إلغاء تعيين الوحدة بنجاح!",
   "module-unassigned-success-description": "تم إلغاء تعيين هذه الوحدة بنجاح من قبل عضو الفريق.",
   "module-assign-error-description":
      "واجهنا مشكلة في تعيين هذه الوحدة لأعضاء فريقك، يرجى المحاولة مرة أخرى.",
   "assign-module-to-members-title": "تعيين الوحدة للأعضاء",
   "module-name-label": "اسم الوحدة",
   "members-to-assign-label": "الأعضاء المراد تعيين هذه الوحدة لهم",
   "unassign-button": "إلغاء التعيين",
   "assign-module-button": "تعيين الوحدة",
   "member-required-validation": "العضو مطلوب",

   "comparison-created-success-title": "تم إنشاء نسخة مقارنة جديدة!",
   "comparison-created-success-description": "تم إنشاء نسخة المقارنة الجديدة بنجاح وهي جاهزة للمراجعة.",
   "comparison-create-error-description":
      "واجهنا مشكلة في إنشاء نسخة المقارنة هذه، يرجى المحاولة مرة أخرى.",
   "duplicate-for-comparison-title": "تكرار للمقارنة",
   "duplicate-comparison-description-1":
      "سيؤدي هذا إلى إنشاء نسخة من التقييم وربط الإصدارين لمقارنة النتائج.",
   "duplicate-comparison-description-2": "بمجرد التكرار، لا يمكن تعديل التقييمات وأي وحدات مرتبطة بها.",
   "current-assessment-label": "التقييم الحالي",
   "new-comparison-version-label": "نسخة المقارنة الجديدة",
   "comparison-suffix-label": "مقارنة",
   "duplicate-comparison-note":
      "ملاحظة: إذا لزم الأمر، يمكنك إزالة الرابط لاحقًا لتعديلهما بشكل مستقل، لكن المقارنة لن تكون متاحة بعد ذلك.",
   "duplicate-button": "تكرار",
   "assessments-unlinked-success-title": "تم إلغاء ربط التقييمات!",
   "assessments-unlinked-success-description":
      "تم إلغاء ربط التقييمات بنجاح ويمكن الآن تعديلها بشكل مستقل.",
   "assessments-unlink-error-description": "واجهنا مشكلة في إلغاء ربط التقييمات، يرجى المحاولة مرة أخرى.",
   "unlink-assessments-title": "هل تريد إلغاء ربط هذه التقييمات؟",
   "unlink-assessments-description":
      "لن تكون مرتبطة بعد الآن للمقارنة، ولن تكون طريقة عرض المقارنة متاحة بعد الآن.",
   "original-assessment-label": "التقييم الأصلي",
   "duplicated-assessment-label": "التقييم المكرر",
   "unlink-assessments-note": "ملاحظة: بعد إلغاء ربطها، يمكن تعديل كل تقييم بشكل مستقل.",
   "unlink-button": "إلغاء الربط",
   "expert-name-column": "اسم الخبير",
   "years-of-experience-column": "سنوات الخبرة",
   "expert-cv-column": "السيرة الذاتية للخبير",
   "cv-link-text": "رابط السيرة الذاتية",
   "no-cv-available-text": "لا توجد سيرة ذاتية متاحة",
   "areas-of-expertise-column": "مجالات الخبرة",
   "select-expert-request-access-title": "حدد خبيرًا واطلب الوصول",
   "first-choose-expert-subtitle": "أولاً اختر خبيرًا",
   "choose-expert-guide-hint": "اختر خبيرًا لتوجيه تقييمك",
   "request-access-button": "طلب الوصول",
   "go-back-experts-list-link": "العودة إلى قائمة الخبراء",
   "no-description-available-text": "لا يوجد وصف متاح",
   "no-expertise-listed-text": "لا توجد خبرة مدرجة",
   "nationality-label": "الجنسية",
   "no-nationality-listed-text": "لا توجد جنسية مدرجة",
   "country-of-residence-label": "بلد الإقامة",
   "no-country-of-residence-text": "لا يوجد بلد إقامة",
   "no-operating-countries-listed-text": "لا توجد دول تشغيل مدرجة",
   "linkedin-profile-label": "الملف الشخصي على لينكد إن",
   "no-linkedin-profile-text": "لم يتم تقديم ملف تعريف لينكد إن",
   "no-phone-number-listed-text": "لا يوجد رقم هاتف مدرج",
   "highest-degree-label": "أعلى درجة علمية تم الحصول عليها",
   "no-highest-degree-listed-text": "لم يتم إدراج أعلى درجة علمية تم الحصول عليها",
   "fields-of-study-label": "مجالات الدراسة",
   "no-study-fields-listed-text": "لا توجد مجالات دراسة مدرجة",
   "educational-institution-label": "المؤسسة التعليمية",
   "no-educational-institution-listed-text": "لم يتم إدراج مؤسسة تعليمية",
   "languages-label": "اللغات",
   "no-languages-listed-text": "لا توجد لغات مدرجة",
   "cv-label": "السيرة الذاتية",
   "no-cv-listed-text": "لا توجد سيرة ذاتية مدرجة",
   "certification-training-label": "شهادة أو تدريب خاص",
   "no-certification-listed-text": "لم يتم إدراج شهادة أو تدريب خاص",

   "archived-assessments-list-title": "قائمة التقييمات المؤرشفة",
   "deleted-assessments-title": "التقييمات المحذوفة",
   "delete-permanently-button": "حذف نهائيًا",
   "unarchive-assessments-button": "إلغاء أرشفة التقييمات",
   "restore-assessments-button": "استعادة التقييمات",
   "deleted-assessments-description":
      "هنا يمكنك عرض واستعادة التقييمات المحذوفة. أي تقييم لم تتم استعادته خلال 60 يومًا سيتم حذفه نهائيًا.",
   "delete-assessment-permanently-title": "حذف التقييم نهائيًا",
   "delete-assessments-permanently-title": "حذف التقييمات نهائيًا",
   "delete-selected-assessment-permanently-description":
      "أنت على وشك حذف التقييم المحدد نهائيًا.",
   "delete-selected-assessments-permanently-description":
      "أنت على وشك حذف التقييمات المحددة نهائيًا.",
   "action-cannot-be-undone-confirm-text":
      "لا يمكن التراجع عن هذا الإجراء. هل أنت متأكد أنك تريد المتابعة؟",

   "request-sent-success-title": "تم إرسال الطلب بنجاح!",
   "request-sent-success-description":
      "تم إرسال طلبك إلى المسؤول. بمجرد الرد على الطلب ستتلقى بريدًا إلكترونيًا بالرد.",
   "request-send-error-description": "واجهنا مشكلة في إرسال طلبك، يرجى المحاولة مرة أخرى.",
   "request-rejected-title": "يا للأسف! يبدو أن طلبك قد رُفض",
   "request-rejected-description-line1":
      "في الوقت الحالي لا يمكنك الوصول إلى هذا التقييم لأن طلبك قد رُفض.",
   "request-rejected-description-line2": "لكن لا تقلق! يمكنك طلب الوصول مرة أخرى.",
   "request-pending-title": "لقد طلبت بالفعل الوصول إلى هذا التقييم!",
   "request-pending-description-line1":
      "تم إرسال طلبك إلى مسؤول هذا التقييم. بمجرد الرد على الطلب ستتلقى بريدًا إلكترونيًا بالرد.",
   "request-pending-description-line2": "سنتواصل معك في أقرب وقت ممكن.",
   "request-access-title": "طلب الوصول إلى هذا التقييم",
   "request-access-description-part1": "افتح هذا التقييم الموجّه حتى",
   "request-access-description-part2": "نتمكن من تعيين خبرائنا",
   "request-access-description-part3": "من مجال عملك لـ",
   "request-access-description-part4": "دعمك مباشرة خلال عملية التقييم",
   "request-access-description-part5":
      "ومساعدتك على استكشاف طرق لبناء شراكات أفضل وتأمين التمويل للبرامج المستقبلية.",

   "guided-assessments-title": "التقييمات الموجّهة",
   "assessments-list-title": "قائمة التقييمات",
   "organizations-name-column": "اسم المنظمة",
   "assessment-column": "التقييم",
   "status-column": "الحالة",
   "not-started-status": "لم يبدأ",
   "in-progress-status": "قيد التنفيذ",
   "completed-status": "مكتمل",

   "success-title": "نجاح",
   "module-submitted-success-description": "تم إرسال الوحدة بنجاح",
   "no-submission-rounds-text": "لا توجد جولات تقديم",
   "submission-rounds-title": "جولات التقديم",
   "round-target-label": "الهدف",
   "module-submitted-modal-title": "لقد أرسلت هذه الوحدة بنجاح!",
   "next-round-active-description":
      "يرجى العودة إلى هذا التقييم عندما تصبح جولة التقديم التالية نشطة.",
   "remaining-time-current-round-label": "الوقت المتبقي للجولة الحالية",
   "start-label": "البداية",
   "end-label": "النهاية",
   "linked-modules-title": "الوحدات المرتبطة",
   "no-linked-modules-text": "لا توجد وحدات مرتبطة",
   "finished-status": "منتهي",
   "completed-text": "مكتمل",

   "assigned-to-label": "معيّن إلى",
   "assign-member-button": "تعيين عضو",
   "submitted-at-label": "تم الإرسال في",
   "edit-assignment-button": "تعديل التعيين",
   "assign-to-team-button": "تعيين إلى الفريق",
   "assessment-assigned-to-label": "التقييم معيّن إلى:",
   "expert-modules-description":
      "هذه هي الوحدات التي سيقوم الخبير الذي اخترته بالرد عليها. بمجرد أن يقوم الخبير بتقديم الوحدات، ستتمكن من عرض النتائج والإجابات في قسم النتائج.",

   "no-self-assessments-yet-title": "يبدو أن مساحة العمل هذه لا تحتوي على تقييمات ذاتية بعد!",
   "no-guided-assessments-yet-title": "يبدو أن مساحة العمل هذه لا تحتوي على تقييمات موجّهة بعد!",
   "work-on-guided-assessments-instead-description":
      "لكن لا تقلق، يمكنك العمل على التقييمات الموجّهة بدلاً من ذلك.",
   "work-on-self-assessments-instead-description":
      "لكن لا تقلق، يمكنك العمل على التقييمات الذاتية بدلاً من ذلك.",

   "name-column": "الاسم",
   "type-column": "النوع",
   "created-by-column": "أنشئ بواسطة",
   "created-date-column": "تاريخ الإنشاء",
   "edit-action": "تعديل",
   "founded-label": "تأسست",
   "areas-label": "مجالات",
   "staff-label": "موظف",
   "contact-label": "التواصل",
   "online-label": "عبر الإنترنت",
   "unlink-assessment-action": "فصل التقييم",
   "edit-assessment-alt": "تعديل التقييم",
   "archive-assessment-alt": "أرشفة التقييم",
   "delete-assessment-alt": "حذف التقييم",
   "unlink-assessment-alt": "فصل التقييم",

   "assessment-deleted-success-title": "تم حذف التقييم بنجاح!",
   "assessment-deleted-success-description": "تم حذف هذا التقييم بنجاح من قاعدة بياناتك.",
   "assessment-delete-error-description": "واجهنا مشكلة في حذف هذا التقييم، يرجى المحاولة مرة أخرى.",
   "assessments-deleted-success-title": "تم حذف التقييمات بنجاح!",
   "assessments-deleted-success-description": "تم حذف هذه التقييمات بنجاح من قاعدة بياناتك.",
   "assessments-delete-error-description":
      "واجهنا مشكلة في حذف هذه التقييمات، يرجى المحاولة مرة أخرى.",
   "assessment-restored-success-title": "تمت استعادة التقييم بنجاح!",
   "assessment-restored-success-description": "تمت استعادة هذا التقييم بنجاح.",
   "assessment-unarchive-error-description":
      "واجهنا مشكلة في إلغاء أرشفة هذا التقييم، يرجى المحاولة مرة أخرى.",
   "assessments-unarchived-success-title": "تم إلغاء أرشفة التقييمات بنجاح!",
   "assessments-unarchived-success-description": "تم إلغاء أرشفة هذه التقييمات بنجاح.",
   "assessments-unarchive-error-description":
      "واجهنا مشكلة في إلغاء أرشفة هذه التقييمات، يرجى المحاولة مرة أخرى.",
   "assessment-archived-success-title": "تمت أرشفة التقييم بنجاح!",
   "assessment-archived-success-description": "تمت أرشفة هذا التقييم بنجاح.",
   "assessment-archive-error-description":
      "واجهنا مشكلة في إضافة هذا التقييم إلى الأرشيف، يرجى المحاولة مرة أخرى.",
   "assessment-trashed-success-title": "تمت إضافة التقييم إلى سلة المهملات بنجاح!",
   "assessment-trashed-success-description": "تمت إضافة هذا التقييم بنجاح إلى سلة المهملات.",
   "assessment-trash-error-description":
      "واجهنا مشكلة في إضافة هذا التقييم إلى سلة المهملات، يرجى المحاولة مرة أخرى.",

   "assessment-modules-title": "وحدات التقييم",
   "module-name-column": "اسم الوحدة",
   "go-to-module-button": "الانتقال إلى الوحدة",

   "consultant-organization-list-title": "قائمة منظمات الاستشاريين",
   "country-column": "البلد",
   "progress-column": "التقدم",
   "submitted-status": "تم الإرسال",
   "go-to-assessment-button": "الانتقال إلى التقييم",

   "module-submitted-toast": "تم إرسال الوحدة بنجاح.",
   "no-permission-submit-module-warning": "ليس لديك إذن لإرسال وحدة!",
   "submit-button": "إرسال",
   "module-submitted-text": "تم إرسال هذه الوحدة.",

   "choose-consultant-guide-title": "اختر مستشارًا لتوجيه تقييمك",
   "consultant-profile-title": "الملف الشخصي للمستشار",
   "consultant-label": "مستشار",
   "experience-title": "الخبرة",
   "education-title": "التعليم",
   "school-label": "المدرسة",
   "skills-title": "المهارات",
   "select-this-consultant-button": "اختر هذا المستشار",
   "enrolled-guided-assessment-success-title": "لقد تم تسجيلك بنجاح في التقييم الموجّه!",
   "consultant-contact-soon-description-part1": "المستشار",
   "consultant-contact-soon-description-part2": "سيتواصل معك قريبًا لبدء تقييماتك.",
   "go-to-assessments-button": "الانتقال إلى التقييمات",

   "improve-score-help-title":
      "إذا كنت ترغب في تحسين نتيجتك وتنمية مؤسستك أكثر، فإن فريق KAPorg هنا لمساعدتك!",
   "request-guided-assessment-description-part1":
      "اطلب تقييمًا موجّهًا الآن حتى نتمكن من تعيين خبرائنا من مجال عملك لدعمك مباشرة خلال عملية التقييم ومساعدتك على استكشاف طرق لبناء شراكات أفضل وتأمين التمويل للبرامج المستقبلية.",
   "request-guided-assessment-description-part2": "اطلبه الآن وسنتواصل معك في أقرب وقت ممكن.",
   "request-assessment-code-button": "طلب رمز تقييم",
   "have-assessment-code-button": "لدي رمز تقييم",
   "assessment-code-title": "رمز التقييم",
   "enter-assessment-code-description": "للوصول إلى تقييمك، يرجى كتابة رمز التقييم أدناه",
   "enter-code-here-label": "أدخل رمزك هنا",
   "please-enter-code-error": "يرجى إدخال الرمز",
   "assessment-list-label": "قائمة التقييمات",
   "select-an-assessment-placeholder": "-اختر تقييمًا-",
   "select-assessment-error": "يجب عليك اختيار تقييم",
   "submit-request-button": "إرسال الطلب",
   "request-assessment-code-title": "طلب رمز التقييم",
   "request-assessment-code-description":
      "يرجى طلب تقييمك وسنتواصل معك. بمجرد قبول الطلب، ستتلقى بريدًا إلكترونيًا يحتوي على الرمز.",
   "select-assessment-from-list-description": "اختر تقييمًا من القائمة أدناه",
   "code-valid-select-consultant-toast": "رمزك صالح والآن يمكنك اختيار المستشار",

   "my-modules-tab": "وحداتي",
   "template-library-tab": "مكتبة القوالب",

   "module-deleted-success-title": "تم حذف الوحدة بنجاح!",
   "module-deleted-success-description": "تمت إزالة هذه الوحدة بنجاح من قاعدة بياناتك.",
   "module-delete-error-description": "واجهنا مشكلة في حذف هذه الوحدة، يرجى المحاولة مرة أخرى.",
   "module-cannot-be-deleted-error": "لا يمكن حذف الوحدة",
   "preview-action": "معاينة",
   "download-action": "تنزيل",
   "turn-into-template-action": "تحويل إلى قالب",
   "preview-template-alt": "معاينة القالب",
   "edit-module-alt": "تعديل الوحدة",
   "download-module-alt": "تنزيل الوحدة",
   "turn-into-template-alt": "تحويل إلى قالب",
   "delete-module-alt": "حذف الوحدة",
   "title-column": "العنوان",
   "deleted-modules-button": "الوحدات المحذوفة",
   "add-module-button": "وحدة جديدة",
   "add-module-modal-button": "إضافة وحدة",
   "add-new-module-title": "إضافة وحدة جديدة",
   "add-new-assessment-title": "إضافة تقييم جديد",
   "survey-status-editing": "قيد التحرير",
   "survey-status-archived": "مؤرشف",
   "survey-status-deployed": "تم النشر",
   "survey-status-locked": "مقفل",

   "how-start-title": "كيف تريد أن تبدأ؟",
   "create-form-title": "إنشاء نموذج",
   "create-form-description": "ابدأ بهيكل فارغ، مضيفًا الأقسام والأسئلة أثناء المتابعة.",
   "import-form-title": "استيراد نموذج",
   "import-form-description": "قم بتحميل ملف يحتوي على أقسام وأسئلة محددة مسبقًا.",
   "use-template-title": "استخدام قالب",
   "use-template-description":
      "ابدأ بنموذج مخزن بالفعل في النظام وقم بتعديله بسهولة حسب احتياجاتك.",
   "continue-button": "متابعة",

   "module-details-title": "تفاصيل الوحدة",
   "enter-module-name-placeholder": "أدخل اسم الوحدة",
   "enter-module-description-placeholder": "أدخل وصف الوحدة",
   "default-language-label": "اللغة الافتراضية",
   "select-default-language-module-placeholder": "اختر اللغة الافتراضية للوحدة",
   "select-assessment-label": "اختر التقييم",
   "select-assessment-module-placeholder": "اختر تقييم الوحدة",

   "delete-module-title": "حذف الوحدة",
   "delete-template-title": "حذف القالب",
   "delete-module-confirm-description": "أنت على وشك حذف هذه الوحدة. لا يمكن التراجع عن هذا الإجراء.",
   "delete-template-confirm-description": "أنت على وشك حذف هذا القالب. لا يمكن التراجع عن هذا الإجراء.",

   "module-restored-success-title": "تمت استعادة الوحدة بنجاح!",
   "module-restored-success-description": "تمت استعادة هذه الوحدة بنجاح.",
   "module-restore-error-description": "واجهنا مشكلة في استعادة هذه الوحدة، يرجى المحاولة مرة أخرى.",
   "deleted-modules-list-title": "قائمة الوحدات المحذوفة",
   "restore-modules-button": "استعادة الوحدات",
   "deleted-modules-description":
      "هنا يمكنك عرض واستعادة الوحدات المحذوفة. أي وحدة لم تتم استعادتها خلال 60 يومًا سيتم حذفها نهائيًا.",

   "module-name-required-validation": "اسم الوحدة مطلوب",
   "upload-module-file-label": "تحميل ملف الوحدة",
   "drag-drop-file-text": "اسحب وأفلت الملف هنا، أو",
   "click-to-select-file-text": "انقر لتحديد الملف",
   "max-file-size-text": "الحد الأقصى لحجم الملف: 20 ميغابايت",

   "module-create-error-description": "واجهنا مشكلة في إنشاء هذه الوحدة، يرجى المحاولة مرة أخرى.",
   "make-module-template-label": "اجعل هذه الوحدة قالبًا",

   "not-a-xlsx-file-error": "ليس ملف xlsx",
   "upload-valid-xlsx-error": "يرجى تحميل ملف xlsx صالح قبل الإرسال.",
   "error-title": "خطأ",
   "survey-imported-success-description": "تم استيراد الوحدة بنجاح",
   "survey-import-failed-error": "فشل استيراد الوحدة.",
   "copy-file-name-tooltip": "نسخ اسم الملف",
   "copied-tooltip": "تم النسخ!",
   "module-must-have-right-format-text": "يجب أن تكون وحدتك بالتنسيق الصحيح لاستيرادها بشكل صحيح.",
   "download-format-link": "تنزيل التنسيق",
   "enter-description-placeholder": "أدخل الوصف",

   "min-3-characters-validation": "3 أحرف كحد أدنى",
   "language-required-validation": "اللغة مطلوبة",
   "assessment-required-validation": "التقييم مطلوب",
   "new-module-suffix": "وحدة جديدة",

   "edit-module-title": "تعديل الوحدة",
   "module-description-label": "وصف الوحدة",

   "template-deleted-success-title": "تم حذف القالب بنجاح!",
   "template-deleted-success-description": "تمت إزالة هذا القالب بنجاح من قاعدة بياناتك.",
   "template-delete-error-description": "واجهنا مشكلة في حذف هذا القالب، يرجى المحاولة مرة أخرى.",
   "edit-template-alt": "تعديل القالب",
   "download-template-alt": "تنزيل القالب",
   "duplicate-template-alt": "تكرار القالب",
   "delete-template-alt": "حذف القالب",
   "copy-action": "نسخ",
   "module-title-column": "عنوان الوحدة",
   "created-on-column": "تاريخ الإنشاء",
   "last-updated-column": "آخر تحديث",

   "copy-suffix-label": "نسخة",
   "template-duplicated-success-title": "تم تكرار القالب بنجاح!",
   "template-duplicated-success-description":
      "تم تكرار قالبك بنجاح. يمكنك الآن تعديل وتخصيص النسخة الجديدة.",
   "template-duplicate-error-description": "واجهنا مشكلة في تكرار هذا القالب، يرجى المحاولة مرة أخرى.",
   "copy-template-title": "نسخ القالب",
   "copy-template-description":
      "أنت على وشك إنشاء قالب قابل لإعادة الاستخدام بناءً على هيكل هذه الوحدة. ستتمكن من استخدام هذا القالب لإنشاء وحدات جديدة بسرعة.",
   "template-name-label": "اسم القالب",
   "template-name-required-validation": "اسم القالب مطلوب",
   "enter-template-name-placeholder": "أدخل اسم القالب",
   "description-optional-label": "(اختياري)",
   "template-description-hint-placeholder": "ملاحظة قصيرة لمساعدة فريقك على فهم متى يتم استخدام هذا القالب",

   "no-templates-found-title": "لم يتم العثور على قوالب",
   "no-templates-found-description":
      "لا توجد قوالب متاحة الآن. حاول مرة أخرى لاحقًا أو أنشئ واحدًا جديدًا!",
   "sections-label": "الأقسام:",
   "use-template-button": "استخدام القالب",

   "template-created-success-title": "تم إنشاء القالب بنجاح!",
   "template-created-success-description":
      "تم إنشاء قالبك الجديد من هيكل هذه الوحدة. يمكنك الآن تعديله أو استخدامه لإنشاء وحدات جديدة بسرعة.",
   "template-create-error-description": "واجهنا مشكلة في إنشاء هذا القالب، يرجى المحاولة مرة أخرى.",
   "convert-module-to-template-title": "تحويل الوحدة إلى قالب",
   "module-label": "الوحدة",
   "structure-logic-copied-note": "ملاحظة: سيتم نسخ الهيكل والمنطق فقط، ولن يتم تضمين الإجابات.",
   "create-template-button": "إنشاء القالب",

   "fetch-drafts-error": "فشل جلب المسودات",
   "module-saved-draft-success": "تم حفظ الوحدة كمسودة بنجاح",
   "save-draft-error": "فشل حفظ المسودة",
   "reject-module-error": "فشل رفض الوحدة",
   "submit-module-error": "فشل إرسال الوحدة",
   "preview-other-modules-text": "معاينة الوحدات الأخرى في هذا التقييم",
   "my-saved-drafts-button": "مسوداتي المحفوظة",
   "save-as-draft-button": "حفظ كمسودة",
   "processing-text": "جارٍ المعالجة...",
   "submit-module-button": "إرسال الوحدة",
   "reject-module-button": "رفض الوحدة",
   "approve-module-button": "الموافقة على الوحدة",

   "change-status-button": "تغيير الحالة",
   "change-module-status-editing-title": "تغيير حالة الوحدة إلى قيد التحرير",
   "change-module-status-editing-confirm-description":
      "أنت على وشك تغيير حالة الوحدة إلى قيد التحرير.",

   "language-label": "اللغة",
   "select-language-placeholder": "اختر اللغة",
   "print-module-button": "طباعة الوحدة",

   "save-as-draft-title": "حفظ كمسودة",
   "save-draft-description":
      "لحفظ مسودة من هذه الوحدة، أعطها اسمًا حتى تتمكن من مراجعتها لاحقًا. يتم تخزين المسودات التي تحفظها في قاعدة بياناتنا.",
   "save-draft-button": "حفظ المسودة",

   "start-new-draft-button": "بدء مسودة جديدة",
   "my-saved-draft-title": "مسودتي المحفوظة",
   "unsubmitted-drafts-description": "لديك مسودات غير مرسلة لهذه الوحدة.",
   "continue-draft-or-new-question": "هل تريد المتابعة بمسودة أو بدء واحدة جديدة؟",
   "my-draft-label": "مسودتي",
   "no-drafts-found-text": "لم يتم العثور على مسودات. ابدأ مسودة جديدة.",

   "submit-module-confirm-description-part1":
      "أنت على وشك إرسال هذه الوحدة. بمجرد المتابعة، سيتم إرسال إجاباتك إلى مدير المشروع للمراجعة والموافقة.",
   "submit-module-confirm-description-part2":
      "يرجى التأكد من دقة جميع إجاباتك، حيث لن تتمكن من إجراء أي تغييرات بعد الإرسال.",

   "approve-request-confirm-description":
      "أنت على وشك الموافقة على هذا الطلب. لا يمكن التراجع عن هذا الإجراء.",
   "feedback-required-validation": "الملاحظات مطلوبة",
   "reject-module-description-part1": "يرجى تقديم ملاحظات مفصلة حول سبب رفض هذه الوحدة.",
   "reject-module-description-part2":
      "سيكون هذا بمثابة دليل لعضو الفريق المسؤول لإجراء التصحيحات اللازمة.",
   "why-rejecting-module-label": "لماذا ترفض هذه الوحدة؟",
   "enter-rejection-reason-placeholder": "يرجى إدخال سبب الرفض",

   "module-status-label": "حالة الوحدة:",
   "survey-status-published": "منشور",
   "edit-module-details-tooltip": "تعديل تفاصيل الوحدة",
   "page-preparing-text": "جارٍ تحضير الصفحة...",

   "add-section-to-module-tooltip": "إضافة قسم إلى الوحدة",
   "add-inner-section-tooltip": "إضافة قسم داخلي",

   "question-type-section": "قسم",
   "question-type-select-one": "اختر واحدًا",
   "question-type-text": "نص",
   "question-type-file-upload": "تحميل ملف",
   "question-type-date": "تاريخ",
   "question-type-phone-number": "رقم الهاتف",
   "question-type-rating": "تقييم",
   "question-type-ranking": "ترتيب",
   "question-type-select-multiple": "اختر متعدد",
   "question-type-note": "ملاحظة",
   "question-type-date-time": "التاريخ والوقت",
   "question-type-time": "الوقت",
   "question-type-number": "رقم",
   "question-type-acknowledge": "إقرار",
   "question-type-matrix": "مصفوفة",
   "type-section-label-placeholder": "يرجى كتابة تسمية القسم",
   "type-question-label-placeholder": "يرجى كتابة تسمية السؤال",

   "option-placeholder": "خيار",
   "enter-note-text-above": "يرجى كتابة نص الملاحظة أعلاه.",
   "calculate-question-coming-soon": "سؤال الحساب - قريبًا...",
   "file-upload-caps-label": "تحميل ملف",
   "items-to-be-ranked-label": "العناصر المراد ترتيبها",
   "text-question-type-label": "نوع السؤال: نص",
   "question-displayed-as-table-text": "سيتم عرض هذا السؤال كجدول",
   "row-questions-title": "أسئلة الصفوف",
   "columns-questions-title": "أسئلة الأعمدة",
   "allow-numbers-range-only-text": "السماح بالأرقام من نطاق فقط",
   "gps-question-coming-soon": "سؤال GPS - قريبًا...",
   "type-label-optional-placeholder": "اكتب تسمية (اختياري)",
   "optional-placeholder": "اختياري",
   "reverse-answers-order-button": "عكس ترتيب الإجابات",
   "type-answer-choice-placeholder": "اكتب خيار إجابة",
   "label-text": "التسمية",
   "select-an-option-placeholder": "اختر خيارًا",
   "select-a-scale-placeholder": "اختر مقياسًا",
   "enter-bulk-action-placeholder": "أدخل إجراء جماعي",
   "to-divider-label": "إلى",
   "collect-date-info-text": "جمع معلومات التاريخ",
   "collect-time-info-text": "جمع معلومات الوقت",
   "collect-phone-number-info-text": "جمع معلومات رقم الهاتف",
   "type-a-question-placeholder": "اكتب سؤالاً",
   "min-label": "الحد الأدنى:",
   "max-label": "الحد الأقصى:",
   "max-options-chosen-text": "الحد الأقصى لعدد الخيارات التي يمكن اختيارها",
   "all-options-label": "الكل",
   "answer-genius-label": "عبقري الإجابات",
   "add-choices-button": "إضافة خيارات",
   "bulk-actions-label": "إجراءات جماعية",
   "enter-each-answer-choice-line-text": "أدخل كل خيار إجابة في سطر منفصل.",

   // Question editor (admin/survey v2) - EditorFooter, QuestionEditorWrapper
   "required-answer-label": "إجابة مطلوبة",
   "delete-question-confirm-title": "هل أنت متأكد أنك تريد حذف هذا السؤال؟",
   "delete-section-confirm-title": "هل أنت متأكد أنك تريد حذف هذا القسم؟",
   "this-action-cannot-be-undone-text": "لا يمكن التراجع عن هذا الإجراء",
   "yes-confirm-button": "نعم",
   "no-confirm-button": "لا",
   "add-new-question-button": "إضافة سؤال جديد",
   "add-new-inner-section-button": "إضافة قسم فرعي جديد",
   "add-new-section-button": "إضافة قسم جديد",

   // Skip logic (admin/survey v2)
   "show-logic-button": "إظهار المنطق",
   "display-condition-prefix-text": "عرض",
   "question-word-label": "سؤال",
   "when-following-conditions-apply-text": "عند تحقق الشروط التالية:",
   "add-another-condition-button": "إضافة شرط آخر",
   "should-match-all-the-criteria-placeholder-text": "يجب أن يطابق جميع المعايير",
   "should-match-all-of-these-criteria-text": "يجب أن يطابق كل هذه المعايير",
   "should-match-any-of-these-criteria-text": "يجب أن يطابق أياً من هذه المعايير",
   "operator-was-not-answered-label": "لم تتم الإجابة",
   "operator-was-answered-label": "تمت الإجابة",
   "operator-equals-label": "يساوي (=)",
   "operator-not-equals-label": "لا يساوي (!=)",
   "operator-greater-than-label": "أكبر من (>)",
   "operator-less-than-label": "أصغر من (<)",
   "operator-greater-than-or-equal-label": "أكبر من أو يساوي (>=)",
   "operator-less-than-or-equal-label": "أصغر من أو يساوي (<=)",

   // Question submission types (admin/survey v2 preview/answer rendering)
   "field-required-text": "هذا الحقل مطلوب",
   "type-your-answer-here-placeholder": "اكتب إجابتك هنا",
   "you-must-select-text": "يجب عليك الاختيار",
   "you-must-enter-date-and-time-text": "يجب إدخال تاريخ ووقت",
   "you-must-enter-a-number-text": "يجب إدخال رقم",
   "drag-drop-files-text": "اسحب وأفلت الملفات هنا، أو انقر لتحديد الملفات",
   "uploaded-file-label": "الملف المرفوع:",
   "you-must-upload-file-text": "يجب رفع ملف",
   "all-rankings-must-be-selected-text": "يجب اختيار جميع الترتيبات",
   "please-specify-placeholder": "يرجى التحديد",
   "you-can-select-up-to-text": "يمكنك اختيار حتى",
   "choices-suffix-text": "خيارات.",
   "you-must-select-at-least-one-text": "يجب اختيار واحد على الأقل",
   "you-must-select-one-text": "يجب اختيار واحد",
   "you-must-select-a-time-text": "يجب اختيار وقت",

   // Approver feature (survey Preview + approve/reject modals)
   "no-submission-made-yet-text": "لم يتم تقديم أي إجابة لهذا الوحدة حتى الآن.",
   "approval-successful-title": "تمت بنجاح",
   "submission-approved-successfully-text": "تمت الموافقة على الإجابة بنجاح",
   "fetch-submission-answers-error": "فشل في جلب إجابات الإرسال",
   "approve-without-review-button": "الموافقة دون مراجعة",
   "send-for-approval-button": "إرسال للموافقة",
   "approve-module-pending-approver-description":
      "أنت على وشك الموافقة على هذه الوحدة. بعد المتابعة، سيتم إرسالها إلى المعتمد لمراجعة نهائية قبل تحديد حالتها كـ",
   "approve-module-final-description-part1":
      "أنت على وشك تقديم الموافقة النهائية على هذه الوحدة. بعد المتابعة، سيتم تحديد حالتها كـ",
   "approve-module-final-description-part2":
      "وستكون نتائجها متاحة للتحليل. لا يمكن التراجع عن هذا الإجراء. هل أنت متأكد أنك تريد الاستمرار؟",
   "send-to-approver-for-review-label": "إرسال إلى المعتمد للمراجعة النهائية",
   "approver-review-recommended-hint": "موصى به - تجاوز هذا الخيار يُنهي الوحدة على الفور.",
   "skipping-approver-review-warning-text": "أنت تتجاوز مراجعة المعتمد. سينتهي هذا الوحدة دون فحص ثانٍ.",
   "enter-detailed-feedback-placeholder": "يرجى كتابة ملاحظاتك التفصيلية هنا",

   // Approver management (admin/approver)
   "department-team-label": "القسم/الفريق",
   "enter-approver-name-placeholder": "أدخل اسم المعتمد",
   "enter-approver-email-placeholder": "أدخل البريد الإلكتروني للمعتمد",
   "enter-approver-department-placeholder": "أدخل قسم المعتمد",
   "approver-added-success-title": "تمت إضافة المعتمد بنجاح!",
   "approver-added-success-description": "يمكن الآن تعيين هذا المعتمد للتقييمات.",
   "approver-updated-success-title": "تم تحديث المعتمد بنجاح!",
   "approver-updated-success-description": "تم تحديث تفاصيل هذا المعتمد.",
   "approver-add-error-description": "حدثت مشكلة أثناء إضافة هذا المعتمد، يرجى المحاولة مرة أخرى.",
   "approver-update-error-description": "حدثت مشكلة أثناء تحديث هذا المعتمد، يرجى المحاولة مرة أخرى.",
   "approver-delete-error-description": "حدثت مشكلة أثناء حذف هذا المعتمد، يرجى المحاولة مرة أخرى.",
   "approver-deleted-success-title": "تم حذف المعتمد بنجاح!",
   "approver-deleted-success-description": "تمت إزالة هذا المعتمد.",
   "delete-approver-title": "حذف المعتمد",
   "delete-approver-confirm-text": "أنت على وشك حذف هذا المعتمد.",
   "add-approver-title": "إضافة معتمد",
   "edit-approver-title": "تعديل المعتمد",
   "add-approver-button": "إضافة معتمد",
   "approvers-title": "المعتمدون",
   "search-approver-by-name-placeholder": "البحث عن معتمد باسمه",
   "filter-approvers-by-department-placeholder": "تصفية المعتمدين حسب القسم",

   // Approver submissions (approver-facing pages)
   "no-data-text": "لا توجد بيانات",
   "submitted-by-column": "تم التقديم من قبل",
   "pending-modules-title": "الوحدات المعلقة",
   "approved-modules-title": "الوحدات المعتمدة",
   "rejected-modules-title": "الوحدات المرفوضة",
   "filter-tasks-by-submission-date-placeholder": "تصفية المهام حسب تاريخ التقديم",
   "module-approvals-title": "موافقات الوحدات",
   "pending-modules-review-description":
      "هذه هي قائمة الوحدات المعلقة لمراجعتك. للمتابعة، يرجى النقر على كل وحدة حيث ستتمكن من قبولها أو رفضها.",
   "the-approver-label": "المعتمد",
   "approver-label": "المعتمد",
   "select-an-approver-placeholder": "اختر معتمداً",
   "go-to-revise-module-button": "الانتقال لمراجعة الوحدة",
   "rejected-module-information-title": "معلومات الوحدة المرفوضة",
   "feedback-from-label-prefix": "الملاحظات من",
   "the-project-manager-label": "مدير المشروع",
   "awaiting-approver-status": "في انتظار المعتمد",

   // Editor page, edit panel, edit survey details (admin/survey v2 editor)
   "module-title-label": "عنوان الوحدة",
   "enter-module-title-placeholder": "أدخل عنوان الوحدة",
   "module-description-label": "وصف الوحدة",
   "assigned-assessment-label": "التقييم المخصص",
   "survey-updated-success-title": "تم تحديث الاستبيان بنجاح!",
   "module-updated-success-description": "تم تحديث هذه الوحدة بشكل صحيح.",
   "edit-module-error-description": "حدثت مشكلة أثناء تعديل هذه الوحدة، يرجى المحاولة مرة أخرى.",
   "form-builder-tab-label": "منشئ النموذج",
   "logic-builder-tab-label": "منشئ المنطق",
   "translate-questions-tab-label": "ترجمة الأسئلة",
   "score-questions-tab-label": "تسجيل نقاط الأسئلة",
   "stay-here-button": "البقاء هنا",
   "change-tab-button": "تغيير علامة التبويب",
   "unsaved-progress-title": "تقدم غير محفوظ",
   "unsaved-changes-tab-text": "لديك تغييرات غير محفوظة في هذه العلامة.",
   "confirm-proceed-without-saving-part1": "هل أنت متأكد أنك تريد المتابعة",
   "confirm-proceed-without-saving-part2": "دون حفظ التقدم؟",
   "module-status-changed-success-title": "تم تغيير حالة الوحدة بنجاح!",
   "module-status-changed-success-description": "تم تغيير حالة هذه الوحدة بشكل صحيح.",
   "problem-occurred-title": "حدثت مشكلة!",
   "change-status-error-description":
      "حدثت مشكلة أثناء تغيير حالة هذه الوحدة، يرجى المحاولة مرة أخرى.",
   "publish-module-button": "نشر الوحدة",
   "change-status-to-editing-button": "تغيير الحالة إلى التحرير",
   "changes-saved-success-description": "تم حفظ التغييرات بنجاح",
   "save-progress-button": "حفظ التقدم",
   "skip-logic-saved-success-description": "تمت إضافة منطق التخطي بنجاح",
   "score-points-saved-success-description": "تمت إضافة نقاط التقييم بنجاح",
   "total-module-score-label": "النقاط الإجمالية للوحدة:",
   "points-suffix": "نقطة",
   "answers-column-label": "الإجابات",
   "score-column-label": "النقاط",
   "input-score-placeholder": "أدخل النقاط",
   "max-score-label": "أقصى نقاط:",
   "date-answer-label": "إجابة التاريخ",
   "time-answer-label": "إجابة الوقت",
   "answer-keywords-label": "الكلمات المفتاحية للإجابة",
   "section-score-label": "نقاط القسم:",
   "number-range-hint-prefix": "النطاق لهذا السؤال هو",
   "number-range-hint-value": "من 1 إلى 50",
   "number-range-hint-suffix": ". يرجى تحديد خيارات الإجابة الصحيحة للتسجيل:",
   "select-right-answer-choices-placeholder": "حدد خيارات الإجابة الصحيحة",
   "single-number-option-label": "رقم واحد",
   "range-option-label": "نطاق",
   "enter-range-correct-answers-label": "أدخل نطاق الإجابات الصحيحة",
   "to-connector-label": "إلى",
   "enter-correct-number-label": "أدخل الرقم الصحيح",
   "input-number-placeholder": "أدخل الرقم",
   "ranking-score-instructions-text": "يرجى ترتيب الخيارات بالترتيب الصحيح، ثم أعطِ كل واحدة نقاطاً",
   "input-phone-number-placeholder": "أدخل رقم الهاتف",

   // Translate panel (admin/survey v2 editor)
   "main-module-title": "الوحدة الرئيسية",
   "main-module-description-text": "هذه هي الأسئلة من وحدتك الرئيسية",
   "default-language-placeholder": "اللغة الافتراضية",
   "translate-module-title": "ترجمة الوحدة",
   "write-translation-here-text": "اكتب ترجمة كل سؤال هنا",
   "translate-to-label": "ترجمة إلى",
   "select-a-language-placeholder": "--اختر لغة--",
   "select-language-first-error": "يرجى تحديد لغة أولاً",
   "translation-saved-success-description": "تم حفظ الترجمة بنجاح",
   "save-translation-button": "حفظ الترجمة",

   // Action Plan admin-side resource/expert modals (workspace/actionPlan/adminActionPlan)
   "module-required-validation": "الوحدة مطلوبة",
   "at-least-one-section-required-validation": "مطلوب قسم واحد على الأقل",
   "resource-type-required-validation": "نوع المورد مطلوب",
   "at-least-one-attachment-required-validation": "مطلوب مرفق واحد على الأقل",
   "description-required-validation": "الوصف مطلوب",
   "tagged-topics-required-validation": "المواضيع الموسومة مطلوبة",
   "invalid-url-format-validation": "تنسيق رابط غير صالح",
   "link-url-required-validation": "رابط الارتباط مطلوب",
   "agree-to-terms-required-validation": "يجب أن توافق على الشروط",
   "section-required-validation": "القسم مطلوب",
   "resources-added-success-title": "تمت إضافة الموارد بنجاح!",
   "resources-added-success-description": "تم إنشاء هذه الموارد وإضافتها إلى قاعدة بياناتك.",
   "upload-resource-matching-type-error": "يرجى تحميل مورد يتطابق مع النوع المحدد.",
   "resources-updated-success-title": "تم تحديث الموارد بنجاح!",
   "resources-updated-success-description": "تم تحديث هذه الموارد بنجاح.",
   "add-new-resource-title": "مورد جديد",
   "edit-resource-title": "تعديل المورد",
   "resource-upload-shared-repository-notice":
      "سيتم نشر أي مورد تقوم بتحميله على المنصة في مستودع KAPorg المشترك، مما يجعله متاحاً للمستخدمين الآخرين لتنزيله ومشاركته، مع تعزيز دعم المجتمع.",
   "select-module-link-resource-label": "حدد الوحدة التي تريد ربط هذا المورد بها",
   "all-modules-in-assessment-placeholder": "جميع الوحدات في هذا التقييم",
   "select-section-link-resource-label": "حدد قسم الوحدة التي تريد ربط هذا المورد بها",
   "all-sections-of-module-placeholder": "جميع أقسام الوحدة",
   "resource-information-title": "معلومات المورد",
   "select-resource-type-label": "حدد نوع المورد",
   "before-upload-select-type-hint": "قبل تحميل المورد يجب تحديد نوعه",
   "paste-link-here-label": "لصق الرابط هنا",
   "enter-link-url-placeholder": "أدخل رابط الارتباط",
   "upload-file-here-label": "قم بتحميل الملف هنا",
   "drag-drop-file-here-prefix": "اسحب وأفلت الملف هنا، أو",
   "click-to-select-file-text": "انقر لتحديد الملف",
   "max-file-size-text": "الحد الأقصى لحجم الملف: 20 ميجابايت",
   "enter-resource-description-label": "أدخل وصف المورد",
   "tagged-topics-label": "المواضيع الموسومة",
   "enter-tagged-topics-placeholder": "أدخل المواضيع التي يمكن ربط هذا المورد بها",
   "upload-rights-confirmation-text":
      "بتحميل هذه المادة، أؤكد أن لدي الحقوق والأذونات اللازمة للقيام بذلك.",
   "add-resource-button": "إضافة مورد",
   "expert-name-column": "اسم الخبير",
   "operating-countries-column": "بلدان العمل",
   "years-of-experience-column": "سنوات الخبرة",
   "expert-cv-column": "السيرة الذاتية للخبير",
   "areas-of-expertise-column": "مجالات الخبرة",
   "assign-experts-to-assessment-title": "تعيين خبراء لهذا التقييم",
   "select-expert-assign-assessment-text": "حدد الخبير الذي تريد تعيينه لهذا التقييم.",
   "search-resource-by-name-placeholder": "البحث عن مورد باسمه",
   "assign-expert-to-assessment-button": "تعيين الخبير لهذا التقييم",
   "expert-assigned-success-title": "تم تعيين الخبير بنجاح!",
   "expert-assigned-success-description": "تم تعيين هذا الخبير وإضافته إلى قاعدة بيانات خطة العمل الخاصة بك.",
   "assign-expert-error-description":
      "حدثت مشكلة أثناء تعيين هذا الخبير في خطة عملك، يرجى المحاولة مرة أخرى.",
   "expert-removed-success-title": "تمت إزالة الخبير بنجاح!",
   "expert-removed-success-description": "تمت إزالة هذا الخبير من قاعدة بيانات خطة عملك.",
   "remove-expert-from-assessment-button": "إزالة الخبير من هذا التقييم",
   "email-label-colon": "البريد الإلكتروني:",
   "description-label-colon": "الوصف:",
   "no-description-available-text": "لا يوجد وصف متاح",
   "no-expertise-listed-text": "لا توجد خبرة مدرجة",
   "field-of-study-label": "مجال الدراسة",
   "no-field-of-study-listed-text": "لا يوجد مجال دراسة مدرج",
   "no-operating-countries-listed-text": "لا توجد بلدان عمل مدرجة",
   "languages-label": "اللغات",
   "no-languages-listed-text": "لا توجد لغات مدرجة",
   "linkedin-profile-label": "الملف الشخصي على LinkedIn",
   "no-linkedin-profile-text": "لم يتم تقديم ملف LinkedIn",
   "delete-collection-title": "حذف المجموعة",
   "delete-collection-confirm-text": "أنت على وشك حذف هذه المجموعة. لا يمكن التراجع عن هذا الإجراء.",
   "delete-resource-title": "حذف المورد",
   "delete-resource-confirm-text": "أنت على وشك حذف هذا المورد. لا يمكن التراجع عن هذا الإجراء.",
   "collection-deleted-success-title": "تم حذف المجموعة بنجاح!",
   "collection-deleted-success-description": "تمت إزالة هذه المجموعة بنجاح من قاعدة بياناتك.",
   "resource-deleted-success-title": "تم حذف المورد بنجاح!",
   "resource-deleted-success-description": "تمت إزالة هذا المورد بنجاح من قاعدة بياناتك.",
   "delete-resource-error-description": "حدثت مشكلة أثناء حذف هذا المورد، يرجى المحاولة مرة أخرى.",
   "resource-preview-title": "معاينة المورد",
   "document-type-label": "وثيقة",
   "video-type-label": "فيديو",
   "slide-type-label": "شريحة",
   "tags-and-categories-label": "العلامات والفئات",
   "upload-date-label": "تاريخ التحميل",
   "description-label": "الوصف",

   // Action Plan view/manager-side task modals (workspace/actionPlan/viewActionPlan)
   "status-label-colon": "الحالة:",
   "assign-to-label-colon": "تعيين إلى:",
   "deadline-label-colon": "الموعد النهائي:",
   "resources-attached-section-text": "الموارد المرفقة بهذا القسم",
   "resource-link-label-colon": "هذا هو رابط المورد:",
   "task-title-required-validation": "عنوان المهمة مطلوب",
   "deadline-required-validation": "الموعد النهائي مطلوب",
   "create-new-task-title": "إنشاء مهمة جديدة",
   "edit-task-title": "تعديل المهمة",
   "task-title-label": "عنوان المهمة",
   "task-title-example-placeholder": "كم مرة تقدم التدريب لموظفيك؟",
   "enter-task-instruction-placeholder": "أدخل ملاحظة أو تعليمات تساعد الشخص المكلف على إنجاز المهمة",
   "assign-task-to-label": "تعيين المهمة إلى",
   "select-member-assign-task-placeholder": "حدد العضو لتعيين هذه المهمة له",
   "cant-find-member-assign-task-text": "لا تجد العضو لتعيين مهمة له؟",
   "add-in-organization-management-text": "أضفه في إدارة المنظمة",
   "upload-files-complete-task-label": "قم بتحميل الملفات اللازمة لإكمال هذه المهمة",
   "can-add-up-to-3-resources-text": "يمكنك إضافة ما يصل إلى 3 موارد",
   "deadline-label": "الموعد النهائي",
   "resource-link-optional-label": "هل موردك رابط؟ يرجى إدخاله هنا",
   "enter-resource-link-placeholder": "أدخل رابط موردك",
   "assign-task-title": "تعيين المهمة",
   "assign-task-at-least-one-member-validation": "تعيين المهمة لعضو واحد على الأقل",
   "deadline-valid-date-validation": "يجب أن يكون الموعد النهائي تاريخاً صالحاً",
   "select-deadline-placeholder": "حدد الموعد النهائي",
   "task-added-assigned-success-title": "تمت إضافة المهمة وتعيينها بنجاح!",
   "task-added-assigned-success-description":
      "تم تعيين هذه المهمة بنجاح، وسيتم إشعار العضو الذي حددته بذلك.",
   "assign-task-error-description": "حدثت مشكلة أثناء تعيين هذه المهمة، يرجى المحاولة مرة أخرى.",
   "select-status-title": "حدد الحالة",
   "task-updated-success-title": "تم تحديث المهمة بنجاح!",
   "task-updated-success-description": "تم تحديث هذه المهمة بنجاح في قاعدة بياناتك.",
   "update-task-error-description": "حدثت مشكلة أثناء تحديث هذه المهمة، يرجى المحاولة مرة أخرى.",
   "task-deleted-success-title": "تم حذف المهمة بنجاح!",
   "task-deleted-success-description": "تمت إزالة هذه المهمة بنجاح من قاعدة بياناتك.",
   "delete-task-error-description": "حدثت مشكلة أثناء حذف هذه المهمة، يرجى المحاولة مرة أخرى.",
   "delete-task-title": "حذف المهمة",
   "delete-task-confirm-text": "أنت على وشك حذف هذه المهمة. لا يمكن التراجع عن هذا الإجراء.",
   "rounds-filter-label": "الجولات",
   "managers-filter-label": "المدراء",
   "generate-report-button": "إنشاء تقرير",
   "generate-report-title": "إنشاء التقرير",
   "choose-sections-report-text": "اختر الأقسام التي تريد تضمينها في التقرير.",
   "include-module-breakdown-label": "تضمين تفصيل الوحدات",
   "of-label": "من",
   "sections-selected-suffix": "أقسام محددة",
   "generate-button": "إنشاء",
   "report-preview-title": "معاينة التقرير",
   "edit-sections-button": "تعديل الأقسام",
   "assessment-report-eyebrow-text": "تقرير التقييم",
   "no-sections-data-selected-text": "لا توجد أقسام تحتوي على بيانات محددة.",
   "assessment-report-pdf-heading": "تقرير التقييم",
   "exported-on-label": "تم التصدير في",
   "page-word": "صفحة",
   "add-review-note-title": "إضافة ملاحظة مراجعة",
   "edit-review-note-title": "تعديل ملاحظة المراجعة",
   "note-title-required-validation": "يرجى إدخال عنوان الملاحظة",
   "enter-note-title-placeholder": "أدخل عنوان الملاحظة",
   "round-covered-label": "الجولة المشمولة",
   "select-option-required-validation": "يرجى اختيار خيار",
   "note-required-validation": "يرجى إدخال ملاحظاتك",
   "summarize-progress-placeholder": "لخّص التقدم الرئيسي أو القرارات أو المشكلات.",
   "add-note-button": "إضافة ملاحظة",
   "staff-members-fetch-error": "واجهنا مشكلة في جلب أعضاء الطاقم، يرجى تحديث الصفحة.",
   "task-priority-fetch-error": "واجهنا مشكلة في جلب أولوية المهمة، يرجى تحديث الصفحة.",
   "select-section-add-task-error": "يرجى اختيار قسم لإضافة هذه المهمة.",
   "add-task-error-description": "واجهنا مشكلة في إضافة هذه المهمة، يرجى المحاولة مرة أخرى.",
   "add-new-task-title": "إضافة مهمة جديدة",
   "task-name-label": "اسم المهمة",
   "task-name-required-validation": "يرجى إدخال اسم المهمة",
   "enter-task-name-placeholder": "أدخل اسم المهمة",
   "linked-questions-label": "الأسئلة المرتبطة",
   "select-questions-required-validation": "يرجى اختيار الأسئلة",
   "linked-questions-helper-text": "اختر الأسئلة التي تهدف هذه المهمة إلى تحسينها",
   "select-questions-placeholder": "اختر الأسئلة",
   "task-description-required-validation": "يرجى إدخال وصف",
   "enter-task-description-placeholder": "أدخل وصف المهمة",
   "select-member-required-validation": "يرجى اختيار عضو",
   "select-deadline-required-validation": "يرجى اختيار موعد نهائي",
   "priority-label": "الأولوية",
   "select-priority-required-validation": "يرجى اختيار الأولوية",
   "select-priority-placeholder": "اختر الأولوية",
   "resources-label": "الموارد",
   "select-resources-placeholder": "اختر الموارد المرتبطة بهذه المهمة",
   "select-resources-required-validation": "يرجى اختيار الموارد",
   "search-resource-placeholder": "البحث عن مورد",
   "browse-resources-library-text": "تصفح مكتبة الموارد",
   "add-task-button": "إضافة مهمة",
   "confirm-selection-button": "تأكيد التحديد",
   "resource-library-title": "مكتبة الموارد",
   "collections-tab-label": "المجموعات",
   "workspace-breadcrumb-label": "مساحة العمل",
   "resources-breadcrumb-label": "الموارد",
   "results-breadcrumb-label": "النتائج",
   "action-plan-breadcrumb-label": "خطة العمل",
   "respondents-count-label": "مستجيبين",
   "of-word": "من",
   "copy-tasks-title": "نسخ المهام",
   "copy-tasks-description-text":
      "سيتم نسخ جميع المهام من الجولة السابقة لضمان اكتمال خطة العمل مع مرور الوقت.",
   "previous-round-label": "الجولة السابقة:",
   "tasks-copied-label": "المهام المنسوخة",
   "task-statistics-fetch-error": "واجهنا مشكلة في تحميل إحصائيات المهام، يرجى المحاولة مرة أخرى.",
   "delete-note-confirm-text":
      "أنت على وشك حذف ملاحظة المراجعة هذه. لا يمكن التراجع عن هذا الإجراء.",
   "delete-view-title": "حذف العرض",
   "delete-view-confirm-text": "أنت على وشك حذف هذا العرض. لا يمكن التراجع عن هذا الإجراء.",
   "rename-view-title": "إعادة تسمية العرض",
   "save-button": "حفظ",
   "select-a-resource-title": "اختر مورداً",
   "set-a-reminder-title": "ضبط تذكير",
   "reminder-description-text":
      "اختر الوقت الذي تريد أن يتم تذكيرك فيه لإضافة أو تحديث ملاحظات تقدم فريقك.",
   "reminder-type-label": "نوع التذكير",
   "select-reminder-type-required-validation": "يرجى اختيار نوع التذكير",
   "select-day-required-validation": "يرجى اختيار يوم",
   "select-a-day-placeholder": "اختر يوماً",
   "reminder-repeat-prefix-text": "ستكون هذه تاريخ أول تذكير لك. ستتكرر التذكيرات المستقبلية كل",
   "repeat-interval-week": "أسبوع",
   "repeat-interval-2-weeks": "أسبوعين",
   "repeat-interval-month": "شهر",
   "repeat-interval-3-months": "3 أشهر",
   "repeat-interval-year": "سنة",
   "reminder-repeat-suffix-text": "في نفس اليوم.",
   "next-reminder-date-label": "تاريخ التذكير القادم:",
   "save-reminder-button": "حفظ التذكير",
   "my-workspaces-tab": "مساحات عملي",
   "all-workspaces-tab": "جميع مساحات العمل",
   "fetch-workspaces-error-description": "واجهنا مشكلة في جلب مساحات العمل، يرجى المحاولة مرة أخرى.",
   "archived-workspaces-title": "مساحات العمل المؤرشفة",
   "deleted-workspaces-button": "مساحات العمل المحذوفة",
   "new-workspace-button": "مساحة عمل جديدة",
   "remove-action": "إزالة",
   "workspace-name-label": "اسم مساحة العمل",
   "enter-workspace-name-placeholder": "أدخل اسم مساحة عملك",
   "workspace-description-label": "وصف مساحة العمل",
   "enter-workspace-description-placeholder": "أدخل وصف مساحة العمل",
   "workspace-countries-label": "دول مساحة العمل",
   "select-a-country-placeholder": "اختر دولة",
   "workspace-assessment-label": "تقييم مساحة العمل",
   "select-default-assessment-survey-placeholder": "اختر التقييم الافتراضي للاستبيان",
   "select-default-assessment-module-placeholder": "اختر التقييم الافتراضي للوحدة",
   "workspace-duplicate-name-validation": "توجد مساحة العمل هذه بالفعل. يرجى تجربة اسم آخر.",
   "workspace-created-success-title": "تم إنشاء مساحة العمل بنجاح!",
   "workspace-created-success-description": "تم إنشاء مساحة عمل جديدة وإضافتها إلى قاعدة بياناتك",
   "create-workspace-error-description": "واجهنا مشكلة في إنشاء مساحة العمل هذه، يرجى المحاولة مرة أخرى.",
   "add-new-workspace-title": "إضافة مساحة عمل جديدة",
   "workspace-updated-success-title": "تم تحديث مساحة العمل بنجاح!",
   "workspace-updated-success-description": "تم تحديث مساحة العمل هذه بنجاح.",
   "update-workspace-error-description": "واجهنا مشكلة في تحديث مساحة العمل هذه، يرجى المحاولة مرة أخرى.",
   "edit-workspace-title": "تعديل مساحة العمل",
   "at-least-one-assessment-required-validation": "مطلوب تقييم واحد على الأقل",
   "workspace-archived-success-title": "تم أرشفة مساحة العمل بنجاح!",
   "workspace-archived-success-description": "تمت أرشفة مساحة العمل هذه بنجاح.",
   "archive-workspace-error-description": "واجهنا مشكلة في أرشفة مساحة العمل هذه، يرجى المحاولة مرة أخرى.",
   "archive-workspace-title": "أرشفة مساحة العمل",
   "archive-workspace-confirm-text": "أنت على وشك أرشفة مساحة العمل هذه.",
   "workspace-deleted-success-title": "تم حذف مساحة العمل بنجاح!",
   "workspace-deleted-success-description": "تمت إزالة مساحة العمل هذه بنجاح.",
   "delete-workspace-error-description": "واجهنا مشكلة في حذف مساحة العمل هذه، يرجى المحاولة مرة أخرى.",
   "delete-workspace-title": "حذف مساحة العمل",
   "delete-workspace-confirm-text": "أنت على وشك حذف مساحة العمل هذه.",
   "workspace-restored-success-title": "تم استرجاع مساحة العمل بنجاح!",
   "restore-workspace-error-description": "واجهنا مشكلة في استرجاع مساحة العمل هذه، يرجى المحاولة مرة أخرى.",
   "workspace-deleted-permanently-success-description":
      "تم حذف مساحة العمل هذه بنجاح من قاعدة بياناتك.",
   "restore-assessment-error-description": "واجهنا مشكلة في استرجاع هذا التقييم، يرجى المحاولة مرة أخرى.",
   "restore-workspaces-button": "استرجاع مساحات العمل",
   "delete-workspace-permanently-title": "حذف مساحة العمل نهائياً",
   "delete-workspace-permanently-confirm-text":
      "أنت على وشك حذف مساحة العمل هذه نهائياً. لا يمكن التراجع عن هذا الإجراء.",
   "workspaces-unarchived-success-title": "تم إلغاء أرشفة مساحات العمل بنجاح!",
   "workspaces-unarchived-success-description":
      "تم إلغاء أرشفة مساحات العمل هذه وإضافتها إلى قاعدة بياناتك.",
   "unarchive-workspace-error-description":
      "واجهنا مشكلة في إلغاء أرشفة مساحة العمل هذه، يرجى المحاولة مرة أخرى.",
   "workspaces-deleted-success-title": "تم حذف مساحات العمل بنجاح!",
   "workspaces-deleted-success-description": "تم حذف مساحات العمل هذه من قاعدة بياناتك.",
   "deleted-workspaces-list-title": "قائمة مساحات العمل المحذوفة",
   "deleted-workspaces-retention-text":
      "هنا يمكنك عرض واسترجاع مساحات العمل المحذوفة. أي مساحة عمل لم يتم استرجاعها في غضون 60 يوماً سيتم حذفها نهائياً.",
   "request-canceled-success-title": "تم إلغاء الطلب بنجاح!",
   "request-canceled-success-description": "تم إلغاء طلبك.",
   "cancel-request-error-description": "واجهنا مشكلة في إلغاء هذا الطلب، يرجى المحاولة مرة أخرى.",
   "cancel-request-button": "إلغاء الطلب",
   "send-request-success-description":
      "تم إرسال طلبك إلى المسؤول. بمجرد الرد على الطلب، ستتلقى بريداً إلكترونياً.",
   "send-request-error-description": "واجهنا مشكلة في إرسال طلبك، يرجى المحاولة مرة أخرى.",
   "no-workspaces-here-title": "لا توجد مساحات عمل هنا!",
   "request-part-workspace-description":
      "لكن لا تقلق، يمكنك طلب الانضمام إلى مساحة عمل من قسم «جميع مساحات العمل».",
   "go-to-all-workspaces-button": "الانتقال إلى جميع مساحات العمل",
   "create-workspaces-tagline-text": "أنشئ مساحات عمل مصممة لتعزيز نمو المؤسسات وتحسينها.",
   "export-workspaces-button": "تصدير مساحات العمل",
   "all-workspaces-consultant-heading": "جميع مساحات العمل",
   "assess-partners-consultant-description":
      "ابدأ بتقييم الشركاء/المنظمات غير الحكومية المحلية وقدم لهم تقريراً مفصلاً عن أدائهم الحالي.",
   "access-workspace-organization-text": "ادخل إلى مساحة عمل وابدأ بالوصول إلى مؤسستك.",
   "no-workspace-created-yet-description":
      "يبدو أنك لم تقم بإنشاء أي مساحة عمل حتى الآن. لكن لا تقلق، يمكنك إنشاءها هنا.",
   "untitled-label": "بدون عنوان",
   "no-section-label": "بدون قسم",
   "swot-analysis-title": "تحليل SWOT",
   "swot-analysis-subtitle-text": "حلل نقاط القوة والضعف والفرص والتهديدات",
   "related-module-label": "الوحدة المرتبطة",
   "select-module-placeholder": "اختر الوحدة",
   "enter-analysis-description-placeholder": "أدخل وصف التحليل",
   "swot-strengths-title": "نقاط القوة",
   "swot-weaknesses-title": "نقاط الضعف",
   "swot-opportunities-title": "الفرص",
   "swot-threats-title": "التهديدات",
   "related-sections-label": "الأقسام المرتبطة",
   "select-sections-placeholder": "اختر الأقسام",
   "analysis-label": "التحليل",
   "describe-strengths-placeholder": "صف نقاط القوة",
   "describe-weaknesses-placeholder": "صف نقاط الضعف",
   "describe-opportunities-placeholder": "صف الفرص",
   "describe-threats-placeholder": "صف التهديدات",
   "add-analysis-button": "إضافة تحليل",
   "scores-label": "الدرجات",
   "guided-assessment-label": "التقييم الموجه",
   "self-assessment-label": "التقييم الذاتي",
   "highlights-title": "أبرز النقاط",
   "highlights-subtitle-text": "أبرز النتائج الرئيسية وقدم توصيات بناءً على النتائج",
   "choose-chart-analyze-label": "اختر الرسم البياني الذي تريد تحليله",
   "select-chart-analyze-text": "اختر الرسم البياني الذي تريد تحليله",
   "change-button": "تغيير",
   "select-a-module-first-placeholder": "اختر وحدة أولاً",
   "add-comparison-label": "إضافة مقارنة",
   "insight-label": "الرؤية",
   "max-400-characters-validation": "الحد الأقصى 400 حرف",
   "describe-key-points-placeholder":
      "صف النقاط الرئيسية التي تريد تسليط الضوء عليها من هذا الرسم البياني...",
   "select-chart-to-analyze-title": "اختر رسماً بيانياً لتحليله",
   "choose-chart-from-list-text": "اختر أحد الرسوم البيانية المتاحة من القائمة لتحليله.",
   "report-title": "التقرير",
   "upload-report-insights-text": "قم بتحميل تقريرك ليصبح جزءاً من الرؤى الخاصة بهذا التقييم.",
   "upload-file-here-label": "قم بتحميل الملف هنا",
   "current-file-text": "الملف الحالي",
   "remove-file-aria-label": "إزالة الملف",
   "doc-pdf-pptx-text": "DOC أو PDF أو PPTX",
   "only-doc-pdf-pptx-error": "يُسمح فقط بملفات DOC أو PDF أو PPTX.",
   "file-must-be-smaller-than-prefix": "يجب أن يكون حجم الملف أصغر من",
   "missing-assessment-org-warning": "تفاصيل التقييم أو المؤسسة مفقودة.",
   "upload-report-file-warning": "يرجى تحميل ملف التقرير.",
   "title-required-validation": "العنوان مطلوب",
   "ticket-type-required-validation": "نوع التذكرة مطلوب",
   "message-required-validation": "الرسالة مطلوبة",
   "ticket-added-success-title": "تمت إضافة التذكرة بنجاح!",
   "ticket-added-success-description":
      "تمت إضافة هذه التذكرة بنجاح إلى قاعدة بيانات سجل تذاكرك، سيقوم شخص ما بالرد على طلبك قريباً جداً.",
   "add-ticket-error-description": "واجهنا مشكلة في إضافة هذه التذكرة، يرجى المحاولة مرة أخرى.",
   "upload-jpg-png-gif-webp-error": "يرجى تحميل ملفات JPG أو PNG أو GIF أو WEBP فقط.",
   "add-new-ticket-title": "إضافة تذكرة جديدة",
   "ticket-type-label": "نوع التذكرة",
   "select-ticket-type-placeholder": "اختر نوع التذكرة",
   "summary-label": "الملخص",
   "enter-title-placeholder": "أدخل العنوان",
   "describe-problem-detail-label": "صف المشكلة بالتفصيل",
   "type-something-placeholder": "اكتب شيئاً هنا",
   "attach-evidence-label": "أرفق أي دليل تعتبره مهماً",
   "jpg-png-gif-webp-text": "JPG و PNG و GIF و WEBP",
   "add-ticket-button": "إضافة تذكرة",
   "tickets-deleted-success-title": "تم حذف التذاكر المحددة بنجاح!",
   "tickets-deleted-success-description": "تم حذف هذه التذاكر المحددة بنجاح من قاعدة البيانات",
   "delete-tickets-error-description": "واجهنا مشكلة في حذف هذه التذاكر المحددة، يرجى المحاولة مرة أخرى.",
   "delete-selected-tickets-title": "حذف التذاكر المحددة",
   "delete-selected-tickets-confirm-text": "أنت على وشك حذف هذه التذاكر المحددة.",
   "collection-updated-success-title": "تم تحديث المجموعة بنجاح!",
   "collection-updated-success-description": "تم تحديث هذه المجموعة بشكل صحيح.",
   "update-collection-error-description": "واجهنا مشكلة في تحديث هذه المجموعة، يرجى المحاولة مرة أخرى.",
   "collection-added-success-title": "تمت إضافة المجموعة بنجاح!",
   "collection-added-success-description": "تم إنشاء هذه المجموعة وإضافتها إلى قاعدة بياناتك.",
   "add-collection-error-description": "واجهنا مشكلة في إضافة هذه المجموعة، يرجى المحاولة مرة أخرى.",
   "edit-collection-title": "تعديل المجموعة",
   "add-new-collection-title": "إضافة مجموعة جديدة",
   "new-collection-button-label": "مجموعة جديدة",
   "name-collection-label": "اسم المجموعة",
   "enter-collection-name-placeholder": "أدخل اسم المجموعة",
   "enter-collection-description-placeholder": "أدخل وصف المجموعة",
   "select-the-assessment-label": "اختر التقييم",
   "select-resources-collection-placeholder": "اختر الموارد المرتبطة بهذه المجموعة",
   "see-more-text": "عرض المزيد",
   "make-collection-public-label": "اجعل هذه المجموعة عامة وظاهرة لجميع المستخدمين",
   "add-collection-button": "إضافة مجموعة",
   "global-status": "عام",
   "owner-colon-label": "المالك:",
   "resources-colon-label": "الموارد:",
   "resource-added-collection-success-title": "تمت إضافة المورد إلى المجموعة!",
   "resource-added-collection-success-description": "تمت إضافة هذا المورد بنجاح إلى المجموعة.",
   "add-resource-collection-error-description":
      "واجهنا مشكلة في إضافة هذا المورد إلى المجموعة، يرجى المحاولة مرة أخرى.",
   "add-to-collection-title": "إضافة إلى المجموعة",
   "resource-updated-success-title": "تم تحديث المورد بنجاح!",
   "resource-updated-success-description": "تم تحديث هذا المورد بشكل صحيح. تم إنشاء نسخة جديدة",
   "update-resource-error-description": "واجهنا مشكلة في تحديث هذا المورد، يرجى المحاولة مرة أخرى.",
   "resource-added-success-title": "تمت إضافة المورد بنجاح!",
   "resource-added-success-description": "تم إنشاء هذا المورد وإضافته إلى قاعدة بياناتك.",
   "add-resource-error-description": "واجهنا مشكلة في إضافة هذا المورد، يرجى المحاولة مرة أخرى.",
   "edit-resource-title": "تعديل المورد",
   "select-resource-type-label": "اختر نوع المورد",
   "select-resource-type-required-validation": "يرجى اختيار نوع المورد",
   "video-placeholder-text": "فيديو",
   "select-type-before-upload-text": "قبل تحميل مورد يجب عليك اختيار نوعه",
   "enter-resource-link-label": "يرجى إدخال رابط المورد هنا",
   "valid-url-required-validation": "يرجى إدخال رابط صحيح",
   "enter-resource-link-placeholder": "أدخل رابط موردك",
   "select-a-file-required-validation": "يرجى اختيار ملف",
   "click-to-select-files-text": "انقر لتحديد الملفات",
   "resource-version-colon-label": "إصدار المورد:",
   "make-resource-private-label": "اجعل هذا المورد خاصاً",
   "resource-name-label": "اسم المورد",
   "enter-resource-name-placeholder": "أدخل اسم المورد",
   "tags-label": "العلامات",
   "enter-resource-tags-placeholder": "أدخل المواضيع التي يمكن ربط هذا المورد بها",
   "select-module-label": "اختر الوحدة",
   "select-section-label": "اختر القسم",
   "upload-consent-text":
      "سيتم تخزين أي مورد تقوم بتحميله في مستودع KAPorg وفقاً لمستوى الظهور الذي تختاره، مما يجعله متاحاً للجمهور المحدد. بالمتابعة، فإنك تؤكد أنك تملك الحقوق والأذونات اللازمة لتحميل هذه المادة.",
   "add-resource-button": "إضافة مورد",
   "file-label": "الملف",
   "views-suffix": "مشاهدات",
   "rating-suffix": "التقييم",
   "owner-label": "المالك",
   "visibility-label": "الظهور",
   "linked-to-label": "مرتبط بـ",
   "last-update-date-label": "تاريخ آخر تحديث",
   "resource-version-label": "إصدار المورد",
   "targets-updated-success-title": "تم تحديث الأهداف بنجاح!",
   "targets-updated-success-description": "تم حفظ جميع التغييرات بنجاح.",
   "save-targets-error-description": "واجهنا مشكلة في حفظ جميع التغييرات، يرجى المحاولة مرة أخرى.",
   "current-target-label": "الهدف الحالي:",
   "no-active-rounds-text": "لا توجد جولات نشطة",
   "no-target-set-yet-text": "لم يتم تحديد هدف بعد",
   "no-assessments-found-text": "لم يتم العثور على تقييمات",
   "no-modules-yet-title": "لا توجد وحدات حتى الآن",
   "no-modules-assigned-description": "لا يحتوي هذا التقييم على وحدات مخصصة. ستظهر هنا بعد إضافتها.",
   "enter-target-placeholder": "أدخل الهدف",
   "ticket-history-title": "سجل التذاكر",
   "help-desk-title": "مكتب المساعدة",
   "delete-selected-rows-text": "حذف الصفوف المحددة",
   "add-new-ticket-text": "تذكرة جديدة",
   "subject-column": "الموضوع",
   "creation-date-column": "تاريخ الإنشاء",
   "organization-column": "المؤسسة",
   "last-response-column": "آخر رد",
   "ticket-preview-title": "معاينة التذكرة",
   "ticket-status-closed": "مغلق",
   "ticket-summary-title": "ملخص التذكرة",
   "user-email-label": "البريد الإلكتروني للمستخدم",
   "ticket-subject-label": "موضوع التذكرة",
   "mark-as-resolved-button": "إغلاق التذكرة",
   "mark-ticket-resolved-title": "هل تريد إغلاق هذه التذكرة؟",
   "mark-ticket-resolved-confirm-text": "هل أنت متأكد من أنك تريد إغلاق هذه التذكرة؟ لا يزال بإمكان المنظمة الرد إذا احتاجت إلى مساعدة إضافية.",
   "ticket-resolved-success-title": "تم إغلاق التذكرة",
   "ticket-resolved-success-description": "تم إغلاق التذكرة.",
   "resolve-ticket-error-description": "حدث خطأ أثناء إغلاق التذكرة. يرجى المحاولة مرة أخرى.",
   "type-your-message-placeholder": "اكتب رسالتك هنا...",
   "filter-tickets-by-type-placeholder": "تصفية حسب النوع",
   "filter-tickets-by-status-placeholder": "تصفية حسب الحالة",
   "summary-results-title": "ملخص النتائج",
   "graphs-view-tab": "عرض الرسوم البيانية",
   "table-view-tab": "عرض الجدول",
   "expert-insights-tab": "رؤى الخبراء",
   "no-dashboard-results-yet-title": "لا توجد نتائج في لوحة التحكم هذه حتى الآن",
   "results-appear-here-description": "عندما تصبح البيانات متاحة، ستظهر نتائجك هنا.",
   "submission-round-column": "جولة التقديم",
   "submission-label-column": "تسمية التقديم",
   "select-module-first-text": "يرجى اختيار وحدة أولاً.",
   "select-at-least-one-submission-round-text": "يرجى اختيار جولة تقديم واحدة على الأقل.",
   "unable-detect-organization-text": "تعذر تحديد مؤسستك. يرجى تسجيل الدخول مرة أخرى.",
   "download-table-label": "تحميل الجدول",
   "score-overview-title": "نظرة عامة على النتيجة",
   "toggle-score-overview-aria-label": "تبديل نظرة عامة على النتيجة",
   "visualizations-title": "التصورات البيانية",
   "search-a-graph-placeholder": "البحث عن رسم بياني",
   "select-view-placeholder": "اختر العرض",
   "save-view-button": "حفظ العرض",
   "save-dashboard-button": "حفظ لوحة التحكم",
   "edit-dashboard-button": "تعديل لوحة التحكم",
   "download-dashboard-label": "تحميل لوحة التحكم",
   "round-label": "الجولة",
   "manager-label": "المدير",
   "select-an-organization-placeholder": "اختر مؤسسة",
   "select-all-option": "تحديد الكل",
   "all-placeholder": "الكل",
   "score-percent-label": "الدرجة (%)",
   "task-completion-percent-label": "إتمام المهام (%)",
   "task-status-percent-label": "حالة المهام (%)",
   "value-label": "القيمة",
   "first-round-label": "الجولة الأولى",
   "second-round-label": "الجولة الثانية",
   "improvement-percent-label": "التحسن %",
   "result-label": "النتيجة",
   "current-label": "الحالي",
   "target-word": "الهدف",
   "overall-score-label": "الدرجة الإجمالية",
   "of-tasks-completed-label": "من المهام المكتملة",
   "leading-label": "متقدم",
   "developing-label": "قيد التطور",
   "lagging-label": "متأخر",
   "section-word": "القسم",
   "task-completion-label": "إتمام المهام",
   "indicator-word": "المؤشر",
   "progress-word": "التقدم",
   "current-round-label": "الجولة الحالية:",
   "change-label": "التغيير:",
   "improvement-label": "التحسن",
   "task-count-label": "عدد المهام",
   "assessment-results-per-module-title": "نتائج التقييم حسب الوحدة",
   "assessment-results-per-section-title": "نتائج التقييم حسب القسم",
   "performance-map-title": "خريطة الأداء",
   "assessment-results-per-organization-title": "نتائج التقييم حسب المؤسسة",
   "module-results-per-organization-title": "نتائج الوحدة حسب المؤسسة",
   "section-results-per-organization-title": "نتائج القسم حسب المؤسسة",
   "assessment-targets-per-organization-title": "أهداف التقييم حسب المؤسسة",
   "module-targets-per-organization-title": "أهداف الوحدة حسب المؤسسة",
   "section-targets-per-organization-title": "أهداف القسم حسب المؤسسة",
   "improvement-tracker-per-organization-title": "متتبع التحسن حسب المؤسسة",
   "target-score-task-progress-per-organization-title": "الهدف والنتيجة وتقدم المهام حسب المؤسسة",
   "assessment-results-per-round-title": "نتائج التقييم حسب الجولة",
   "module-results-per-round-title": "نتائج الوحدة حسب الجولة",
   "section-results-per-round-title": "نتائج القسم حسب الجولة",
   "assessment-targets-per-round-title": "أهداف التقييم حسب الجولة",
   "module-targets-per-round-title": "أهداف الوحدة حسب الجولة",
   "section-targets-per-round-title": "أهداف القسم حسب الجولة",
   "improvement-tracker-per-assessment-title": "متتبع التحسن حسب التقييم",
   "target-score-task-progress-per-assessment-title": "الهدف والنتيجة وتقدم المهام حسب التقييم",
   "radar-chart-type-label": "مخطط راداري",
   "tier-list-type-label": "قائمة المستويات",
   "score-progress-across-rounds-title": "تطور النتيجة عبر الجولات",
   "module-score-progress-across-rounds-title": "تطور نتيجة المحاور عبر الجولات",
   "bar-chart-type-label": "مخطط شريطي",
   "table-type-label": "جدول",
   "modules-word": "الوحدات",
   "sections-word": "الأقسام",
   "task-status-per-assessment-title": "حالة المهام حسب التقييم",
   "module-task-completion-title": "إتمام مهام الوحدة",
   "section-task-completion-title": "إتمام مهام القسم",
   "task-completion-per-organization-title": "إتمام المهام حسب المؤسسة",
   "improvement-tracker-title": "متتبع التحسن",
   "donut-chart-type-label": "مخطط دائري (دونات)",
   "task-updated-success-message": "تم تحديث المهمة بنجاح.",
   "task-added-success-message": "تمت إضافة المهمة بنجاح.",
   "export-tasks-error-message": "حدثت مشكلة في تصدير المهام، يرجى المحاولة مرة أخرى.",
   "tasks-copied-success-title": "تم نسخ المهام بنجاح!",
   "tasks-copied-success-description": "تم نسخ جميع المهام من الجولة السابقة إلى الجولة الحالية.",
   "results-not-yet-approved-title": "النتائج لم تتم الموافقة عليها بعد!",
   "results-not-yet-approved-description": "يمكن نسخ المهام فقط بعد أن تحصل جميع وحدات هذا التقييم على موافقة على التقديمات. يرجى الموافقة على تقديماتك قبل نسخ المهام.",
   "tasks-already-copied-title": "تم نسخ المهام مسبقاً لهذه الجولة",
   "tasks-already-copied-description": "يمكن نسخ المهام مرة واحدة فقط في كل جولة. إذا كانت تنقصك مهام، يرجى التواصل مع المسؤول.",
   "copy-tasks-error-title": "عفواً! حدثت مشكلة!",
   "copy-tasks-error-description": "حدثت مشكلة في نسخ المهام من الجولة السابقة، يرجى المحاولة مرة أخرى.",
   "resource-label-colon": "المصدر:",
   "edit-module-alt-text": "تعديل الوحدة",
   "delete-module-alt-text": "حذف الوحدة",
   "task-status-updated-message": "تم تحديث حالة المهمة.",
   "failed-update-task-status-message": "فشل تحديث حالة المهمة.",
   "plan-summary-title": "ملخص الخطة",
   "select-organization-to-view-plan-text": "اختر مؤسسة أعلاه لعرض ملخص خطتها.",
   "select-organization-placeholder": "اختر المؤسسة",
   "previous-round-readonly-notice-text": "هذه جولة سابقة وهي للقراءة فقط للحفاظ على بياناتها. يمكنك إجراء التغييرات فقط في الجولة الحالية.",
   "viewing-previous-round-button": "أنت تشاهد جولة سابقة",
   "go-to-current-round-button": "الانتقال إلى الجولة الحالية",
   "staff-member-label": "عضو الفريق",
   "export-plan-button": "تصدير الخطة",
   "task-column-header": "المهمة",
   "responsible-column-header": "المسؤول",
   "due-date-column-header": "تاريخ الاستحقاق",
   "see-less-link": "عرض أقل",
   "see-all-link": "عرض الكل",
   "no-linked-questions-text": "لا توجد أسئلة مرتبطة",
   "resources-label-colon": "الموارد:",
   "no-tasks-for-staff-member-text": "لم يتم العثور على مهام لعضو الفريق المحدد",
   "add-tasks-improve-score-text": "أضف مهام إلى هذا المؤشر لتحسين نتيجتك",
   "result-label-colon": "النتيجة:",
   "target-label-colon": "الهدف:",
   "review-note-added-success-description": "تمت إضافة ملاحظة المراجعة بنجاح.",
   "reminder-set-title": "تم تعيين التذكير",
   "reminder-scheduled-success-description": "تمت جدولة تذكيرك بنجاح.",
   "review-notes-title": "ملاحظات المراجعة",
   "set-reminder-button": "تعيين تذكير",
   "print-summary-button": "طباعة الملخص",
   "export-notes-button": "تصدير الملاحظات",
   "note-word": "ملاحظة",
   "no-note-created-yet-text": "لم يتم إنشاء أي ملاحظة بعد.",
   "no-review-notes-available-text": "لا توجد ملاحظات مراجعة متاحة.",
   "no-score-selected-text": "لم يتم تحديد نتيجة",
   "filters-colon-label": "الفلاتر:",
   "none-word": "لا يوجد",
   "graph-word": "الرسم البياني",
   "no-chart-content-text": "لا يوجد محتوى للرسم البياني",
   "filter-colon-label": "الفلتر:",
   "action-plan-word": "خطة العمل",
   "results-word": "النتائج",
   "no-charts-available-title": "لا توجد رسوم بيانية متاحة",
   "no-charts-data-export-text": "لا توجد رسوم بيانية تحتوي على بيانات متاحة للتصدير.",
   "summary-action-plan-dashboard-title": "ملخص لوحة خطة العمل",
   "summary-results-dashboard-title": "ملخص لوحة النتائج",
   "assessment-colon-label": "التقييم:",
   "assessment-word": "التقييم",
   "download-svg-action": "تحميل SVG",
   "download-png-action": "تحميل PNG",
   "included-in-report-tooltip-text": "يتم تضمينه عند إنشاء التقرير",
   "no-visualization-selected-text": "لم يتم تحديد أي تصور",
   "drop-visualization-here-text": "أفلت التصور هنا",
   "add-graph-button": "إضافة رسم بياني",
   "delete-block-tooltip-text": "حذف الكتلة",
   "no-filters-selected-text": "لم يتم تحديد فلاتر",
   "filters-word": "الفلاتر",
   "untitled-graph-text": "رسم بياني بدون عنوان",
   "graph-preview-unavailable-text": "معاينة الرسم البياني غير متوفرة",
   "filter-word": "الفلتر",
   "global-suffix-label": "(عام)",
   "organization-word": "المؤسسة",
   "staff-word": "الموظفون",
   "generic-problem-occurred-title": "عفواً! حدثت مشكلة",
   "view-saved-success-title": "تم حفظ العرض بنجاح!",
   "view-saved-success-description": "تم حفظ عرض لوحتك بنجاح.",
   "problem-saving-view-description": "حدثت مشكلة في حفظ هذا العرض، يرجى المحاولة مرة أخرى.",
   "select-view-before-rename-text": "حدد عرضاً قبل إعادة تسميته.",
   "select-view-before-delete-text": "حدد عرضاً قبل حذفه.",
   "view-deleted-success-title": "تم حذف العرض بنجاح!",
   "view-deleted-success-description": "تم حذف العرض المحدد من لوحتك.",
   "problem-deleting-view-description": "حدثت مشكلة في حذف هذا العرض، يرجى المحاولة مرة أخرى.",
   "view-renamed-success-title": "تم إعادة تسمية العرض بنجاح!",
   "view-renamed-success-description": "تم تحديث اسم العرض المحدد بنجاح.",
   "problem-renaming-view-description": "حدثت مشكلة في إعادة تسمية هذا العرض، يرجى المحاولة مرة أخرى.",
   "view-word": "العرض",
   "compare-with-self-assessment-label": "المقارنة مع التقييم الذاتي",
   "comparison-limited-one-org-text": "تقتصر هذه المقارنة على مؤسسة واحدة في كل مرة",
   "assessment-not-linked-self-text": "هذا التقييم غير مرتبط بتقييم ذاتي",
   "dashboard-word": "لوحة التحكم",
   "self-assessments-menu-item": "التقييمات الذاتية",
   "guided-assessments-menu-item": "التقييمات الموجهة",
   "module-request-menu-item": "طلب وحدة",
   "action-plan-menu-item": "خطة العمل",
   "my-performance-menu-item": "أدائي",
   "task-management-menu-item": "إدارة المهام",
   "resources-menu-item": "الموارد",
   "organization-management-menu-item": "إدارة المؤسسة",
   "quick-search-tooltip-text": "بحث سريع",
   "notifications-tooltip-text": "الإشعارات",
   "help-desk-word": "مكتب المساعدة",
   "go-back-previous-menu-text": "العودة إلى القائمة السابقة",
   "go-back-to-action-plan-link": "العودة إلى خطة العمل",
   "go-back-to-module-list-link": "العودة إلى قائمة الوحدات",
   "go-back-to-modules-list-link": "العودة إلى قائمة الوحدات",
   "go-back-to-templates-list-link": "العودة إلى قائمة القوالب",
   "go-back-to-action-plan-section-link": "العودة إلى قسم خطة العمل",
   "go-back-to-assessment-link": "العودة إلى التقييم",
   "go-back-to-assessments-link": "العودة إلى التقييمات",
   "go-back-to-assigned-modules-list-link": "العودة إلى قائمة الوحدات المخصصة",
   "go-back-to-approved-modules-list-link": "العودة إلى قائمة الوحدات المعتمدة",
   "go-back-to-pending-modules-list-link": "العودة إلى قائمة الوحدات المعلقة",
   "go-back-to-guided-assessment-link": "العودة إلى التقييم الموجه",
   "go-back-to-guided-assessment-list-link": "العودة إلى قائمة التقييمات الموجهة",
   "go-back-to-workspaces-link": "العودة إلى مساحات العمل",
   "profile-preview-alt-text": "معاينة الملف الشخصي",
   "org-role-abbreviation": "مؤسسة",
   "role-super-admin-label": "المشرف العام",
   "role-consultant-label": "مستشار",
   "role-donor-label": "المتبرع",
   "role-national-organization-label": "منظمة وطنية",
   "role-international-organization-label": "منظمة دولية",
   "male-label": "ذكر",
   "female-label": "أنثى",
   "no-self-assessments-here-text": "لا توجد تقييمات ذاتية هنا",
   "no-guided-assessments-here-text": "لا توجد تقييمات موجهة هنا",
   "self-assessment-panel-title": "تقييم ذاتي",
   "guided-assessment-panel-title": "تقييم موجه",
   "sort-progress-by-label": "ترتيب التقدم حسب:",
   "highest-to-lowest-option": "من الأعلى إلى الأدنى",
   "lowest-to-highest-option": "من الأدنى إلى الأعلى",
   "modules-count-suffix": "وحدات",
   "answer-pending-status": "في انتظار الإجابة",
   "unlock-assessment-text": "إلغاء قفل التقييم",
   "select-assessment-see-results-text": "حدد تقييماً لعرض نتائجه بالتفصيل.",
   "linked-badge-label": "مرتبط",
   "no-assessments-available-title": "لا توجد تقييمات متاحة.",
   "start-adding-view-results-text": "ابدأ بإضافة واحد لعرض النتائج المجمعة.",
   "assessment-selected-suffix": "تقييم محدد",
   "action-plan-panel-description-text": "هنا ستجد خطة عمل بناءً على نتائجك في كل تقييم.",
   "select-one-see-plan-detail-text": "حدد واحداً لعرض الخطة بالتفصيل.",
   "search-for-assessment-placeholder": "البحث عن تقييم",
   "areas-to-improve-label": "الوحدات المراد تحسينها:",
   "no-assessments-here-text": "لا توجد تقييمات هنا!",
   "selected-assessment-title": "التقييم المحدد",
   "no-assessment-selected-text": "لم يتم تحديد أي تقييم",
   "number-of-resources-label": "عدد الموارد:",
   "areas-in-label": "المجالات:",
   "indicators-to-improve-label": "المؤشرات المراد تحسينها:",
   "no-data-available-to-display-text": "لا توجد بيانات متاحة للعرض.",
   "self-evaluate-screen-description-text": "تتيح لك هذه الشاشة تقييم نفسك بناءً على الاستبيانات التي أكملتها",
   "maximum-organizations-warning-text": "الحد الأقصى 5 مؤسسات!",
   "search-organization-placeholder": "بحث عن مؤسسة",
   "sort-order-tooltip-text": "ترتيب",
   "get-results-tooltip-text": "الحصول على النتائج",
   "report-word": "التقرير",
   "capacity-gaps-title": "فجوات القدرات",
   "capacity-gaps-description-text": "الوحدات والأقسام القوية والضعيفة، وكيفية أدائها مقارنةً بأهدافها.",
   "performance-overview-title": "نظرة عامة على الأداء",
   "performance-overview-description-text": "أين تقف المجموعة في هذه الجولة: نتائج المؤسسات، وكيفية توزعها عبر فئات النتائج في التقييم، وكيف تقارن بهدف الجولة.",
   "progress-across-rounds-title": "التقدم عبر الجولات",
   "progress-across-rounds-description-text": "أين وصلت المجموعة في هذه الجولة على مستوى القسم، وكيف تحركت كل مؤسسة منذ الجولة السابقة — من تحسن، ومن تراجع، وبكم.",
   "action-plan-status-title": "حالة خطة العمل",
   "action-plan-status-description-text": "إتمام المهام لكل مؤسسة للجولة المحددة، وكيف يرتبط ذلك بتحقيق الهدف.",
   "score-band-deficient": "ضعيف جداً",
   "score-band-insufficient": "غير كافٍ",
   "score-band-satisfactory": "مُرضٍ",
   "score-band-very-good": "جيد جداً",
   "score-band-excellent": "ممتاز",
   "module-rejected-success-description": "تم رفض الوحدة بنجاح",
   "failed-reject-module-description": "فشل رفض هذه الوحدة",
   "module-accepted-success-description": "تم قبول الوحدة بنجاح",
   "failed-accept-module-description": "فشل قبول هذه الوحدة",
   "module-requests-title": "طلبات الوحدات",
   "pending-modules-review-description-text": "هذه قائمة الوحدات في انتظار مراجعتك. للمتابعة، يرجى النقر على كل وحدة حيث ستتمكن من قبولها أو رفضها.",

   // Login / Registration pages
   "welcome-back-title": "مرحبًا بعودتك!",
   "login-into-account-subtitle": "تسجيل الدخول إلى حسابك",
   "email-placeholder": "yourmail@gmail.com",
   "password-label": "كلمة المرور",
   "toggle-password-visibility-label": "إظهار/إخفاء كلمة المرور",
   "remember-me-label": "تذكرني؟",
   "log-in-button": "تسجيل الدخول",
   "no-account-yet-text": "ليس لديك حساب بعد؟",
   "sign-up-link": "إنشاء حساب",
   "max-16-symbols-validation": "الحد الأقصى 16 رمزًا",
   "go-back-icon-alt": "رجوع",
   "go-back-to-login-link": "العودة إلى تسجيل الدخول",
   "welcome-to-kaporg-title": "مرحبًا بك في KAPorg!",
   "which-profile-title": "أي ملف تعريف يصفك بشكل أفضل؟",
   "profile-organization-label": "منظمة",
   "profile-donors-label": "جهات مانحة",
   "profile-expert-label": "خبير",
   "signup-role-title": "كيف ستستخدم KAPorg؟",
   "signup-role-subtitle": "اختر الدور الذي يتوافق مع مسؤولياتك.",
   "profile-donor-label": "جهة مانحة",
   "signup-role-organization-description": "بناء قدرات مؤسسية مستدامة",
   "signup-role-donor-description": "الإشراف على أداء المحفظة المؤسسية",
   "signup-role-expert-description": "تقديم توجيه استراتيجي مستقل",
   "signup-create-account-as-an": "أنشئ حسابًا بصفة",
   "signup-create-account-as-a": "أنشئ حسابًا بصفة",
   "showcase-login-headline": "نمكّن المؤسسات من قيادة [[تنمية القدرات]]",
   "showcase-organization-headline": "قيّم قدراتك و[[عزّز رسالتك]]",
   "showcase-donor-headline": "أشرف على أداء المحفظة و[[حقّق نتائج قابلة للقياس]]",
   "showcase-expert-headline": "قدّم التوجيه الاستراتيجي و[[ارتقِ بالقدرات المؤسسية]]",
   "signup-step-profile": "الملف الشخصي",
   "signup-step-expertise": "الخبرة",
   "profile-details-title": "تفاصيل الملف الشخصي",
   "upload-photo-text": "تحميل صورة",
   "adjust-your-photo-title": "اضبط صورتك",
   "change-photo-text": "تغيير الصورة",
   "signup-step-account": "الحساب",
   "signup-step-contact": "التواصل",
   "enter-organization-email-placeholder": "أدخل البريد الإلكتروني للمؤسسة",
   "code-must-have-6-digits-validation": "يجب أن يتكون الرمز من 6 أرقام",
   "code-incorrect-text": "الرمز غير صحيح",
   "confirmation-email-shortly-text": "ستتلقى رسالة تأكيد عبر البريد الإلكتروني قريبًا",
   "go-to-homepage-button": "الذهاب إلى الصفحة الرئيسية",
   "didnt-get-email-text": "لم تصلك الرسالة؟ تحقق من مجلد الرسائل غير المرغوب فيها أو راسلنا على",
   "language-selector-label": "اختر اللغة",
   "auth-tagline-transforming-title": "تحويل بناء القدرات",
   "auth-tagline-transforming-description": "لعصر رقمي",
   "auth-tagline-elevate-title": "ارتقِ بمنظمتك",
   "auth-tagline-elevate-description": "من خلال تقييم هادف!",
   "auth-tagline-changemakers-title": "تواصل مع صانعي التغيير",
   "auth-tagline-changemakers-description": "الذين هم بأمس الحاجة إليك.",
   "auth-tagline-miss-you-title": "سنشتاق إليك،",
   "auth-tagline-miss-you-description": "نأمل أن نرحب بعودتك قريبًا.",
   "auth-tagline-collaborations-title": "انغمس في عالم من",
   "auth-tagline-collaborations-description": "التعاون المؤثر!",
   "auth-tagline-expertise-title": "خبرتك",
   "auth-tagline-expertise-description": "ورؤاك تدفعان التقدم!",

   // National organization registration form
   "go-back-to-profile-selection-link": "العودة إلى اختيار الملف الشخصي",
   "create-account-title": "إنشاء حساب",
   "as-an-org-label": "كمنظمة",
   "login-details-title": "بيانات تسجيل الدخول",
   "confirm-password-label": "تأكيد كلمة المرور",
   "type-description-placeholder": "اكتب الوصف",
   "working-sectors-label": "قطاعات العمل",
   "enter-organization-name-placeholder": "أدخل اسم المنظمة",
   "enter-organization-address-placeholder": "أدخل عنوان المنظمة",
   "enter-organization-zip-code-placeholder": "أدخل الرمز البريدي للمنظمة",
   "terms-agreement-prefix-text": "لقد قرأت ووافقت على",
   "terms-of-service-privacy-policy-link": "شروط الخدمة وسياسة الخصوصية",
   "and-conjunction-text": "و",
   "cookie-policy-link": "سياسة ملفات تعريف الارتباط.",
   "invalid-email-address-validation": "البريد الإلكتروني غير صالح",
   "password-min-length-validation": "يجب أن تتكون كلمة المرور من 8 أحرف على الأقل",
   "password-complexity-validation": "يجب أن تحتوي كلمة المرور على حرف كبير واحد على الأقل، ورقم واحد، وأحد الرموز المحددة !، @، #، $، %، ^، &، *",
   "password-required-validation": "كلمة المرور مطلوبة",
   "passwords-must-match-validation": "يجب أن تتطابق كلمتا المرور",
   "confirm-password-required-validation": "تأكيد كلمة المرور مطلوب",
   "organization-name-required-validation": "اسم المنظمة الدولية مطلوب",
   "foundation-year-required-validation": "سنة التأسيس مطلوبة",
   "sectors-min-validation": "يجب اختيار قطاع واحد على الأقل",
   "sectors-required-validation": "القطاعات مطلوبة",
   "organization-address-required-validation": "عنوان المنظمة مطلوب",
   "invalid-organization-email-validation": "البريد الإلكتروني للمنظمة غير صالح",
   "organization-email-required-validation": "البريد الإلكتروني للمنظمة مطلوب",
   "accept-terms-required-validation": "يجب عليك قبول الشروط والأحكام",

   // Donor registration form
   "as-an-international-donor-label": "كمانح دولي",
   "donor-organization-name-required-validation": "اسم المنظمة مطلوب",
   "invitation-code-label": "رمز الدعوة",
   "enter-invitation-code-placeholder": "أدخل رمز الدعوة الخاص بك",
   "invitation-code-min-length-validation": "يجب أن يتكون رمز الدعوة من 12 حرفًا على الأقل",
   "invitation-code-required-validation": "رمز الدعوة مطلوب",
   "invalid-invitation-code-format-validation": "تنسيق رمز الدعوة غير صالح",
   "no-invitation-code-help-text": "إذا لم يكن لديك رمز دعوة، يرجى إرسال بريد إلكتروني إلينا هنا:",

   // Terms/Conditions modal
   "close-icon-alt": "إغلاق",
   "terms-of-service-tab-label": "شروط الخدمة",
   "privacy-policy-tab-label": "سياسة الخصوصية",
   "cookie-policy-tab-label": "سياسة ملفات تعريف الارتباط",
   "got-it-button": "فهمت!",

   // Shared auth thunk toasts (donor/expert registration)
   "account-created-success-description": "تم إنشاء الحساب بنجاح.",
   "unexpected-error-description": "حدث خطأ غير متوقع. يرجى المحاولة مرة أخرى.",
   "verification-code-sent-description": "تم إرسال رمز التحقق إلى بريدك الإلكتروني.",
   "expert-user-created-success-description": "تم إنشاء حساب الخبير بنجاح",

   // Expert registration step one
   "as-an-expert-label": "كخبير",

   // Expert registration step three
   "lets-start-profile-info-title": "لنبدأ بمعلومات ملفك الشخصي",
   "enter-full-name-placeholder": "أدخل اسمك الكامل",
   "personal-statement-label": "البيان الشخصي/الدافع",
   "enter-personal-statement-placeholder": "أدخل بيانك الشخصي",
   "select-nationality-placeholder": "اختر جنسيتك",
   "select-country-of-residence-placeholder": "اختر بلد إقامتك",
   "operating-countries-label": "بلدان العمل",
   "enter-linkedin-profile-placeholder": "أدخل ملفك الشخصي على LinkedIn",
   "full-name-required-validation": "الاسم الكامل مطلوب",
   "nationality-required-validation": "الجنسية مطلوبة",
   "country-of-residence-required-validation": "بلد الإقامة مطلوب",

   // Expert registration step four
   "now-your-professional-details-title": "الآن تفاصيلك المهنية",
   "profile-picture-label": "صورة الملف الشخصي",
   "education-section-title": "التعليم",
   "select-highest-degree-placeholder": "اختر أعلى شهادة حصلت عليها",
   "enter-fields-of-study-placeholder": "أدخل مجالات الدراسة",
   "enter-educational-institution-placeholder": "أدخل مؤسستك التعليمية",
   "area-label": "المجال",
   "enter-area-placeholder": "أدخل المجال",
   "add-another-area-button": "أضف مجالًا آخر",
   "level-label": "المستوى",
   "select-level-placeholder": "اختر المستوى",
   "add-another-language-button": "أضف لغة أخرى",
   "upload-cv-label": "حمّل سيرتك الذاتية",
   "upload-certificate-label": "حمّل شهادة أو تدريبًا خاصًا",
   "remove-button": "إزالة",
   "image-file-type-badge": "JPG أو PNG",
   "pdf-file-type-badge": "PDF",
   "highest-degree-required-validation": "أعلى شهادة مطلوبة",
   "area-required-validation": "المجال مطلوب",
   "years-of-experience-required-validation": "سنوات الخبرة مطلوبة",
   "years-of-experience-number-validation": "يجب أن تكون سنوات الخبرة رقمًا",
   "profile-picture-required-validation": "صورة الملف الشخصي مطلوبة",
   "invalid-image-file-type-validation": "نوع الملف غير صالح. يُسمح فقط بـ PNG أو JPEG.",
   "file-size-too-large-validation": "حجم الملف كبير جدًا. الحجم الأقصى هو 20 ميغابايت.",
   "invalid-pdf-file-type-validation": "نوع الملف غير صالح. يُسمح فقط بـ PDF.",
   "level-required-validation": "المستوى مطلوب",
   "level-number-validation": "يجب أن يكون المستوى رقمًا",
   "go-back-to-profile-details-link": "العودة إلى تفاصيل الملف الشخصي",
   "uploaded-file-icon-alt": "ملف",
   "add-icon-alt": "إضافة",

   // Confirm-code page
   "verification-code-title": "رمز التحقق",
   "verification-code-sent-to-text": "يرجى إدخال رمز التحقق الذي أرسلناه إلى",
   "verify-code-button": "تحقق من الرمز",
   "didnt-receive-code-text": "إذا لم تستلم رمز التحقق،",
   "resend-code-link": "انقر هنا لإعادة إرساله",
   "or-send-email-at-text": "أو أرسل لنا بريدًا إلكترونيًا على",
   "verification-code-required-validation": "رمز التحقق مطلوب",
   "code-verified-success-description": "تم التحقق من الرمز بنجاح",

   // Account on review page
   "account-on-review-icon-alt": "الحساب قيد المراجعة",
   "got-your-application-title": "لقد تلقينا طلبك!",
   "application-review-description-text": "ستتلقى بريدًا إلكترونيًا للتأكيد بمجرد موافقة أحد المسؤولين على طلبك.",
   "in-the-meantime-prefix-text": "في هذه الأثناء، يمكنك زيارة",
   "in-the-meantime-suffix-text": "لمزيد من المعلومات.",
   "thank-you-for-interest-text": "شكرًا لاهتمامك بـ KAPorg!",

   // Resources library
   "resources-library-tab-label": "مكتبة الموارد",
   "resource-type-all-label": "جميع الموارد",
   "resource-type-documents-label": "المستندات",
   "resource-type-videos-label": "الفيديوهات",
   "resource-type-links-label": "الروابط",
   "resource-type-presentations-label": "العروض التقديمية",
   "no-resources-available-text": "لا توجد موارد متاحة",
   "no-collections-available-text": "لا توجد مجموعات متاحة",
   "which-resource-looking-for-label": "ما الذي تبحث عنه؟",
   "search-ellipsis-placeholder": "بحث...",
   "assessments-placeholder": "التقييمات",
   "modules-label": "الوحدات",
   "section-label": "القسم",
   "sections-placeholder": "الأقسام",
   "resource-icon-alt": "الموارد",
   "copy-link-action": "نسخ الرابط",
   "edit-resource-icon-alt": "تعديل المورد",
   "rate-this-resource-action": "قيّم هذا المورد",
   "delete-resource-icon-alt": "حذف المورد",
   "more-suffix-text": "أخرى",
   "rate-this-resource-title": "قيّم هذا المورد",
   "resource-word": "مورد",
   "your-rating-label": "تقييمك:",
   "save-rating-button": "حفظ التقييم",
   "all-tab-label": "الكل",
   "my-collections-label": "المجموعات",
   "my-collection-toggle-label": "مجموعتي",
   "all-collections-label": "المجموعات",
   "edit-collection-icon-alt": "تعديل المجموعة",
   "delete-collection-icon-alt": "حذف المجموعة",
   "preview-colon-label": "معاينة:",
   "resources-word": "موارد",

   // Top navigation bar: account/user menu (PopoverLinks)
   "account-summary-icon-alt": "ملخص الحساب",
   "account-summary-label": "ملخص الحساب",
   "account-summary-upgrade-message":
      "لقد اقتربت من الوصول إلى حد باقتك. قم بترقيتها للحصول على مساحة أكبر والإنشاء دون قيود.",
   "upgrade-package-button": "ترقية الباقة",
   "modules-available-label": "الوحدات المتاحة",
   "modules-created-label": "الوحدات التي تم إنشاؤها",
   "assessments-available-label": "التقييمات المتاحة",
   "assessments-created-label": "التقييمات التي تم إنشاؤها",
   "workspaces-available-label": "مساحات العمل المتاحة",
   "workspaces-created-label": "مساحات العمل التي تم إنشاؤها",
   "including-humanitarian-experts-created-label": "بما في ذلك الخبراء الإنسانيون الذين تم إنشاؤهم",
   "amount-of-storage-label": "مقدار التخزين",
   "data-usage-label": "استخدام البيانات",
   "usage-statistics-label": "إحصاءات الاستخدام",
   "available-label": "متاح",
   "used-label": "مستخدم",
   "profile-info-icon-alt": "معلومات الملف الشخصي",
   "profile-information-label": "معلومات الملف الشخصي",
   "login-info-icon-alt": "معلومات تسجيل الدخول",
   "login-information-label": "معلومات تسجيل الدخول",
   "payment-info-icon-alt": "معلومات الدفع",
   "payment-information-label": "معلومات الدفع",
   "log-out-icon-alt": "تسجيل الخروج",
   "log-out-button": "تسجيل الخروج",
   "account-menu-toggle-alt": "قائمة الحساب",

   // Top navigation bar: mobile header
   "menu-toggle-icon-alt": "القائمة",
   "logo-alt-text": "الشعار",

   // Top navigation bar: notifications popover
   "mark-all-as-read-button": "تحديد الكل كمقروء",
   "unread-tab-label": "غير مقروء",
   "no-notifications-title-text": "لا توجد إشعارات هنا!",
   "up-to-date-description-text": "كل شيء محدث!",

   // Terms of Service (legal document body) - translated
   "terms-last-updated-text": "تم آخر تحديث لشروط الخدمة هذه بتاريخ 4 مارس 2024.",
   "terms-intro-websites-prefix-text": "تحكم شروط الخدمة هذه استخدامك لمواقعنا الإلكترونية الموجودة على",
   "terms-intro-websites-suffix-text": "، بالإضافة إلى أي خدمات ذات صلة تقدمها International Advisory, Products and Systems Ltd. من خلال الوصول إلى مواقعنا الإلكترونية، فإنك توافق على الالتزام بشروط الخدمة هذه والامتثال لجميع القوانين واللوائح المعمول بها. وإذا كنت لا توافق على شروط الخدمة هذه، فيُحظر عليك استخدام تلك المواقع الإلكترونية أو الوصول إليها أو استخدام أي خدمات أخرى تقدمها International Advisory, Products and Systems Ltd. نحن، International Advisory, Products and Systems Ltd، نحتفظ بالحق في مراجعة وتعديل أي من شروط الخدمة هذه وفقاً لتقديرنا المطلق. وعند القيام بذلك، سنقوم بتحديث هذه الصفحة. وسيسري أي تغيير على شروط الخدمة هذه فوراً اعتباراً من تاريخ نشره.",
   "overview-of-services-title": "نظرة عامة على الخدمات",
   "overview-of-services-description-text": "تقدم International Advisory, Products and Systems Ltd. (i-APS)، إلى جانب الكيانات التابعة لها، بما في ذلك على سبيل المثال لا الحصر KAPsurvey وKAPorg وKAPinsights وKAPcourse (يُشار إليها مجتمعة فيما يلي باسم \"KAPtech Group\")، خدمات استشارية تقنية، وحلولاً تكنولوجية مبتكرة، وأدوات شاملة لجمع البيانات وتحليلها. وتهدف عروض KAPtech Group إلى دعم تنفيذ وإدارة المشاريع الخبيرة والتنموية. وتستخدم هذه الخدمات أحدث التقنيات وتستفيد من الخبرة المحلية الواسعة لمساعدة المنظمات والمجتمعات الشريكة على الاستجابة بفعالية للتحديات في قطاعي المساعدة الخبيرة والتنمية والتغلب عليها. وباستخدامك للخدمات التي تقدمها KAPtech Group، بما في ذلك الوصول إلى مواقعنا الإلكترونية، فإنك توافق على الامتثال للشروط والأحكام المنصوص عليها في هذه الاتفاقية والالتزام بها. وتخضع الخدمات المقدمة للشروط الموضحة هنا، إلى جانب أي إرشادات أو قواعد إضافية تنطبق على خدمات أو ميزات محددة من الخدمات.",
   "limitations-of-use-title": "قيود الاستخدام",
   "limitations-of-use-intro-text": "باستخدامك لمواقعنا الإلكترونية، فإنك تتعهد، نيابة عن نفسك ومستخدميك والأطراف الأخرى التي تمثلها، بألا تقوم بما يلي:",
   "limitation-modify-content-text": "تعديل أو نسخ أو إعداد أعمال مشتقة من أي مواد أو برامج واردة في تلك المواقع الإلكترونية، أو إجراء هندسة عكسية أو فك ترجمة لها؛",
   "limitation-remove-notices-text": "إزالة أي إشعارات حقوق نشر أو إشعارات ملكية أخرى من أي مواد أو برامج على تلك المواقع الإلكترونية؛",
   "limitation-transfer-materials-text": "نقل المواد إلى شخص آخر أو نسخها بشكل مطابق على أي خادم آخر؛",
   "limitation-abuse-networks-text": "استخدام تلك المواقع الإلكترونية أو أي من الخدمات المرتبطة بها، عن علم أو نتيجة إهمال، بطريقة تسيء إلى شبكاتنا أو تعطّلها، أو إلى أي خدمة أخرى تقدّمها International Advisory, Products and Systems Ltd أو تعطّلها؛",
   "limitation-unlawful-material-text": "استخدام تلك المواقع الإلكترونية أو الخدمات المرتبطة بها لنقل أو نشر أي مواد مضايقة أو غير لائقة أو فاحشة أو احتيالية أو غير قانونية؛",
   "limitation-violate-laws-text": "استخدام تلك المواقع الإلكترونية أو الخدمات المرتبطة بها بما يخالف أي قوانين أو لوائح معمول بها؛",
   "limitation-spam-text": "استخدام تلك المواقع الإلكترونية بالاقتران مع إرسال إعلانات غير مصرح بها أو رسائل غير مرغوب فيها (سبام)؛",
   "limitation-harvest-data-text": "استخراج بيانات المستخدمين أو جمعها أو التقاطها دون موافقتهم؛ أو",
   "limitation-infringe-rights-text": "استخدام تلك المواقع الإلكترونية أو الخدمات المرتبطة بها بطريقة قد تنتهك خصوصية الأطراف الثالثة أو حقوق الملكية الفكرية الخاصة بها أو أي حقوق أخرى لها",
   "intellectual-property-title": "الملكية الفكرية",
   "intellectual-property-description-text": "إن حقوق الملكية الفكرية في المواد الواردة في تلك المواقع الإلكترونية مملوكة لـ International Advisory, Products and Systems Ltd أو مرخصة لها، وهي محمية بموجب قوانين حقوق النشر والعلامات التجارية المعمول بها. ونمنح مستخدمينا إذناً بتنزيل نسخة واحدة من المواد للاستخدام الشخصي وغير التجاري والمؤقت. ويشكل ذلك منح ترخيص وليس نقلاً لحق الملكية. وينتهي هذا الترخيص تلقائياً في حال مخالفتك لأي من هذه القيود أو لشروط الخدمة، ويجوز لـ International Advisory, Products and Systems Ltd إنهاؤه في أي وقت.",
   "user-generated-content-title": "المحتوى الذي ينشئه المستخدم",
   "terms-user-generated-content-description-text": "تحتفظ بحقوق ملكيتك الفكرية على المحتوى الذي تقدمه إلينا لنشره على مواقعنا الإلكترونية. ولن نطالب أبداً بملكية محتواك، إلا أننا نحتاج إلى ترخيص منك لاستخدامه. وعندما تستخدم مواقعنا الإلكترونية أو الخدمات المرتبطة بها لنشر أو تحميل أو مشاركة أو نقل محتوى مشمول بحقوق الملكية الفكرية بأي طريقة أخرى، فإنك تمنحنا ترخيصاً غير حصري، ومعفى من الإتاوات، وقابلاً للتحويل، وقابلاً لمنح تراخيص من الباطن، وسارياً في جميع أنحاء العالم، لاستخدام محتواك وتوزيعه وتعديله وتشغيله ونسخه وعرضه علناً وترجمته أو إنشاء أعمال مشتقة منه بطريقة تتسق مع تفضيلات الخصوصية الخاصة بك وسياسة الخصوصية الخاصة بنا. ويمكن إنهاء الترخيص الذي تمنحنا إياه في أي وقت عن طريق حذف محتواك أو حسابك. ومع ذلك، وبقدر ما نكون قد استخدمنا (نحن أو شركاؤنا) محتواك فيما يتعلق بمحتوى تجاري أو مُموَّل، فسيستمر الترخيص إلى أن نتوقف عن استخدام ذلك المحتوى التجاري أو المنشور ذي الصلة. وأنت تمنحنا إذناً باستخدام اسم المستخدم الخاص بك وغيره من المعلومات التعريفية المرتبطة بحسابك بطريقة تتسق مع تفضيلات الخصوصية الخاصة بك وسياسة الخصوصية الخاصة بنا.",
   "registration-and-payments-title": "التسجيل والمدفوعات",
   "registration-and-payments-description-text": "لاستخدام أي من خدماتنا، يتعين عليك إنشاء حساب. ويجب أن تكون أي معلومات مقدمة دقيقة ومحدّثة عند الاقتضاء. ويتحمل العملاء مسؤولية الحفاظ على حساباتهم، ويتحملون المسؤولية الكاملة عن جميع الأنشطة التي تجري في إطار حساباتهم. وفي حال حصول أي شخص على وصول غير مصرح به إلى حسابك، يتعين عليك إخطارنا فوراً. ولا تتحمل International Advisory, Products and Systems Ltd أي مسؤولية عن أي خسارة أو ضرر ينشأ عن الإخفاق في الحفاظ على سرية حسابك. وعند إنشاء حسابك، يتعين عليك تقديم معلوماتك المالية المتعلقة بطريقة الدفع المختارة. وفي بعض الحالات، قد يُطلب منك تقديم بيانات بطاقتك الائتمانية. يُرجى ملاحظة أن أي مدفوعات تتم على منصتنا ستتم معالجتها بواسطة PayPal أو Stripe أو Square أو Google Payments أو Apple Pay. وبناءً على ذلك، لن نتحمل مسؤولية معالجة أو الاحتفاظ بأي من معلوماتك المالية. وستتولى PayPal أو Stripe أو Square أو Google Payments أو Apple Pay معالجة جميع معلوماتك المالية وفقاً لشروط الخدمة الخاصة بكل منها، وأنت توافق على الالتزام بشروط الخدمة تلك.",
   "disclaimer-and-limitations-title": "إخلاء المسؤولية وحدود المسؤولية",
   "disclaimer-websites-prefix-text": "إن المواقع الإلكترونية والمواد التي تقدمها International Advisory, Products and Systems Ltd.، بما في ذلك على سبيل المثال لا الحصر",
   "disclaimer-as-is-description-text": "، تُتاح للمستخدمين \"كما هي\". وتخلي International Advisory, Products and Systems Ltd مسؤوليتها عن جميع الضمانات، الصريحة أو الضمنية، إلى الحد الذي يسمح به القانون. ويشمل ذلك على سبيل المثال لا الحصر ضمانات القابلية للتسويق، والملاءمة لغرض معين، أو عدم انتهاك حقوق الملكية الفكرية. علاوة على ذلك، لا تنشئ أي مشورة أو معلومات، سواء كانت شفهية أو مكتوبة، تحصل عليها من International Advisory, Products and Systems Ltd أو من خلال الخدمات، أي ضمان غير منصوص عليه صراحة في هذه الشروط. ولا تتحمل International Advisory, Products and Systems Ltd ومورّدوها المسؤولية عن أي أضرار مباشرة أو غير مباشرة أو عرضية أو خاصة أو تبعية أو رادعة، بما في ذلك على سبيل المثال لا الحصر الأضرار الناجمة عن فقدان الأرباح أو السمعة التجارية أو الاستخدام أو البيانات أو غيرها من الخسائر غير الملموسة (حتى في حال إبلاغ International Advisory, Products and Systems Ltd باحتمال وقوع مثل هذه الأضرار)، الناتجة عن استخدام الخدمات أو عدم القدرة على استخدامها أو أي أمر آخر يتعلق بالخدمات. وتنطبق حدود المسؤولية هذه سواء استندت المسؤولية المزعومة إلى العقد أو المسؤولية التقصيرية أو الإهمال أو المسؤولية الصارمة أو أي أساس آخر، حتى في حال إبلاغ International Advisory, Products and Systems Ltd باحتمال وقوع مثل هذا الضرر. ونظراً لطبيعة الخدمات التي تقدمها International Advisory, Products and Systems Ltd، ولا سيما في سياق قطاعي الخبرة والتنمية، يقر المستخدمون بالمخاطر الكامنة في جمع البيانات واستخدام الحلول القائمة على التكنولوجيا. ويتحمل المستخدمون وحدهم مسؤولية ضمان امتثالهم لجميع القوانين واللوائح المعمول بها، بما في ذلك على سبيل المثال لا الحصر قوانين حماية البيانات والخصوصية. وتقع مسؤولية الحصول على الموافقات والأذونات اللازمة لجمع البيانات، ولا سيما عند تعلق الأمر بالقُصَّر أو البيانات الحساسة، على عاتق المستخدم. وتقتصر مسؤولية International Advisory, Products and Systems Ltd والشركات التابعة لها ومديريها ومسؤوليها وموظفيها ووكلائها ومورّديها ومرخّصيها على أقصى حد يسمح به القانون. وإذا كنت غير راضٍ عن أي جزء من الخدمات، أو عن أي من هذه الشروط، فإن سبيل الانتصاف الوحيد والحصري المتاح لك هو التوقف عن استخدام الخدمات. ولا تسمح بعض الولايات القضائية باستبعاد ضمانات معينة أو تحديد أو استبعاد المسؤولية عن الأضرار العرضية أو التبعية، لذا فقد لا تنطبق عليك بعض القيود المذكورة أعلاه.",
   "accuracy-of-materials-title": "دقة المواد",
   "accuracy-of-materials-description-text": "إن المواد الواردة في مواقعنا الإلكترونية ليست شاملة وهي مخصصة لأغراض المعلومات العامة فقط. ولا تقدم International Advisory, Products and Systems Ltd أي ضمان أو إقرار يتعلق بدقة استخدام المواد الواردة في تلك المواقع الإلكترونية أو النتائج المحتملة لذلك أو موثوقيته، أو بخلاف ذلك فيما يتعلق بتلك المواد أو بأي موارد مرتبطة بتلك المواقع الإلكترونية. ولا ينبغي لك الاعتماد فقط على المواد المذكورة لاتخاذ القرارات، وننصحك بالرجوع إلى مصادر معلومات أخرى أكثر شمولاً. وأنت تتحمل وحدك مسؤولية الاعتماد الصارم على المواد المنشورة على مواقعنا الإلكترونية. ويحق لنا تغيير المعلومات الواردة في مواقعنا الإلكترونية دون إشعار مسبق، ويتحمل المستخدمون مسؤولية متابعة تلك التغييرات.",
   "additional-tools-title": "أدوات إضافية",
   "additional-tools-description-text": "يُرجى ملاحظة أن مواقعنا الإلكترونية قد تتضمن أدوات تابعة لأطراف ثالثة تخرج عن سيطرتنا. ويُتاح الوصول إلى هذه الأدوات \"كما هي\" دون أي ضمانات، صريحة أو ضمنية، ودون أي تأييد. ولا نتحمل أي مسؤولية عن استخدام الأدوات التابعة لأطراف ثالثة المتاحة على مواقعنا الإلكترونية. وأنت تتحمل وحدك مسؤولية أي مخاطر مرتبطة باستخدام هذه الأدوات، ونوصي بالاطلاع على شروط الخدمة الخاصة بمزود الطرف الثالث ذي الصلة. ويحق لـ International Advisory, Products and Systems Ltd تقديم أدوات جديدة تابعة لأطراف ثالثة في المستقبل",
   "links-title": "الروابط",
   "links-description-text": "لم تقم International Advisory, Products and Systems Ltd بمراجعة جميع المواقع المرتبطة بمواقعها الإلكترونية، وهي غير مسؤولة عن محتوى أي من هذه المواقع المرتبطة. ولا يعني إدراج أي رابط تأييد International Advisory, Products and Systems Ltd للموقع أو موافقتها عليه أو سيطرتها عليه. ويكون استخدام أي من هذه المواقع المرتبطة على مسؤوليتك الخاصة، وننصحك بشدة بإجراء تحرياتك الخاصة بشأن ملاءمة تلك المواقع.",
   "inaccuracies-and-mistakes-title": "عدم الدقة والأخطاء",
   "inaccuracies-and-mistakes-description-text": "يُرجى ملاحظة أن أي محتوى متاح على مواقعنا الإلكترونية قد يحتوي على أخطاء مطبعية أو أخطاء في الدقة أو أخطاء أخرى تتعلق بوصف الخدمة أو تسعيرها أو الترويج لها ومدى توفرها. ويحق لنا إلغاء أو تحديث أي من الخدمات القائمة في حال ثبت عدم دقة أي معلومات قدمناها. ويجوز تعديل هذه المعلومات في أي وقت دون إشعار مسبق. يُرجى ملاحظة أننا غير ملزمين بتوضيح أي من المعلومات المتعلقة بمواقعنا الإلكترونية وخدماتنا، بما في ذلك معلومات التسعير، إلا في حال اقتضى القانون ذلك.",
   "indemnification-title": "التعويض",
   "indemnification-description-text": "أنت توافق على الدفاع عنا وتعويضنا وإبراء ذمتنا، بما يشمل شركاتنا التابعة والفرعية وجميع مسؤولينا ووكلائنا وشركائنا وموظفينا، من وضد أي خسارة أو ضرر أو مسؤولية أو مطالبة أو طلب، بما في ذلك أتعاب المحاماة والمصاريف المعقولة، يتقدم بها أي طرف ثالث بسبب أو نتيجة: (1) مساهماتك؛ (2) استخدام المواقع الإلكترونية؛ (3) مخالفة شروط الخدمة هذه؛ (4) أي إخلال بإقراراتك وضماناتك المنصوص عليها في شروط الخدمة هذه؛ (5) انتهاكك لحقوق أي طرف ثالث، بما في ذلك على سبيل المثال لا الحصر حقوق الملكية الفكرية؛ أو (6) أي فعل ضار صريح تجاه أي مستخدم آخر من مستخدمي المواقع الإلكترونية تواصلت معه عبر تلك المواقع.",
   "indemnification-defense-text": "وبصرف النظر عما سبق، فإننا نحتفظ بالحق، على نفقتك، في تولي الدفاع الحصري والسيطرة الكاملة على أي مسألة يتعين عليك بموجبها تعويضنا عنها، وأنت توافق على التعاون، على نفقتك، مع دفاعنا عن هذه المطالبات. وسنبذل جهوداً معقولة لإخطارك بأي مطالبة أو دعوى أو إجراء يخضع لهذا التعويض فور علمنا به.",
   "right-to-terminate-title": "الحق في الإنهاء",
   "right-to-terminate-description-text": "يجوز لنا تعليق أو إنهاء حقك في استخدام مواقعنا الإلكترونية وإنهاء شروط الخدمة هذه فوراً بموجب إشعار خطي يوجَّه إليك في حال أي مخالفة لشروط الخدمة هذه.",
   "severance-title": "قابلية الفصل",
   "severance-description-text": "يتم فصل أي بند من بنود شروط الخدمة هذه يكون باطلاً أو غير قابل للتنفيذ، كلياً أو جزئياً، بالقدر الذي يكون فيه باطلاً أو غير قابل للتنفيذ. ولا يتأثر بذلك سريان باقي بنود شروط الخدمة هذه.",
   "entire-agreement-title": "الاتفاقية الكاملة",
   "entire-agreement-description-text": "تشكل شروط الخدمة هذه وأي سياسات أو قواعد تشغيلية ننشرها على المواقع الإلكترونية أو فيما يتعلق بها الاتفاقية والتفاهم الكاملين بينك وبيننا. ولا يُعد عدم ممارستنا أو إنفاذنا لأي حق أو حكم من أحكام شروط الخدمة هذه تنازلاً عن ذلك الحق أو الحكم. وتسري شروط الخدمة هذه إلى أقصى حد يسمح به القانون. ويجوز لنا التنازل عن أي أو كل حقوقنا والتزاماتنا لأطراف أخرى في أي وقت. ولن نكون مسؤولين عن أي خسارة أو ضرر أو تأخير أو إخفاق في التصرف ناجم عن أي سبب يخرج عن سيطرتنا المعقولة. وإذا تقرر أن أي حكم أو جزء من حكم من أحكام شروط الخدمة هذه غير قانوني أو باطل أو غير قابل للتنفيذ، فإن ذلك الحكم أو ذلك الجزء منه يُعتبر قابلاً للفصل عن شروط الخدمة هذه ولا يؤثر على صحة وقابلية إنفاذ باقي الأحكام. ولا تنشأ أي علاقة مشروع مشترك أو شراكة أو توظيف أو وكالة بينك وبيننا نتيجة لشروط الخدمة هذه أو استخدام المواقع الإلكترونية. وأنت توافق على عدم تفسير شروط الخدمة هذه ضدنا بحجة أننا من قمنا بصياغتها. وأنت تتنازل بموجب هذا عن أي وجميع الدفوع التي قد تكون لديك استناداً إلى الشكل الإلكتروني لشروط الخدمة هذه وعدم توقيع أطرافها عليها.",
   "governing-law-title": "القانون الحاكم",
   "governing-law-description-text": "تخضع شروط الخدمة هذه لقوانين Virginia وتُفسَّر وفقاً لها. وأنت تخضع بشكل نهائي وغير قابل للرجوع فيه للاختصاص القضائي الحصري لمحاكم تلك الولاية أو ذلك الموقع.",

   // Cookie Policy (legal document body)
   "cookie-last-updated-text": "تم آخر تحديث لشروط الخدمة هذه في 4 مارس 2024.",
   "cookie-intro-websites-prefix-text": "نستخدم ملفات تعريف الارتباط (الكوكيز) للمساعدة في تحسين تجربتك على مواقعنا الإلكترونية على",
   "cookie-intro-websites-suffix-text": ". تُعد سياسة ملفات تعريف الارتباط هذه جزءًا من سياسة الخصوصية الخاصة بشركة International Advisory, Products and Systems Ltd. وهي تغطي استخدام ملفات تعريف الارتباط بين جهازك ومواقعنا.",
   "cookie-third-party-services-notice-text": "كما نقدم معلومات أساسية حول خدمات الأطراف الثالثة التي قد نستخدمها، والتي قد تستخدم أيضًا ملفات تعريف الارتباط كجزء من خدماتها. لا تغطي هذه السياسة ملفات تعريف الارتباط الخاصة بها.",
   "cookie-refuse-prefix-text": "إذا كنت لا ترغب في قبول ملفات تعريف الارتباط منا، فيجب عليك توجيه متصفحك لرفض ملفات تعريف الارتباط من",
   "cookie-refuse-suffix-text": ". في هذه الحالة، قد لا نتمكن من تزويدك ببعض المحتوى والخدمات التي ترغب بها.",
   "what-is-a-cookie-title": "ما هو ملف تعريف الارتباط (الكوكي)؟",
   "cookie-definition-text": "ملف تعريف الارتباط هو قطعة صغيرة من البيانات يقوم موقع إلكتروني بتخزينها على جهازك عند زيارتك له. ويحتوي عادةً على معلومات حول الموقع الإلكتروني نفسه، ومُعرِّف فريد يتيح للموقع التعرف على متصفحك عند عودتك، وبيانات إضافية تخدم الغرض من ملف تعريف الارتباط، ومدة صلاحية ملف تعريف الارتباط نفسه.",
   "cookie-usage-examples-text": "تُستخدم ملفات تعريف الارتباط لتمكين ميزات معينة (مثل تسجيل الدخول)، وتتبع استخدام الموقع (مثل التحليلات)، وتخزين إعدادات المستخدم الخاصة بك (مثل المنطقة الزمنية وتفضيلات الإشعارات)، وتخصيص المحتوى الخاص بك (مثل الإعلانات واللغة).",
   "first-party-cookies-definition-text": "تُعرف ملفات تعريف الارتباط التي يضبطها الموقع الإلكتروني الذي تزوره عادةً باسم ملفات تعريف الارتباط الخاصة بالطرف الأول. وهي عادةً لا تتتبع سوى نشاطك على ذلك الموقع بالتحديد.",
   "third-party-cookies-definition-text": "تُسمى ملفات تعريف الارتباط التي تضبطها مواقع وشركات أخرى (أي أطراف ثالثة) بملفات تعريف الارتباط الخاصة بالطرف الثالث. ويمكن استخدامها لتتبعك على مواقع إلكترونية أخرى تستخدم خدمة الطرف الثالث نفسها.",
   "cookie-types-title": "أنواع ملفات تعريف الارتباط وكيفية استخدامنا لها",
   "essential-cookies-definition-text": "تُعد ملفات تعريف الارتباط الأساسية ضرورية لتجربتك على الموقع الإلكتروني، إذ تُمكّن الميزات الأساسية مثل تسجيل دخول المستخدم، وإدارة الحساب، وعربات التسوق، ومعالجة المدفوعات.",
   "essential-cookies-usage-text": "نستخدم ملفات تعريف الارتباط الأساسية لتمكين وظائف معينة على مواقعنا الإلكترونية.",
   "performance-cookies-title": "ملفات تعريف الارتباط الخاصة بالأداء",
   "performance-cookies-definition-text": "تتتبع ملفات تعريف الارتباط الخاصة بالأداء كيفية استخدامك للموقع الإلكتروني أثناء زيارتك. وعادةً ما تكون هذه المعلومات مجهولة الهوية ومجمّعة، حيث تُجمع المعلومات من جميع مستخدمي الموقع. وتساعد هذه الملفات الشركات على فهم أنماط استخدام الزوار، وتحديد وتشخيص المشكلات أو الأخطاء التي قد يواجهها مستخدموها، واتخاذ قرارات استراتيجية أفضل لتحسين تجربة الموقع الإلكتروني الشاملة لجمهورها. وقد تُضبط هذه الملفات من قبل الموقع الإلكتروني الذي تزوره (طرف أول) أو من قبل خدمات الأطراف الثالثة. وهي لا تجمع معلومات شخصية عنك.",
   "performance-cookies-usage-text": "نستخدم ملفات تعريف الارتباط الخاصة بالأداء على مواقعنا.",
   "functionality-cookies-title": "ملفات تعريف الارتباط الخاصة بالوظائف",
   "functionality-cookies-definition-text": "تُستخدم ملفات تعريف الارتباط الخاصة بالوظائف لجمع معلومات حول جهازك وأي إعدادات قد تقوم بتهيئتها على الموقع الإلكتروني الذي تزوره (مثل إعدادات اللغة والمنطقة الزمنية). وبفضل هذه المعلومات، يمكن للمواقع الإلكترونية تزويدك بمحتوى وخدمات مخصصة أو معززة أو محسّنة. وقد تُضبط هذه الملفات من قبل الموقع الإلكتروني الذي تزوره (طرف أول) أو من قبل خدمات الأطراف الثالثة.",
   "functionality-cookies-usage-text": "نستخدم ملفات تعريف الارتباط الخاصة بالوظائف لميزات مختارة على مواقعنا.",
   "targeting-advertising-cookies-title": "ملفات تعريف الارتباط الخاصة بالاستهداف/الإعلانات",
   "targeting-advertising-cookies-definition-text": "تساعد ملفات تعريف الارتباط الخاصة بالاستهداف/الإعلانات في تحديد المحتوى الترويجي الأكثر ملاءمة وارتباطًا بك وباهتماماتك. وقد تستخدمها المواقع الإلكترونية لتقديم إعلانات مستهدفة أو للحد من عدد المرات التي تشاهد فيها إعلانًا معينًا. ويساعد ذلك الشركات على تحسين فعالية حملاتها وجودة المحتوى المقدَّم لك. وقد تُضبط هذه الملفات من قبل الموقع الإلكتروني الذي تزوره (طرف أول) أو من قبل خدمات الأطراف الثالثة. ويمكن استخدام ملفات تعريف الارتباط الخاصة بالاستهداف/الإعلانات التي تضبطها الأطراف الثالثة لتتبعك على مواقع إلكترونية أخرى تستخدم خدمة الطرف الثالث نفسها.",
   "targeting-advertising-cookies-usage-text": "نستخدم ملفات تعريف الارتباط الخاصة بالاستهداف/الإعلانات على مواقعنا.",
   "control-cookies-title": "كيف يمكنك التحكم في استخدام موقعنا الإلكتروني لملفات تعريف الارتباط؟",
   "cookie-consent-manager-description-text": "لديك الحق في تقرير ما إذا كنت تقبل أو ترفض ملفات تعريف الارتباط على مواقعنا الإلكترونية. ويمكنك إدارة تفضيلاتك الخاصة بملفات تعريف الارتباط من خلال Cookie Consent Manager الخاص بنا. يتيح لك Cookie Consent Manager اختيار فئات ملفات تعريف الارتباط التي تقبلها أو ترفضها. لا يمكن رفض ملفات تعريف الارتباط الأساسية لأنها ضرورية بشكل صارم لتزويدك بالخدمات على مواقعنا الإلكترونية.",
   "browser-settings-cookie-control-text": "قد يكون بإمكانك أيضًا ضبط أو تعديل تفضيلاتك الخاصة بملفات تعريف الارتباط من خلال إدارة إعدادات متصفح الويب الخاص بك. ونظرًا لاختلاف كل متصفح ويب عن الآخر، يُرجى الرجوع إلى التعليمات المقدَّمة من متصفح الويب الخاص بك (وعادةً ما تكون موجودة في قسم \"المساعدة\"). وإذا اخترت رفض ملفات تعريف الارتباط أو تعطيلها، فلا يزال بإمكانك استخدام مواقعنا الإلكترونية، رغم أن بعض وظائفها قد لا تكون متاحة لك.",
   "cookie-policy-update-frequency-title": "كم مرة سنقوم بتحديث سياسة ملفات تعريف الارتباط هذه؟",
   "cookie-policy-update-reason-text": "قد نقوم بتحديث سياسة ملفات تعريف الارتباط هذه من وقت لآخر لتعكس أي تغييرات في ملفات تعريف الارتباط والتقنيات ذات الصلة التي نستخدمها، أو لأسباب تشغيلية أو قانونية أو تنظيمية أخرى.",
   "cookie-policy-version-notice-text": "في كل مرة تستخدم فيها مواقعنا الإلكترونية، سيتم تطبيق النسخة الحالية من سياسة ملفات تعريف الارتباط. وعند استخدامك لمواقعنا الإلكترونية، يجب عليك التحقق من تاريخ سياسة ملفات تعريف الارتباط هذه (الذي يظهر في أعلى هذه الوثيقة) ومراجعة أي تغييرات طرأت منذ النسخة الأخيرة.",
   "cookie-policy-further-info-title": "أين يمكنك الحصول على مزيد من المعلومات؟",
   "cookie-policy-contact-us-description-text": "لأي أسئلة أو استفسارات بخصوص سياسة ملفات تعريف الارتباط الخاصة بنا، يمكنك التواصل معنا باستخدام التفاصيل التالية:",

   // Privacy Policy (legal document body)
   "privacy-last-updated-text": "تم تحديث شروط الخدمة هذه آخر مرة في 4 مارس 2024.",
   "privacy-intro-websites-prefix-text": "خصوصيتك مهمة بالنسبة لنا. تتمثل سياسة International Advisory, Products and Systems Ltd في احترام خصوصيتك والامتثال لأي قانون ولائحة معمول بهما فيما يتعلق بأي معلومات شخصية قد نجمعها عنك، بما في ذلك عبر مواقعنا الإلكترونية،",
   "privacy-intro-websites-suffix-text": "، والمواقع الأخرى التي نملكها ونقوم بتشغيلها.",
   "personal-information-definition-text": "المعلومات الشخصية هي أي معلومات عنك يمكن استخدامها لتحديد هويتك. ويشمل ذلك المعلومات المتعلقة بك كشخص (مثل الاسم والعنوان وتاريخ الميلاد)، وأجهزتك، وتفاصيل الدفع، بل وحتى المعلومات المتعلقة بكيفية استخدامك لموقع إلكتروني أو خدمة عبر الإنترنت.",
   "third-party-sites-disclaimer-text": "في حال احتوت مواقعنا على روابط لمواقع وخدمات تابعة لجهات خارجية، يرجى العلم بأن تلك المواقع والخدمات لديها سياسات خصوصية خاصة بها. وبعد اتباع رابط يؤدي إلى أي محتوى تابع لجهة خارجية، ينبغي عليك قراءة سياسة الخصوصية المنشورة الخاصة بها للاطلاع على كيفية جمعها واستخدامها للمعلومات الشخصية. لا تنطبق سياسة الخصوصية هذه على أي من أنشطتك بعد مغادرتك لأحد مواقعنا.",
   "information-we-collect-title": "المعلومات التي نجمعها",
   "information-categories-intro-text": "تنقسم المعلومات التي نجمعها إلى إحدى فئتين: معلومات \"مقدَّمة طوعًا\" ومعلومات \"مجمَّعة تلقائيًا\"",
   "voluntarily-provided-info-description-text": "تشير المعلومات \"المقدَّمة طوعًا\" إلى أي معلومات تقدمها لنا عن علم وبشكل نشط عند استخدامك أو مشاركتك في أي من خدماتنا وعروضنا الترويجية.",
   "automatically-collected-info-description-text": "تشير المعلومات \"المجمَّعة تلقائيًا\" إلى أي معلومات تُرسَل تلقائيًا من أجهزتك أثناء وصولك إلى منتجاتنا وخدماتنا.",
   "log-data-title": "بيانات السجل",
   "log-data-description-text": "عند زيارتك لأحد مواقعنا الإلكترونية، قد تقوم خوادمنا تلقائيًا بتسجيل البيانات القياسية التي يوفرها متصفح الويب الخاص بك. وقد تشمل هذه البيانات عنوان بروتوكول الإنترنت (IP) الخاص بجهازك، ونوع متصفحك وإصداره، والصفحات التي تزورها، ووقت وتاريخ زيارتك، والوقت الذي تقضيه في كل صفحة، وتفاصيل أخرى حول زيارتك.",
   "log-data-errors-description-text": "بالإضافة إلى ذلك، إذا واجهت أخطاء معينة أثناء استخدام مواقعنا، فقد نقوم تلقائيًا بجمع بيانات حول الخطأ والظروف المحيطة بحدوثه. وقد تشمل هذه البيانات تفاصيل تقنية عن جهازك، وما كنت تحاول القيام به عند وقوع الخطأ، ومعلومات تقنية أخرى تتعلق بالمشكلة. وقد تتلقى أو لا تتلقى إشعارًا بوقوع مثل هذه الأخطاء، حتى في اللحظة التي تحدث فيها، أو بأنها قد حدثت، أو بطبيعة الخطأ.",
   "device-data-intro-text": "عند زيارتك لمواقعنا الإلكترونية أو تفاعلك مع خدماتنا، قد نقوم تلقائياً بجمع بيانات حول جهازك، مثل:",
   "device-data-title": "بيانات الجهاز",
   "device-type-label": "نوع الجهاز",
   "log-data-combination-warning-text": "يرجى العلم أنه على الرغم من أن هذه المعلومات قد لا تكون، في حد ذاتها، معرِّفة للهوية الشخصية، فقد يكون من الممكن دمجها مع بيانات أخرى لتحديد هوية الأفراد شخصياً.",
   "operating-system-label": "نظام التشغيل",
   "unique-device-identifiers-label": "معرّفات الجهاز الفريدة",
   "date-of-birth-label": "تاريخ الميلاد",
   "device-data-settings-note-text": "قد تعتمد البيانات التي نجمعها على الإعدادات الفردية لجهازك وبرامجك. نوصي بمراجعة سياسات الشركة المصنّعة لجهازك أو مزوّد البرنامج لمعرفة المعلومات التي يتيحونها لنا.",
   "geo-location-data-label": "بيانات تحديد الموقع الجغرافي",
   "personal-information-intro-text": "قد نطلب معلومات شخصية — على سبيل المثال، عند اشتراكك في نشرتنا الإخبارية أو عند تواصلك معنا — والتي قد تشمل واحدًا أو أكثر مما يلي:",
   "personal-information-title": "المعلومات الشخصية",
   "social-media-profiles-label": "الملفات الشخصية على وسائل التواصل الاجتماعي",
   "phone-mobile-number-label": "رقم الهاتف/الهاتف المحمول",
   "home-mailing-address-label": "العنوان المنزلي/عنوان المراسلة",
   "work-related-information-label": "المعلومات المتعلقة بالعمل",
   "company-name-label": "اسم الشركة",
   "title-field-label": "المسمى الوظيفي",
   "sensitive-information-title": "المعلومات الحساسة",
   "sensitive-information-definition-text": "\"المعلومات الحساسة\" أو \"الفئات الخاصة من البيانات\" هي مجموعة فرعية من المعلومات الشخصية تُمنح مستوى أعلى من الحماية. تشمل أمثلة المعلومات الحساسة المعلومات المتعلقة بأصلك العرقي أو الإثني، والآراء السياسية، والدين، والنقابات العمالية أو غيرها من الجمعيات أو العضويات المهنية، والمعتقدات الفلسفية، والميل الجنسي، والممارسات الجنسية أو الحياة الجنسية، والسجلات الجنائية، والمعلومات الصحية، أو المعلومات البيومترية.",
   "sensitive-information-types-intro-text": "تشمل أنواع المعلومات الحساسة التي قد نجمعها عنك ما يلي:",
   "sensitive-information-consent-text": "لن نقوم بجمع معلومات حساسة عنك دون الحصول أولاً على موافقتك، ولن نستخدم معلوماتك الحساسة أو نفصح عنها إلا وفقاً لما يسمح به القانون أو يقتضيه أو يُجيزه.",
   "privacy-user-generated-content-description-text": "نعتبر أن \"المحتوى الذي ينشئه المستخدم\" هو المواد (النصوص والصور و/أو محتوى الفيديو) التي يقدمها مستخدمونا لنا طوعاً بغرض النشر أو المعالجة أو الاستخدام على منصتنا. يرتبط جميع المحتوى الذي ينشئه المستخدم بالحساب أو عنوان البريد الإلكتروني المستخدم في تقديم هذه المواد.",
   "user-generated-content-publication-notice-text": "يرجى العلم بأن أي محتوى تقدمه بغرض النشر سيكون متاحاً للعموم بعد نشره (وبعد عملية المراجعة أو التدقيق اللاحقة). وبمجرد نشره، قد يكون متاحاً لأطراف ثالثة لا تخضع لسياسة الخصوصية هذه.",
   "transaction-data-title": "بيانات المعاملات",
   "transaction-data-description-text": "تشير بيانات المعاملات إلى البيانات التي تتراكم خلال السير الطبيعي للعمليات على منصتنا. وقد تشمل هذه البيانات سجلات المعاملات، والملفات المخزَّنة، وملفات تعريف المستخدمين، وبيانات التحليلات وغيرها من المقاييس، بالإضافة إلى أنواع أخرى من المعلومات التي يتم إنشاؤها أو توليدها أثناء تفاعل المستخدمين مع خدماتنا.",
   "legitimate-reasons-title": "الأسباب المشروعة لمعالجة معلوماتك الشخصية",
   "legitimate-reasons-description-text": "لا نقوم بجمع معلوماتك الشخصية واستخدامها إلا عندما يكون لدينا سبب مشروع للقيام بذلك. وفي هذه الحالة، لا نجمع سوى المعلومات الشخصية الضرورية بشكل معقول لتزويدك بخدماتنا.",
   "collection-and-use-title": "جمع المعلومات واستخدامها",
   "collection-and-use-intro-text": "يجوز لنا جمع معلوماتك الشخصية عندما تقوم بأي مما يلي على مواقعنا الإلكترونية:",
   "collect-register-account-text": "التسجيل للحصول على حساب",
   "collect-purchase-subscription-text": "شراء اشتراك",
   "collect-signup-updates-text": "التسجيل لتلقي التحديثات منا عبر البريد الإلكتروني أو قنوات التواصل الاجتماعي",
   "collect-mobile-browser-text": "استخدام جهاز محمول أو متصفح ويب للوصول إلى محتوانا",
   "collect-contact-us-text": "التواصل معنا عبر البريد الإلكتروني أو وسائل التواصل الاجتماعي أو عبر أي تقنيات مماثلة",
   "collect-social-media-mention-text": "عند الإشارة إلينا على وسائل التواصل الاجتماعي",
   "collection-purposes-intro-text": "قد نقوم بجمع المعلومات أو الاحتفاظ بها أو استخدامها أو الإفصاح عنها للأغراض التالية، ولن تتم معالجة المعلومات الشخصية بشكل إضافي بطريقة لا تتوافق مع هذه الأغراض:",
   "purpose-core-features-text": "لتزويدكم بالميزات والخدمات الأساسية لمنصتنا",
   "purpose-customize-experience-text": "لتمكينكم من تخصيص تجربتكم في استخدام مواقعنا الإلكترونية أو إضفاء طابع شخصي عليها",
   "purpose-deliver-products-text": "لتوريد المنتجات و/أو تقديم الخدمات إليكم",
   "purpose-contact-communicate-text": "للتواصل والاتصال بكم",
   "purpose-analytics-research-text": "لأغراض التحليلات وأبحاث السوق وتطوير الأعمال، بما في ذلك تشغيل وتحسين مواقعنا الإلكترونية والتطبيقات المرتبطة بها ومنصات التواصل الاجتماعي المرتبطة بها",
   "purpose-advertising-marketing-text": "لأغراض الإعلان والتسويق، بما في ذلك إرسال معلومات ترويجية إليك عن منتجاتنا وخدماتنا، ومعلومات عن أطراف ثالثة نرى أنها قد تهمك",
   "purpose-enable-access-text": "لتمكينك من الوصول إلى مواقعنا الإلكترونية والتطبيقات المرتبطة بها ومنصات التواصل الاجتماعي المرتبطة بها واستخدامها",
   "purpose-record-keeping-text": "لأغراض داخلية تتعلق بحفظ السجلات والشؤون الإدارية",
   "purpose-legal-compliance-text": "للامتثال لالتزاماتنا القانونية وتسوية أي نزاعات قد تكون لدينا",
   "purpose-attribute-content-text": "لنسب أي محتوى (مثل المنشورات والتعليقات) تقدمه وننشره على مواقعنا الإلكترونية إليك",
   "purpose-security-fraud-text": "لأغراض الأمن ومنع الاحتيال، ولضمان أن تكون مواقعنا وتطبيقاتنا آمنة ومحمية وتُستخدم وفقًا لشروط الاستخدام الخاصة بنا",
   "purpose-technical-assessment-text": "لأغراض التقييم الفني، بما في ذلك تشغيل وتحسين تطبيقنا والتطبيقات المرتبطة به ومنصات التواصل الاجتماعي المرتبطة به",
   "collection-combine-sources-text": "قد نقوم بدمج المعلومات الشخصية المقدَّمة طوعاً والمعلومات التي يتم جمعها تلقائياً مع معلومات عامة أو بيانات بحثية نحصل عليها من مصادر موثوقة أخرى. فعلى سبيل المثال، إذا زوّدتنا بموقعك الجغرافي، فقد نقوم بدمج ذلك مع معلومات عامة حول العملة واللغة لتزويدك بتجربة محسّنة لمواقعنا وخدماتنا.",
   "security-of-information-title": "أمن معلوماتك الشخصية",
   "security-measures-description-text": "عند قيامنا بجمع ومعالجة المعلومات الشخصية، وطوال مدة احتفاظنا بهذه المعلومات، سنقوم بحمايتها بالوسائل المقبولة تجارياً لمنع فقدانها أو سرقتها، وكذلك الوصول إليها أو الإفصاح عنها أو نسخها أو استخدامها أو تعديلها دون تصريح.",
   "security-no-guarantee-text": "على الرغم من أننا سنبذل قصارى جهدنا لحماية المعلومات الشخصية التي تقدمها لنا، فإننا ننبهك إلى أنه لا توجد طريقة لنقل البيانات إلكترونياً أو تخزينها آمنة بنسبة 100%، ولا يمكن لأحد ضمان الأمن المطلق للبيانات.",
   "security-password-responsibility-text": "أنت المسؤول عن اختيار أي كلمة مرور وعن مدى قوتها الأمنية بشكل عام، وعن ضمان أمن معلوماتك الخاصة في حدود خدماتنا. فعلى سبيل المثال، يجب عليك التأكد من أن أي كلمات مرور مرتبطة بالوصول إلى معلوماتك الشخصية وحساباتك آمنة وسرية.",
   "retention-period-title": "مدة الاحتفاظ بمعلوماتك الشخصية",
   "retention-period-description-text": "نحتفظ بمعلوماتك الشخصية فقط للمدة التي نحتاج إليها. وقد تعتمد هذه المدة الزمنية على الغرض الذي نستخدم معلوماتك من أجله، وفقًا لسياسة الخصوصية هذه. فعلى سبيل المثال، إذا كنت قد زوّدتنا بمعلومات شخصية كجزء من إنشاء حساب لدينا، فقد نحتفظ بهذه المعلومات طوال مدة وجود حسابك في نظامنا. وإذا لم تعد معلوماتك الشخصية لازمة لهذا الغرض، فسنقوم بحذفها أو بجعلها مجهولة الهوية عن طريق إزالة جميع التفاصيل التي تحدد هويتك.",
   "retention-legal-obligation-text": "ومع ذلك، فقد نحتفظ بمعلوماتك الشخصية، عند الضرورة، امتثالًا لالتزام قانوني أو محاسبي أو متعلق بإعداد التقارير، أو لأغراض الأرشفة للمصلحة العامة، أو لأغراض البحث العلمي أو التاريخي، أو للأغراض الإحصائية.",
   "childrens-privacy-title": "خصوصية الأطفال",
   "childrens-privacy-description-text": "لا نوجّه أيًا من منتجاتنا أو خدماتنا مباشرة إلى الأطفال دون سن 13 عامًا، ولا نقوم عن علم بجمع معلومات شخصية عن الأطفال دون سن 13 عامًا.",
   "disclosure-to-third-parties-title": "الإفصاح عن المعلومات الشخصية لأطراف ثالثة",
   "disclosure-intro-text": "قد نفصح عن المعلومات الشخصية إلى:",
   "disclose-affiliate-text": "الشركة الأم أو الشركة التابعة أو الشركة الشقيقة لشركتنا",
   "disclose-service-providers-text": "مزوّدي الخدمات من الأطراف الثالثة بهدف تمكينهم من تقديم خدماتهم، بما في ذلك على سبيل المثال لا الحصر مزوّدي خدمات تقنية المعلومات، ومزوّدي خدمات تخزين البيانات والاستضافة والخوادم، وشبكات الإعلانات، وخدمات التحليلات، وأدوات تسجيل الأخطاء، وشركات تحصيل الديون، ومزوّدي خدمات الصيانة أو حل المشكلات، ومزوّدي خدمات التسويق أو الإعلان، والمستشارين المهنيين، ومشغّلي أنظمة الدفع",
   "disclose-employees-text": "موظفينا، ومتعاقدينا، و/أو الكيانات ذات الصلة",
   "disclose-business-partners-text": "وكلاؤنا أو شركاؤنا في العمل، الحاليون أو المحتملون",
   "disclose-credit-agencies-text": "وكالات الاستعلام الائتماني، والمحاكم، والهيئات القضائية، والسلطات التنظيمية، في حال تخلّفك عن سداد قيمة السلع أو الخدمات التي قدّمناها إليك",
   "disclose-law-enforcement-text": "المحاكم، والهيئات القضائية، والسلطات التنظيمية، وموظفي إنفاذ القانون، وذلك وفقاً لما يقتضيه القانون، فيما يتعلق بأي إجراءات قانونية فعلية أو محتملة، أو من أجل إثبات حقوقنا القانونية أو ممارستها أو الدفاع عنها",
   "disclose-agents-subcontractors-text": "أطراف ثالثة، بما في ذلك الوكلاء أو المتعاقدون من الباطن الذين يساعدوننا في تزويدكم بالمعلومات أو المنتجات أو الخدمات أو التسويق المباشر",
   "disclose-collect-process-text": "أطراف ثالثة لجمع البيانات ومعالجتها",
   "disclose-business-transfer-text": "كيان يشتري جميع أصولنا وأعمالنا أو الجزء الأكبر منها، أو ننقل إليه ذلك",
   "third-parties-currently-used-text": "تشمل الأطراف الثالثة التي نستخدمها حالياً ما يلي:",
   "international-transfers-title": "عمليات النقل الدولي للمعلومات الشخصية",
   "international-transfers-description-text": "يتم تخزين و/أو معالجة المعلومات الشخصية التي نجمعها في الولايات المتحدة، أو في الأماكن التي نحتفظ فيها نحن أو شركاؤنا أو الشركات التابعة لنا أو مزودو الخدمات من الأطراف الثالثة بمرافق.",
   "international-transfers-legal-note-text": "قد لا تتمتع الدول التي نقوم فيها بتخزين معلوماتك الشخصية أو معالجتها أو نقلها بقوانين حماية بيانات مماثلة لتلك المعمول بها في الدولة التي قدمت فيها هذه المعلومات في الأصل. وإذا قمنا بنقل معلوماتك الشخصية إلى أطراف ثالثة في دول أخرى، فإننا: (أولاً) سننفذ عمليات النقل هذه وفقاً لمتطلبات القانون المعمول به؛ و(ثانياً) سنحمي المعلومات الشخصية المنقولة وفقاً لسياسة الخصوصية هذه.",
   "your-rights-title": "حقوقك والتحكم في معلوماتك الشخصية",
   "your-choice-description-text": "اختيارك: من خلال تزويدنا بمعلوماتك الشخصية، فإنك تدرك أننا سنقوم بجمع معلوماتك الشخصية والاحتفاظ بها واستخدامها والإفصاح عنها وفقاً لسياسة الخصوصية هذه. لست ملزماً بتزويدنا بمعلوماتك الشخصية، ولكن في حال عدم قيامك بذلك، فقد يؤثر ذلك على استخدامك لمواقعنا الإلكترونية أو المنتجات و/أو الخدمات المقدمة عليها أو من خلالها.",
   "info-from-third-parties-text": "معلومات من أطراف ثالثة: إذا تلقينا معلومات شخصية عنك من طرف ثالث، فسنقوم بحمايتها على النحو المنصوص عليه في سياسة الخصوصية هذه. وإذا كنت طرفاً ثالثاً يقدم معلومات شخصية عن شخص آخر، فإنك تقر وتضمن أنك حصلت على موافقة ذلك الشخص لتقديم معلوماته الشخصية إلينا.",
   "marketing-permission-text": "إذن التسويق: إذا كنت قد وافقت سابقاً على استخدامنا لمعلوماتك الشخصية لأغراض التسويق المباشر، يمكنك تغيير رأيك في أي وقت من خلال التواصل معنا باستخدام التفاصيل أدناه.",
   "access-rights-text": "الوصول: يجوز لك طلب تفاصيل المعلومات الشخصية التي نحتفظ بها عنك",
   "correction-rights-text": "التصحيح: إذا كنت تعتقد أن أي معلومات نحتفظ بها عنك غير دقيقة، أو قديمة، أو غير مكتملة، أو غير ذات صلة، أو مضللة، يُرجى التواصل معنا باستخدام البيانات المذكورة في سياسة الخصوصية هذه. سنتخذ خطوات معقولة لتصحيح أي معلومات يتبين أنها غير دقيقة أو غير مكتملة أو مضللة أو قديمة.",
   "non-discrimination-text": "عدم التمييز: لن نميز ضدك لممارستك أياً من حقوقك المتعلقة بمعلوماتك الشخصية. ما لم تكن معلوماتك الشخصية مطلوبة لتزويدك بخدمة أو عرض معين (على سبيل المثال معالجة بيانات المعاملات)، فلن نحرمك من السلع أو الخدمات و/أو نفرض عليك أسعاراً أو رسوماً مختلفة مقابل السلع أو الخدمات، بما في ذلك من خلال منح خصومات أو مزايا أخرى، أو فرض عقوبات، أو تزويدك بمستوى أو جودة مختلفة من السلع أو الخدمات.",
   "download-personal-info-text": "تنزيل المعلومات الشخصية: نوفر لك وسيلة لتنزيل المعلومات الشخصية التي شاركتها من خلال مواقعنا. يُرجى التواصل معنا لمزيد من المعلومات.",
   "data-breach-notification-text": "الإخطار بخروقات البيانات: سنلتزم بالقوانين السارية علينا فيما يتعلق بأي خرق للبيانات.",
   "complaints-rights-text": "الشكاوى: إذا كنت تعتقد أننا قد خالفنا قانون حماية بيانات ذا صلة وترغب في تقديم شكوى، يُرجى التواصل معنا باستخدام البيانات أدناه وتزويدنا بالتفاصيل الكاملة للمخالفة المزعومة. سنقوم بالتحقيق في شكواك على الفور والرد عليك كتابياً، موضحين نتيجة تحقيقنا والخطوات التي سنتخذها للتعامل مع شكواك. كما يحق لك التواصل مع هيئة تنظيمية أو سلطة حماية بيانات فيما يتعلق بشكواك.",
   "unsubscribe-rights-text": "إلغاء الاشتراك: لإلغاء اشتراكك من قاعدة بيانات البريد الإلكتروني الخاصة بنا أو لإيقاف تلقي الاتصالات (بما في ذلك الاتصالات التسويقية)، يرجى التواصل معنا باستخدام التفاصيل الواردة في سياسة الخصوصية هذه، أو إيقاف التلقي باستخدام وسائل إيقاف التلقي المتوفرة في الرسالة. قد نحتاج إلى طلب معلومات محددة منك لمساعدتنا على تأكيد هويتك.",
   "use-of-cookies-title": "استخدام ملفات تعريف الارتباط",
   "use-of-cookies-description-text": "نستخدم \"ملفات تعريف الارتباط\" (الكوكيز) لجمع معلومات عنك وعن نشاطك عبر مواقعنا الإلكترونية. ملف تعريف الارتباط هو قطعة صغيرة من البيانات تخزّنها مواقعنا الإلكترونية على جهاز الكمبيوتر الخاص بك وتصل إليها في كل مرة تزورها، وذلك لنتمكن من فهم كيفية استخدامك لمواقعنا. يساعدنا ذلك على تزويدك بمحتوى بناءً على التفضيلات التي حددتها.",
   "refer-to-cookie-policy-text": "يرجى الرجوع إلى سياسة ملفات تعريف الارتباط الخاصة بنا لمزيد من المعلومات.",
   "business-transfers-title": "عمليات نقل الأعمال",
   "business-transfers-description-text": "في حال الاستحواذ علينا أو على أصولنا، أو في الحالة غير المرجحة لتوقفنا عن العمل أو دخولنا في إجراءات الإفلاس، فإننا سندرج البيانات، بما في ذلك معلوماتك الشخصية، ضمن الأصول التي يتم نقلها إلى أي أطراف تستحوذ علينا. وأنت تقر بأن عمليات النقل هذه قد تحدث، وأن أي أطراف تستحوذ علينا يجوز لها، إلى الحد الذي يسمح به القانون المعمول به، الاستمرار في استخدام معلوماتك الشخصية وفقًا لهذه السياسة، والتي سيكون لزامًا عليها الالتزام بها باعتبارها الأساس لأي حقوق ملكية أو استخدام نتمتع بها على هذه المعلومات.",
   "limits-of-policy-title": "حدود سياستنا",
   "limits-of-policy-description-text": "قد تتضمن مواقعنا الإلكترونية روابط لمواقع خارجية لا نقوم بتشغيلها. يرجى العلم أننا لا نملك أي سيطرة على محتوى وسياسات تلك المواقع، ولا يمكننا تحمل أي مسؤولية أو تبعة عن ممارسات الخصوصية الخاصة بكل منها.",
   "changes-to-policy-title": "التغييرات على هذه السياسة",
   "changes-to-policy-description-text": "وفقًا لتقديرنا الخاص، يجوز لنا تغيير سياسة الخصوصية الخاصة بنا لتعكس التحديثات التي تطرأ على إجراءات أعمالنا، أو الممارسات المقبولة حاليًا، أو التغييرات التشريعية أو التنظيمية. وإذا قررنا تغيير سياسة الخصوصية هذه، فسنقوم بنشر التغييرات هنا على نفس الرابط الذي تستخدمه للوصول إلى سياسة الخصوصية هذه.",
   "changes-significant-notice-text": "وإذا كانت التغييرات جوهرية، أو إذا تطلب القانون المعمول به ذلك، فسنقوم بالتواصل معك (بناءً على التفضيلات التي اخترتها بشأن تواصلنا معك) ومع جميع مستخدمينا المسجلين، مع تزويدك بالتفاصيل الجديدة والروابط الخاصة بالسياسة المحدّثة أو المعدّلة.",
   "changes-permission-text": "إذا تطلب القانون ذلك، فسنحصل على إذنك أو نمنحك الفرصة للموافقة على أي استخدامات جديدة لمعلوماتك الشخصية أو رفضها، بحسب الحالة.",
   "au-privacy-act-title": "إفصاحات إضافية للامتثال لقانون الخصوصية الأسترالي (AU)",
   "au-privacy-act-description-text": "في الحالات التي يخضع فيها الإفصاح عن معلوماتك الشخصية حصراً لقوانين الخصوصية الأسترالية، فإنك تقر بأن بعض الأطراف الثالثة قد لا تخضع لقانون الخصوصية ولمبادئ الخصوصية الأسترالية الواردة في قانون الخصوصية. كما تقر بأنه في حال قيام أي من هذه الأطراف الثالثة بأي فعل أو ممارسة تخالف مبادئ الخصوصية الأسترالية، فإنها لن تكون مسؤولة بموجب قانون الخصوصية، ولن يكون بإمكانك طلب الانتصاف بموجب قانون الخصوصية.",
   "gdpr-compliance-title": "إفصاحات إضافية للامتثال للائحة العامة لحماية البيانات (GDPR) (الاتحاد الأوروبي)",
   "data-controller-processor-title": "جهة التحكم بالبيانات / جهة معالجة البيانات",
   "data-controller-processor-description-text": "تميّز اللائحة العامة لحماية البيانات (GDPR) بين المؤسسات التي تعالج المعلومات الشخصية لأغراضها الخاصة (يُشار إليها بـ\"جهات التحكم بالبيانات\") والمؤسسات التي تعالج المعلومات الشخصية نيابة عن مؤسسات أخرى (يُشار إليها بـ\"جهات معالجة البيانات\"). نحن، International Advisory, Products and Systems Ltd، الكائن مقرّنا في العنوان المذكور في قسم \"اتصل بنا\"، نُعد جهة تحكم بالبيانات و/أو جهة معالجة لها فيما يتعلق بالمعلومات الشخصية التي تقدمها لنا.",
   "legal-bases-title": "الأسس القانونية لمعالجة معلوماتك الشخصية",
   "legal-bases-description-text": "لن نقوم بجمع معلوماتك الشخصية واستخدامها إلا عندما يكون لدينا حق قانوني للقيام بذلك. وفي هذه الحالة، سنقوم بجمع معلوماتك الشخصية واستخدامها بشكل قانوني وعادل وشفاف. وإذا سعينا للحصول على موافقتك لمعالجة معلوماتك الشخصية، وكان عمرك أقل من 16 عامًا، فسنسعى للحصول على موافقة والدك أو ولي أمرك القانوني لمعالجة معلوماتك الشخصية لذلك الغرض المحدد.",
   "legal-bases-grounds-text": "تعتمد أسسنا القانونية على الخدمات التي تستخدمها وكيفية استخدامك لها. وهذا يعني أننا لا نقوم بجمع معلوماتك واستخدامها إلا استنادًا إلى الأسس التالية:",
   "consent-from-you-title": "الموافقة منك",
   "consent-from-you-description-text": "عندما تمنحنا موافقتك على جمع معلوماتك الشخصية واستخدامها لغرض محدد. يجوز لك سحب موافقتك في أي وقت باستخدام الوسائل التي نوفرها؛ غير أن ذلك لن يؤثر على أي استخدام لمعلوماتك يكون قد تم بالفعل. يجوز لك الموافقة على تقديم عنوان بريدك الإلكتروني بغرض تلقي رسائل تسويقية عبر البريد الإلكتروني منا. وفي حين يمكنك إلغاء الاشتراك في أي وقت، لا يمكننا استرجاع أي رسالة بريد إلكتروني سبق أن أرسلناها. وإذا كانت لديك أي استفسارات إضافية حول كيفية سحب موافقتك، فلا تتردد في الاستفسار باستخدام التفاصيل الواردة في قسم اتصل بنا من سياسة الخصوصية هذه.",
   "performance-of-contract-title": "تنفيذ عقد أو معاملة",
   "performance-of-contract-description-text": "عندما تكون قد أبرمت عقدًا أو معاملة معنا، أو من أجل اتخاذ خطوات تحضيرية قبل إبرامنا عقدًا أو معاملة معك. فعلى سبيل المثال، إذا اشتريت منتجًا أو خدمة أو اشتراكًا منا، فقد نحتاج إلى استخدام معلوماتك الشخصية ومعلومات الدفع الخاصة بك من أجل معالجة طلبك وتسليمه.",
   "legitimate-interests-title": "مصالحنا المشروعة",
   "legitimate-interests-description-text": "في الحالات التي نُقدّر فيها أن ذلك ضروري لمصالحنا المشروعة، كأن نقوم بتقديم خدماتنا وتشغيلها وتحسينها والتواصل بشأنها. ونعتبر أن مصالحنا المشروعة تشمل البحث والتطوير، وفهم جمهورنا، وتسويق خدماتنا والترويج لها، والتدابير المتخذة لتشغيل خدماتنا بكفاءة، وتحليل التسويق، والتدابير المتخذة لحماية حقوقنا ومصالحنا القانونية.",
   "compliance-with-law-title": "الامتثال للقانون",
   "compliance-with-law-description-text": "في بعض الحالات، قد يقع علينا التزام قانوني باستخدام معلوماتك الشخصية أو الاحتفاظ بها. وقد تشمل هذه الحالات على سبيل المثال لا الحصر أوامر المحاكم، والتحقيقات الجنائية، وطلبات الجهات الحكومية، والالتزامات التنظيمية. وإذا كانت لديك أي استفسارات إضافية حول كيفية احتفاظنا بالمعلومات الشخصية امتثالًا للقانون، فلا تتردد في الاستفسار باستخدام البيانات الواردة في قسم \"اتصل بنا\" من سياسة الخصوصية هذه.",
   "eea-transfers-title": "عمليات النقل الدولية خارج المنطقة الاقتصادية الأوروبية (EEA)",
   "eea-transfers-description-text": "سنحرص على أن يكون أي نقل للمعلومات الشخصية من دول المنطقة الاقتصادية الأوروبية (EEA) إلى دول خارج هذه المنطقة محميًا بضمانات مناسبة، وذلك على سبيل المثال من خلال استخدام البنود القياسية لحماية البيانات المعتمدة من المفوضية الأوروبية، أو استخدام القواعد المؤسسية الملزمة، أو غير ذلك من الوسائل المقبولة قانونًا.",
   "data-portability-text": "قابلية نقل البيانات: قد يحق لك طلب نسخة من المعلومات الشخصية التي نحتفظ بها عنك. وحيثما أمكن ذلك، سنقدم هذه المعلومات بصيغة CSV أو بأي صيغة أخرى يمكن قراءتها آليًا بسهولة. كما قد يحق لك أيضًا طلب أن نقوم بنقل هذه المعلومات الشخصية إلى طرف ثالث.",
   "deletion-rights-text": "الحذف: قد يحق لك أن تطلب منا حذف المعلومات الشخصية التي نحتفظ بها عنك في أي وقت، وسنتخذ خطوات معقولة لحذف معلوماتك الشخصية من سجلاتنا الحالية. وإذا طلبت منا حذف معلوماتك الشخصية، فسنُعلمك بكيفية تأثير هذا الحذف على استخدامك لمواقعنا الإلكترونية أو منتجاتنا وخدماتنا. وقد تكون هناك استثناءات لهذا الحق لأسباب قانونية محددة، سنوضحها لك، إن وجدت، ردًا على طلبك. وإذا قمت بإنهاء حسابك أو حذفه، فسنقوم بحذف معلوماتك الشخصية في غضون 45 يومًا من تاريخ حذف حسابك. يُرجى العلم أن محركات البحث والأطراف الثالثة المماثلة قد تحتفظ مع ذلك بنسخ من معلوماتك الشخصية التي تم نشرها علنًا ولو لمرة واحدة، مثل بعض معلومات الملف الشخصي والتعليقات العامة، حتى بعد قيامك بحذف هذه المعلومات من خدماتنا أو إلغاء تفعيل حسابك.",
   "objecting-to-processing-text": "الاعتراض على المعالجة: يحق لك الاعتراض على معالجة معلوماتك الشخصية عندما تستند تلك المعالجة إلى مصالحنا المشروعة أو إلى المصلحة العامة. وفي حال قيامك بذلك، يجب علينا تقديم أسباب مشروعة ومقنعة للمعالجة تتجاوز أهميتها مصالحك وحقوقك وحرياتك، حتى نتمكن من المضي قدمًا في معالجة معلوماتك الشخصية.",
   "restrict-processing-rights-text": "التقييد: يحق لك أن تطلب منا تقييد معالجة معلوماتك الشخصية إذا (أ) كنت قلقًا بشأن دقة معلوماتك الشخصية؛ أو (ب) كنت تعتقد أن معلوماتك الشخصية قد عولجت بصورة غير قانونية؛ أو (ج) كنت بحاجة إلى أن نحتفظ بالمعلومات الشخصية لغرض وحيد يتمثل في مطالبة قانونية؛ أو (د) كنا في معرض النظر في اعتراضك على المعالجة القائمة على أساس المصالح المشروعة.",
   "us-states-privacy-title": "إفصاحات إضافية للامتثال لقوانين الخصوصية في الولايات الأمريكية.",
   "us-states-privacy-description-text": "يتضمن القسم التالي أحكامًا تمتثل لقوانين الخصوصية في هذه الولايات (California وColorado وDelaware وFlorida وVirginia وUtah)، وهو لا ينطبق إلا على المقيمين في تلك الولايات. وأي إشارة محددة إلى ولاية معينة (سواء في عنوان أو في نص الوثيقة) لا تُعد سوى إشارة إلى قانون تلك الولاية، ولا تنطبق إلا على المقيمين في تلك الولاية. أما الصياغة غير المخصصة لولاية بعينها فتنطبق على جميع الولايات المذكورة أعلاه.",
   "do-not-track-title": "عدم التتبع",
   "do-not-track-description-text": "تحتوي بعض المتصفحات على ميزة \"عدم التتبع\" (Do Not Track) تتيح لك إبلاغ المواقع الإلكترونية بأنك لا ترغب في تتبع أنشطتك عبر الإنترنت. في الوقت الحالي، لا نستجيب لإشارات \"عدم التتبع\" الصادرة عن المتصفح.",
   "do-not-track-standards-text": "نحن نلتزم بالمعايير الموضحة في سياسة الخصوصية هذه، بما يضمن جمعنا ومعالجتنا للمعلومات الشخصية بشكل قانوني وعادل وشفاف، ولأسباب مشروعة وقانونية للقيام بذلك.",
   "cookies-and-pixels-title": "ملفات تعريف الارتباط وبكسلات التتبع",
   "cookies-and-pixels-description-text": "يمكنك في جميع الأوقات رفض ملفات تعريف الارتباط الخاصة بمواقعنا إذا كان متصفحك يسمح بذلك. تتيح معظم المتصفحات لك تفعيل إعدادات في متصفحك لرفض تعيين جميع ملفات تعريف الارتباط أو بعضها. وبناءً على ذلك، فإن قدرتك على الحد من ملفات تعريف الارتباط تعتمد فقط على إمكانيات متصفحك. يُرجى الرجوع إلى قسم ملفات تعريف الارتباط في سياسة الخصوصية هذه لمزيد من المعلومات.",
   "california-privacy-laws-title": "قوانين الخصوصية في California - CPPA",
   "california-privacy-financial-incentive-text": "بموجب المادة 1798.83 من القانون المدني لولاية California، إذا كنت مقيمًا في California وكانت علاقتك التجارية معنا تتعلق أساسًا بأغراض شخصية أو عائلية أو منزلية، يجوز لك أن تستفسر منا عن المعلومات التي نفصح عنها لمؤسسات أخرى لأغراضها التسويقية. وتماشيًا مع حقك في عدم التمييز، يجوز لنا أن نقدم لك حوافز مالية معينة يسمح بها كل من قانون California لخصوصية المستهلك وقانون California لحقوق الخصوصية (يُشار إليهما مجتمعين بـ CCPA)، والتي قد تؤدي إلى أسعار أو معدلات أو مستويات جودة مختلفة للسلع أو الخدمات التي نقدمها. وسيكون أي حافز مالي مسموح به بموجب CCPA نقدمه مرتبطًا بشكل معقول بقيمة معلوماتك الشخصية، وسنقدم شروطًا مكتوبة توضح بوضوح طبيعة هذا العرض. وتتطلب المشاركة في برنامج الحوافز المالية موافقتك المسبقة على الانضمام، والتي يجوز لك سحبها في أي وقت.",
   "california-privacy-request-info-text": "بموجب المادة 1798.83 من القانون المدني لولاية California، إذا كنت مقيمًا في California وكانت علاقتك التجارية معنا تتعلق أساسًا بأغراض شخصية أو عائلية أو منزلية، يجوز لك أن تستفسر منا عن المعلومات التي نفصح عنها لمؤسسات أخرى لأغراضها التسويقية. ولتقديم طلب من هذا النوع، يُرجى التواصل معنا باستخدام البيانات الواردة في سياسة الخصوصية هذه مع كتابة \"طلب معلومات الخصوصية الخاصة بـ California\" في عنوان الرسالة. ويجوز لك تقديم هذا النوع من الطلبات مرة واحدة كل سنة تقويمية. وسنرسل إليك عبر البريد الإلكتروني قائمة بفئات المعلومات الشخصية التي أفصحنا عنها لمؤسسات أخرى لأغراضها التسويقية خلال السنة التقويمية الأخيرة، مع أسمائها وعناوينها. ولا تشمل المادة 1798.83 من القانون المدني لولاية California جميع المعلومات الشخصية التي تتم مشاركتها بهذه الطريقة.",
   "california-notice-of-collection-title": "إشعار California بشأن جمع المعلومات",
   "california-notice-of-collection-intro-text": "خلال الاثني عشر شهرًا الماضية، قمنا بجمع الفئات التالية من المعلومات الشخصية المذكورة في CCPA:",
   "ccpa-identifiers-text": "المعرّفات، مثل الاسم، وعنوان البريد الإلكتروني، ورقم الهاتف، واسم الحساب، وعنوان IP، والمعرّف أو الرقم المخصص لحسابك.",
   "ccpa-customer-records-text": "سجلات العملاء، مثل عنوان الفوترة والشحن، وبيانات بطاقة الائتمان أو الخصم.",
   "ccpa-demographics-text": "البيانات الديموغرافية، مثل عمرك أو جنسك. تشمل هذه الفئة البيانات التي قد تُصنَّف على أنها فئات محمية بموجب قوانين أخرى في ولاية كاليفورنيا أو بموجب قوانين فيدرالية أخرى.",
   "ccpa-commercial-info-text": "المعلومات التجارية، مثل سجل المنتجات أو الخدمات والمشتريات.",
   "ccpa-internet-activity-text": "نشاط الإنترنت، مثل تفاعلاتك مع خدمتنا.",
   "ccpa-audio-visual-text": "البيانات السمعية أو المرئية، مثل الصور أو مقاطع الفيديو التي تشاركها معنا أو تنشرها على الخدمة.",
   "ccpa-geolocation-text": "بيانات تحديد الموقع الجغرافي.",
   "ccpa-employment-education-text": "بيانات التوظيف والتعليم، مثل البيانات التي تقدمها عند التقدم للحصول على وظيفة لدينا.",
   "ccpa-inferences-text": "استنتاجات، مثل المعلومات المتعلقة باهتماماتك وتفضيلاتك ومفضلاتك.",
   "california-notice-of-collection-outro-text": "لمزيد من المعلومات حول المعلومات التي نجمعها، بما في ذلك المصادر التي نتلقى منها هذه المعلومات، يُرجى مراجعة قسم \"المعلومات التي نجمعها\". نقوم بجمع واستخدام هذه الفئات من المعلومات الشخصية للأغراض التجارية الموضحة في قسم \"جمع المعلومات واستخدامها\"، بما في ذلك تقديم خدمتنا وإدارتها.",
   "right-to-know-delete-title": "الحق في المعرفة والحذف",
   "right-to-know-delete-intro-text": "لديك الحق في حذف المعلومات الشخصية التي جمعناها عنك، وفي معرفة معلومات معينة حول ممارساتنا المتعلقة بالبيانات خلال الاثني عشر (12) شهرًا الماضية. وعلى وجه الخصوص، يحق لك أن تطلب منا ما يلي:",
   "know-delete-categories-collected-text": "فئات المعلومات الشخصية التي جمعناها عنك؛",
   "know-delete-categories-sources-text": "فئات المصادر التي تم جمع المعلومات الشخصية منها؛",
   "know-delete-categories-disclosed-text": "فئات المعلومات الشخصية المتعلقة بك التي أفصحنا عنها لغرض تجاري أو التي قمنا ببيعها؛",
   "know-delete-third-parties-text": "فئات الأطراف الثالثة التي تم الإفصاح لها عن المعلومات الشخصية لغرض تجاري أو التي تم بيع المعلومات الشخصية لها؛",
   "know-delete-business-purpose-text": "الغرض التجاري أو غرض العمل من جمع المعلومات الشخصية أو بيعها؛ و",
   "know-delete-specific-pieces-text": "العناصر المحددة من المعلومات الشخصية التي قمنا بجمعها عنك.",
   "right-to-know-delete-outro-text": "لممارسة أي من هذه الحقوق، يُرجى التواصل معنا باستخدام التفاصيل المُقدَّمة في سياسة الخصوصية هذه.",
   "shine-the-light-title": "تسليط الضوء",
   "shine-the-light-description-text": "بالإضافة إلى الحقوق التي تمت مناقشتها أعلاه، يحق لك أن تطلب منا معلومات بشأن الطريقة التي نشارك بها بعض المعلومات الشخصية، على النحو المحدد بموجب القانون المعمول به، مع أطراف ثالثة وشركات تابعة لأغراض التسويق المباشر الخاصة بها.",
   "shine-the-light-request-text": "للحصول على هذه المعلومات، يرجى إرسال طلب إلينا باستخدام بيانات الاتصال المذكورة في سياسة الخصوصية هذه. يجب أن تتضمن الطلبات عبارة \"طلب حقوق الخصوصية\" في السطر الأول من الوصف، وأن تتضمن اسمك وعنوان الشارع والمدينة والولاية والرمز البريدي.",
   "contact-us-title": "اتصل بنا",
   "privacy-contact-us-description-text": "لأي أسئلة أو استفسارات بخصوص خصوصيتك، يمكنك الاتصال بنا باستخدام البيانات التالية:",
   "customer-service-label": "خدمة العملاء",

   // My Performance (Staff)
   "loading-ellipsis-text": "جارٍ التحميل...",
   "failed-to-load-modules-error": "فشل تحميل الوحدات",
   "failed-to-load-details-error": "فشل تحميل التفاصيل",
   "my-assessments-title": "تقييماتي",
   "my-assessments-description-text": "ابدأ باختيار تقييم لعرض وحداته ورؤى الأداء الخاصة به.",
   "no-assessments-yet-title": "يبدو أنه لا توجد تقييمات حتى الآن!",
   "no-assessments-yet-description-text":
      "عندما تتوفر نتائج للتقييمات، ستظهر هنا لاستكشافها.",
   "modules-in-assessment-label": "الوحدات في هذا التقييم:",
   "choose-module-to-see-results-text": "اختر وحدة لعرض النتائج",
   "status-closed-label": "مغلق",
   "select-module-alt-text": "اختر الوحدة",
   "select-module-results-text": "اختر وحدة من القائمة لعرض نتائجها",
   "target-label": "الهدف",
   "action-plan-label": "خطة العمل",
   "assessment-preview-title": "معاينة التقييم",
   "no-data-for-assessment-text": "لا تتوفر بيانات حاليًا لهذا التقييم",
   "my-upcoming-tasks-title": "مهامي القادمة",
   "my-improvement-over-time-title": "تحسني على مر الزمن",
   "no-data-for-survey-text": "لا تتوفر بيانات حاليًا لهذا الاستطلاع",
   "your-score-label": "درجتك",
   "target-score-label": "الدرجة المستهدفة",
   "previous-label": "السابق",
   "next-label": "التالي",

   // Task Management (Staff)
   "task-management-title": "إدارة المهام",
   "tasks-tab-label": "المهام",
   "assigned-modules-title": "الوحدات المسندة",
   "collapse-all-button": "طي الكل",
   "expand-all-button": "توسيع الكل",
   "assigned-tasks-title": "المهام المسندة",
   "board-tab-label": "اللوحة",
   "timeline-tab-label": "الجدول الزمني",
   "no-available-modules-text": "لا توجد وحدات متاحة لهذا التقييم",
   "no-available-tasks-text": "لا توجد مهام متاحة لهذا التقييم",
   "go-alt-text": "الانتقال",
   "view-alt-text": "عرض",
   "notes-alt-text": "ملاحظات",
   "change-status-to-label": "تغيير الحالة إلى:",
   "priority-low-label": "منخفضة",
   "priority-medium-label": "متوسطة",
   "priority-high-label": "عالية",
   "priority-urgent-label": "عاجلة",
   "show-less-link": "عرض أقل",
   "monthly-toggle-label": "شهري",
   "quarterly-toggle-label": "ربع سنوي",
   "week-prefix-text": "الأسبوع",
   "to-do-status": "قيد الانتظار",
   "tasks-column-header": "المهام",
   "linked-questions-prefix-text": "الأسئلة المرتبطة:",
   "assigned-status": "مسند",
   "action-plan-dashboard-title": "لوحة خطة العمل",
   "action-plan-for-label": "خطة العمل لـ",

   "role-vendor-label": "مورّد",
   "switch-role-label": "تبديل الدور",
   "current-role-label": "الدور الحالي",
   "switch-role-error-description": "تعذّر تبديل الدور، يرجى المحاولة مرة أخرى.",
   "approver-role-added-to-existing-user-description":
      "هذا المستخدم لديه حساب بالفعل، لذلك لم يتم إرسال رسالة دعوة. يسجّل الدخول بكلمة المرور الحالية ثم ينتقل إلى دور المعتمد.",

   // Dual role (Expert + Approver on the same account)
   "expert-role-column": "خبير",
   "expert-role-enabled-success-title": "تمت إضافة دور الخبير",
   "expert-role-enabled-success-description": "يمكن لهذا المعتمد الآن العمل كخبير أيضًا.",
   "expert-role-disabled-success-title": "تمت إزالة دور الخبير",
   "expert-role-disabled-success-description": "لم يعد هذا المعتمد يملك دور الخبير.",
   "expert-role-toggle-error-description": "تعذّر تحديث دور الخبير، يرجى المحاولة مرة أخرى.",
   "expert-role-not-found-description": "لم يعد هذا المعتمد موجودًا. تم تحديث القائمة.",
   "approver-role-column": "معتمد",
   "approver-role-enabled-success-title": "تمت إضافة دور المعتمد",
   "approver-role-enabled-success-description": "يمكن لهذا الخبير الآن العمل كمعتمد أيضًا.",
   "approver-role-disabled-success-title": "تمت إزالة دور المعتمد",
   "approver-role-disabled-success-description": "لم يعد هذا الخبير يملك دور المعتمد.",
   "approver-role-toggle-error-description": "تعذّر تحديث دور المعتمد، يرجى المحاولة مرة أخرى.",
   "approver-role-not-found-description": "لم يعد هذا الخبير موجودًا. تم تحديث القائمة.",
   "expert-exists-redirect-title": "خبير بالفعل",
   "expert-exists-redirect-description":
      "هذا البريد الإلكتروني يخص خبيرًا بالفعل. سننقلك إلى قائمة الخبراء حيث يمكنك منحه دور المعتمد بدلاً من ذلك.",

   "linked-assessment-edit-notice":
      "هذا التقييم مرتبط بتقييم آخر، لذلك يمكن إضافة جولات جديدة فقط. كل جولة تضيفها هنا تُضاف أيضًا إلى التقييم المرتبط.",
   "start-date-in-past-validation": "لا يمكن أن يكون تاريخ البدء في الماضي.",
   "end-date-must-be-future-validation": "يجب أن يكون تاريخ الانتهاء في المستقبل.",
   "round-overlaps-another-round-validation": "تتداخل هذه الجولة مع جولة أخرى.",
   "view-all-notifications-button": "عرض كل الإشعارات",
   "notifications-page-title": "الإشعارات",
   "notifications-empty-title": "لا توجد إشعارات بعد",
   "notifications-unread-empty-title": "لا توجد إشعارات غير مقروءة",
   "notifications-empty-text": "لقد اطلعت على كل شيء. ستظهر الإشعارات الجديدة هنا.",
   "guided-assessment-completed-prefix-text": "تقييمك الموجّه",
   "guided-assessment-completed-suffix-text": "قد اكتمل.",
   "notification-title-org-signup": "تسجيل منظمة جديدة",
   "notification-title-expert-signup": "تسجيل خبير جديد",
   "notification-title-workspace-join-request": "طلب منظمة للانضمام إلى مساحة العمل",
   "notification-title-workspace-approved": "تمت الموافقة على طلب مساحة العمل",
   "notification-title-workspace-rejected": "تم رفض طلب مساحة العمل",
   "notification-title-guided-request": "طلب تقييم موجّه",
   "notification-title-guided-approved": "تمت الموافقة على طلب التقييم الموجّه",
   "notification-title-guided-rejected": "تم رفض طلب التقييم الموجّه",
   "notification-title-guided-completed": "اكتمل التقييم الموجّه",
   "notification-title-self-assigned": "تم تعيين تقييم ذاتي جديد",
   "notification-title-self-unassigned": "تم إلغاء تعيين التقييم الذاتي",
   "notification-title-expert-assigned": "تم التعيين في تقييم موجّه",
   "notification-title-ticket-created": "تم إنشاء تذكرة جديدة",
   "notification-title-ticket-updated": "تم تحديث التذكرة",
   "notification-title-submission-review": "التقديم جاهز للمراجعة",
   "notification-title-submission-approved-by-approver": "وافق المعتمِد على التقديم",
   "notification-title-submission-rejected-by-approver": "رفض المعتمِد التقديم",
   "notification-title-module-assigned": "تم تعيين وحدة جديدة",
   "notification-title-module-unassigned": "تم إلغاء تعيين الوحدة",
   "notification-title-submission-approved": "تمت الموافقة على التقديم",
   "notification-title-submission-rejected": "تم رفض التقديم",
   "notification-title-submission-approval": "التقديم جاهز للاعتماد",
   "mark-as-read-label": "تحديد كمقروء",
   "notification-actions-label": "إجراءات الإشعار"
};
